import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import DatalabelsPlugin from 'chartjs-plugin-datalabels';
import {
  Chart,
  ChartConfiguration,
  ChartData,
  ChartEvent,
  ChartOptions,
  ChartType,
  ChartTypeRegistry,
  registerables,
  ChartDataset
} from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { ChartsService } from 'src/app/core/services/charts.service';
import {
  ActiveSessionsByProfile,
  CoreHoursByGroups,
  CoreHoursByUsers,
  CoresByApplicationI,
  CoreUsage,
  Dictionary,
  DynamicControl,
  JobByApplicationGraphDataI,
  JobByApplicationI,
  JobByApplicationsPerDayI,
  JobByGroupI,
  JobByNodesI,
  JobByTagsI,
  JobByTagsPerDayI,
  JobByUserI,
  JobsByUserByDay,
  JobWaitTimeI,
  LicenseUsage,
  NodeAvailabilityI,
  NodeUsage,
  PrimeNonPrimCoresDataI,
  PrimeNonPrimeHoursJobs,
  RunningQueuedJobsPerNodeGroup,
  StorageUsage,
} from 'src/app/core/models/charts';
import { DatePipe, formatDate } from '@angular/common';
import { UntypedFormGroup, UntypedFormControl, FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { Job, JobCountData } from 'src/app/core/models/job';
import { Granularity, GraphDataGranularity, Graphs } from 'src/app/core/models/globals';
import { ActionLogService } from 'src/app/core/services/action-log.service';
import { UserService } from 'src/app/core/services/user.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { lastValueFrom, Subject, Subscription } from 'rxjs';
import { Application } from 'src/app/core/models/application';
import { JobsService } from 'src/app/core/services/jobs.service';
import { MatDialog } from '@angular/material/dialog';
import { JobInfoDownloadComponent } from '../../modals/job-info-download/job-info-download.component';
import { saveAs } from 'file-saver';
import { MakeUpperPipe } from 'src/app/core/pipes/make-upper.pipe';
import { MatSnackBar } from '@angular/material/snack-bar';
import Annotation from 'chartjs-plugin-annotation';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { NodeService } from '../../../../core/services/node.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NodeStartStopStatus, Session, SessionInfo, SessionLogPerUser } from '../../../../core/models/session';
import { SessionService } from '../../../../core/services/session.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { HeaderService } from '../../../../core/services/header.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { QuickAccessControl } from 'src/app/core/models/quickAccessControl';
import { UserRolesInt } from 'src/app/core/models/users';

@Component({
  selector: 'app-deployment-graphs',
  templateUrl: './deployment-graphs.component.html',
  styleUrls: ['./deployment-graphs.component.scss'],
})
export class DeploymentGraphsComponent implements OnInit {

  dateTimePeriod = new FormControl();
  showDateRangePicker: boolean = false;
  deployments: string[] = [];
  depName = "";
  jobs: Job[];
  storageData: StorageUsage[] = [];
  coresData: CoreUsage[] = [];
  licenseUsage: LicenseUsage[] = [];
  availableGranularity = ['One Hour', 'One Day', 'One Week', 'One Month'];
  availableGranularityCopy = [];
  allChartsData: any = [];
  loggedInUser: string;
  succeededJobs: number = 0;
  failedJobs: number = 0;
  cancelledJobs: number = 0;
  totalJobsCompleted: number = 0;
  queuedJobs: number = 0;
  runningJobs: number = 0;
  completedJobs: number = 0;
  submittedJobs: number = 0;
  totalJobSummary: number = 0;
  userFilterFlag: boolean = true;
  userFilterValue = "none";
  wsValue = "none";
  selectedMetric = 'all';
  dateFilterValue = '7 days';
  granularityValue = "One Day";
  selectedUser = 'all';

  currentDay = this.headerService.getUserNewDate();
  prevDate = new Date(new Date().setFullYear(this.currentDay.getFullYear() - 1));

  appNames: string[] = [];
  nodeUtilization: NodeUsage[] = [];
  sessinfoPerUser: SessionLogPerUser[] = [];
  SingleNodeUtilizationValue: boolean = false;
  wsNames: string[] = [];
  graphStartEnd: any[] = [];
  graphOption: any[] = [];
  graphConnDiscon: any = [];
  type = 'Timeline';
  colNames: Array<any> = ['Date', 'Node', 'Start', 'End'];
  width: string = '80%';
  chartWidth: string;
  chartHeight: string;
  showFilters: boolean = false;
  metricValue: string = 'All Charts';
  userValue: string = '';
  wsNameValue: string = '';
  date: Date = this.headerService.getUserNewDate();
  currentDate: string = this.headerService.getUserNewDate().toISOString();
  daysValue: string = '';
  downloadingPdf: boolean = false;
  graphRequests = {};
  public cpuGaugeValue = 95;
  gpuMemoryGaugeLabel = 'GPU Memory';
  dataReloadSubscription: Subscription; // subscription for reloading/ refreshing data every 10seconds
  userSelected: string = "all";
  appSelected: string = "all";
  disableApplyFilter: boolean = false;

  showJobData: boolean = false;
  MonthShort: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  lineChartLegend = true;
  realRunningCores = [];
  realQueuedCores = [];
  realActiveCores = [];
  availableChartTypes = [];
  userNames: { item_id: string, item_text: string }[] = [];
  userNamesForSessionGraph: string[] = [];
  userGroupNames: { item_id: string, item_text: string }[] = [];
  jobTags: { item_id: string, item_text: string }[] = [];
  coreHourUserNames: { item_id: string, item_text: string }[] = [];
  dropdownList = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  coreHoursDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    limitSelection: -1
  };
  selectedItems = [];
  graphFilterForm: FormGroup;
  graphDataLabelsForm: FormGroup;
  tagNames: any = null;
  isVdi: boolean = false;
  redirectSortVal: string | null;
  todayDate = new Date();
  activeChartType = "bar";
  differenceInDays;
  showOnlyMachineName = false;
  showOnlyDuration = false;
  showBothMachineAndTime = true;
  showUserNameAndTotalHours = true;
  nodeStatusList: NodeStartStopStatus[] = [];
  selectedJobTags: { item_id: string; item_text: string }[] = [];
  selectedJobTag: string = null;
  activeSessionsPerDepData: ActiveSessionsByProfile[];
  predefinedDatasets = [
    {
      data: [],
      label: '',
      backgroundColor: 'rgba(255, 161, 181,0.2)',
      borderColor: 'red',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
      pointHoverBorderColor: '#fff',
      fill: 'origin'
    },
    {
      data: [],
      label: '',
      backgroundColor: 'rgba(0, 255, 0, 0.2)',
      borderColor: 'green',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)',
      fill: 'origin'
    },
    {
      data: [],
      label: '',
      backgroundColor: 'rgba(255,225,153,0.2)',
      borderColor: 'gold',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)',
      fill: 'origin'
    },
    {
      data: [],
      label: '',
      backgroundColor: 'rgba(134,199,243,0.2)',
      borderColor: 'blue',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)',
      fill: 'origin'
    },
  ]
  chartNameLegend: string = null;
  applicationNames = [];

  //#region [chart variable declarations]

  //#region [jobs summary start]
  allJobsOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job Status Summary - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: 'top',
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.allJobsData.datasets[0].data);
        },
      },
    },
  };
  allJobsData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  allJobsType: ChartType = 'pie';
  allJobsLegend = true;
  allJobsPlugins = [DatalabelsPlugin]; //ChartDataLabels
  allJobsColors = [
    {
      backgroundColor: [
        'rgb(255, 161, 161)',
        'rgb(252, 180, 65)',
        'rgb(255, 255, 184)',
      ],
    },
  ];

  //#endregion

  //#region [job summary start]
  jobsSummaryOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: 'Jobs Completed : ' + this.completedJobs + ` Jobs - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: 'top',
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.jobsSummaryData.datasets[0].data);
        },
      },
    },
  };
  jobsSummaryData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  jobsSummaryType: ChartType = 'pie';
  jobsSummaryLegend = true;
  jobsSummaryPlugins = [DatalabelsPlugin];
  jobsSummaryColors = [
    {
      backgroundColor: [
        'rgb(255, 161, 161)',
        'rgb(252, 180, 65)',
        'rgb(255, 255, 184)',
      ],
    },
  ];

  //#endregion

  //#region [cores per day start]
  coresPerDayOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Average Cores"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },

      title: {
        display: true,
        text: `Average Core Usage - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: 'top',
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.coresPerDayData.datasets[0].data);
        },
      },
    },
  };
  coresPerDayType: ChartType = 'line';
  coresPerDayLegend = true;
  coresPerDayPlugins = [DatalabelsPlugin];
  coresPerDayData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Queued",
        backgroundColor: '#3498db',
        borderColor: 'transparent',
        pointBackgroundColor: '#3498db',
        pointBorderColor: '#3498db',
        order: 1
      },
      {
        data: [],
        label: "Running",
        backgroundColor: '#2ecc71',
        borderColor: 'transparent',
        pointBackgroundColor: '#2ecc71',
        pointBorderColor: '#2ecc71',
        fill: 'origin'
      },
      {
        data: [],
        label: "Average Running Cores",
        fill: false,
        borderColor: 'grey',
        backgroundColor: "grey",
        pointBackgroundColor: "grey",
        pointBorderColor: "grey",
        pointHoverBackgroundColor: "grey",
        pointHoverBorderColor: "grey",
        borderDash: [24, 12],
        radius: 0
      },
      {
        data: [],
        label: "Active Cores",
        fill: false,
        backgroundColor: "red",
        borderColor: "red",
        pointBackgroundColor: "red",
        pointBorderColor: "red",
        pointHoverBackgroundColor: "red",
        pointHoverBorderColor: "red",
        radius: 0,
        tension: 0
      },
      { data: [], label: "Median", fill: false, borderColor: "#7A9D54", borderDash: [8, 10], radius: 0 },
    ],
  };

  //#endregion

  //#region [Job By Applications]
  jobByApplicationOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Applications"
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Number Of Jobs"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: `Job By Application - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    }, elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobByApplicationType: ChartType = 'bar';
  jobByApplicationData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Succeeded",
        backgroundColor: '#95cd41',
        borderColor: '#95cd41',
        pointBackgroundColor: '#3498db',
        pointBorderColor: '#3498db',
        hoverBackgroundColor: "#95cd41",
        order: 1,
        stack: "a"
      },
      {
        data: [],
        label: "Cancelled",
        backgroundColor: '#f6d860',
        borderColor: '#f6d860',
        pointBackgroundColor: '#2ecc71',
        pointBorderColor: '#2ecc71',
        hoverBackgroundColor: "#f6d860",
        fill: 'origin',
        stack: "a"
      },
      {
        data: [],
        label: "Failed",
        fill: false,
        borderColor: "#ff4646",
        backgroundColor: "#ff4646",
        hoverBackgroundColor: "#ff4646",
        borderDash: [5, 3],
        radius: 0,
        stack: "a"
      }
    ],
  };
  jobByApplicationPlugins = [DatalabelsPlugin];
  jobByApplicationsPerDayChartData: ChartConfiguration["data"] = {
    datasets: [
    ],
    labels: [],
  };
  jobByApplicationDataTemp: ChartConfiguration["data"] = {
    datasets: [
    ],
    labels: [],
  };
  //#endregion

  //#region [Job By Nodes]
  jobByNodesOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {},
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of Jobs"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: `Job By Nodes - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.jobByNodesData.datasets[0].data);
        },
      },
    }, elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobByNodesType: ChartType = 'bar';
  jobByNodesData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Succeeded",
        backgroundColor: '#95cd41',
        borderColor: '#95cd41',
        pointBackgroundColor: '#3498db',
        pointBorderColor: '#3498db',
        hoverBackgroundColor: "#95cd41",
        order: 1,
        stack: "a"
      },
      {
        data: [],
        label: "Cancelled",
        backgroundColor: '#f6d860',
        borderColor: '#f6d860',
        pointBackgroundColor: '#2ecc71',
        pointBorderColor: '#2ecc71',
        hoverBackgroundColor: "#f6d860",
        fill: 'origin',
        stack: "a"
      },
      {
        data: [],
        label: "Failed",
        fill: false,
        borderColor: "#ff4646",
        backgroundColor: "#ff4646",
        hoverBackgroundColor: "#ff4646",
        borderDash: [5, 3],
        radius: 0,
        stack: "a"
      }
    ],
  };
  jobByNodesPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Job chart by tags]
  jobByTagsOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Tags"
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of Jobs"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: `Job By Tags - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.jobByTagsData.datasets[0].data);
        },
      },
    }, elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobByTagsType: ChartType = 'bar';
  jobByTagsData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Succeeded",
        backgroundColor: '#95cd41',
        borderColor: '#95cd41',
        pointBackgroundColor: '#3498db',
        pointBorderColor: '#3498db',
        hoverBackgroundColor: "#95cd41",
        order: 1,
        stack: "a"
      },
      {
        data: [],
        label: "Cancelled",
        backgroundColor: '#f6d860',
        borderColor: '#f6d860',
        pointBackgroundColor: '#2ecc71',
        pointBorderColor: '#2ecc71',
        hoverBackgroundColor: "#f6d860",
        fill: 'origin',
        stack: "a"
      },
      {
        data: [],
        label: "Failed",
        fill: false,
        borderColor: "#ff4646",
        backgroundColor: "#ff4646",
        hoverBackgroundColor: "#ff4646",
        borderDash: [5, 3],
        radius: 0,
        stack: "a"
      }
    ],
  };
  jobByTagsPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [storage chart]
  storageChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        title: {
          display: true,
          text: "Date"
        }
      },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        min: 0,
        title: {
          display: true,
          text: 'Usage in GB'
        }
      },
    },
    plugins: {
      datalabels: {
        align: 'bottom',
        font: {
          weight: 'bold'
        },
        clamp: true, // Prevent labels from overflowing outside the chart area
        display: (context) => {
          if (this.selectedMetric == "Overview") return false;
          if (this.graphDataLabelsForm.get('storageUsage').value === false) {
            return false;
          }
          return +context.dataset.data[context.dataIndex] > 0
        }
      },
    }
  };
  storageChartType: ChartType = 'line';
  storageChartLegend = false;
  storageChartPlugins = [DatalabelsPlugin];
  storageChartData: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'Storage',
        backgroundColor: 'rgba(255,0,0,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
      },
    ],
  };
  //#endregion

  //#region [node utilization]
  nodeUtilizationOptionsTotal: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
      },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        max: 100,
        min: 0,
        title: {
          display: true,
          text: 'Usage (%)'
        }
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: 'Node Utilization (24 Hours)',
        position: 'top',
      },
      datalabels: {
        display: false,
      },
    },
  };
  nodeUtilizationOptionsTotalOffice: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
      },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        max: 100,
        min: 0,
        title: {
          display: true,
          text: 'Usage (%)'
        }
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: 'Node Utilization (Office Hours)',
        position: 'top',
      },
      datalabels: {
        display: false,
      },
    },
  };
  nodeUtilizationOptionsNonOffice: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
      },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        max: 100,
        min: 0,
        title: {
          display: true,
          text: 'Usage (%)'
        }
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Node Utilization (Non-Office Hours)`,
        position: 'top',
      },
      datalabels: {
        display: false,
      },
    },
  };
  nodeUtilizationType: ChartType = 'line';
  nodeUtilizationDataTotal: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'CPU',
        backgroundColor: 'rgba(255, 161, 181,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointHoverBorderColor: '#fff',
        fill: 'origin',
      },
      {
        data: [],
        label: 'RAM',
        backgroundColor: 'rgba(0, 255, 0, 0.3)',
        borderColor: 'green',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(77,83,96,1)',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU',
        backgroundColor: 'rgba(255,225,153,0.3)',
        borderColor: 'gold',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU RAM',
        backgroundColor: 'rgba(134,199,243,0.3)',
        borderColor: 'blue',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
    ],
    labels: [],
  };
  nodeUtilizationDataOffice: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'CPU',
        backgroundColor: 'rgba(255, 161, 181,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointHoverBorderColor: '#fff',
        fill: 'origin',
      },
      {
        data: [],
        label: 'RAM',
        backgroundColor: 'rgba(0, 255, 0, 0.3)',
        borderColor: 'green',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(77,83,96,1)',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU',
        backgroundColor: 'rgba(255,225,153,0.3)',
        borderColor: 'gold',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU RAM',
        backgroundColor: 'rgba(134,199,243,0.3)',
        borderColor: 'blue',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
    ],
    labels: [],
  };
  nodeUtilizationDataNonOffice: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'CPU',
        backgroundColor: 'rgba(255, 161, 181,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.3)',
        pointHoverBorderColor: '#fff',
        fill: 'origin',
      },
      {
        data: [],
        label: 'RAM',
        backgroundColor: 'rgba(0, 255, 0, 0.3)',
        borderColor: 'green',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(77,83,96,1)',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU',
        backgroundColor: 'rgba(255,225,153,0.3)',
        borderColor: 'gold',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
      {
        data: [],
        label: 'GPU RAM',
        backgroundColor: 'rgba(134,199,243,0.3)',
        borderColor: 'blue',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
    ],
    labels: [],
  };
  //#endregion

  //#region [JobCount chart]
  jobCountChartOptions: ChartConfiguration['options'] = {
    responsive: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        ticks: {},
        title: {
          display: true,
          text: "Number Of Jobs"
        }
      }
    },
    plugins: {
      datalabels: {
        align: 'top',
        font: {
          weight: 'bold'
        },
        clamp: true, // Prevent labels from overflowing outside the chart area
        display: (context) => {
          if (this.selectedMetric == "Overview") return false;
          if (context.dataset.label === "Average Job Count" || context.dataset.label === "Median Job Count") {
            return false;
          }
          else if (context.dataset.label === "Job Submitted" && this.graphDataLabelsForm.get('jobCountSubmitted').value === false) {
            return false;
          }
          else if (context.dataset.label === "Succeeded" && this.graphDataLabelsForm.get('jobCountSucceeded').value === false) {
            return false;
          }
          else if (context.dataset.label === "Failed" && this.graphDataLabelsForm.get('jobCountFailed').value === false) {
            return false;
          }
          else if (context.dataset.label === "Cancelled" && this.graphDataLabelsForm.get('jobCountCancelled').value === false) {
            return false;
          }
          return +context.dataset.data[context.dataIndex] > 0
        },
        formatter: Math.round
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: `Job Submit count - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
    },
  };
  jobCountChartType: ChartType = "line";
  jobCountChartLegend = false;
  jobCountChartPlugins = [DatalabelsPlugin];
  jobCountChartData: ChartConfiguration['data'] = {
    datasets: [
      { data: [], label: "Job Submitted", order: 1, pointBackgroundColor: "#1f77b4", pointBorderColor: "#1f77b4", fill: false, borderColor: "#bcd7e8", radius: 3 },
      { data: [], label: "Succeeded", order: 1, pointBackgroundColor: "#FFB84C", pointBorderColor: "#FFB84C", fill: false, borderColor: "#FFB84C", radius: 3 },
      { data: [], label: "Failed", order: 1, pointBackgroundColor: "#F16767", pointBorderColor: "#F16767", fill: false, borderColor: "#F16767", radius: 3 },
      { data: [], label: "Cancelled", order: 1, pointBackgroundColor: "#A459D1", pointBorderColor: "#A459D1", fill: false, borderColor: "#A459D1", radius: 3 },
      { data: [], label: "Average Job Count", fill: false, pointBackgroundColor: '#557A46', borderColor: "#557A46", borderDash: [8, 10], radius: 0 },
      { data: [], label: "Median Job Count", fill: false, pointBackgroundColor: '#7A9D54', borderColor: "#7A9D54", borderDash: [8, 10], radius: 0 },
    ], labels: []
  };
  //#endregion

  //#region [Job Wait Time Chart]
  jobWaitTimeChartOptions: ChartOptions = {
    responsive: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job Avg Wait Time ( In Mins ) - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.jobWaitTimeChartData.datasets[0].data);
        },
      },
    }
  };
  jobWaitTimeChartType: ChartType = "doughnut";
  jobWaitTimeChartData: ChartData<'doughnut'> = {
    labels: [],
    datasets: [
      { data: [] }
    ]
  };
  jobWaitTimeChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Node Avaiilability Chart]
  nodeAvailabilityChartOptions: ChartOptions = {
    responsive: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        title: {
          display: true,
          text: "Number Of Nodes"
        }
      }
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: true
        },
      },
      title: {
        display: true,
        text: `Node Availability - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        align: 'top',
        anchor: 'end',
        font: {
          weight: 'bold'
        },
        formatter: Math.round,
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.nodeAvailabilityData.datasets[0].data);
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  nodeAvailabilityType: ChartType = "line";
  nodeAvailabilityLegend = true;
  nodeAvailabilityData: ChartData<'line'> = {
    datasets: [
      {
        data: [],
        label: "Busy",
        order: 1,
        backgroundColor: '#E8751A',
        borderColor: 'orange',
        pointBackgroundColor: '#E8751A',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#E8751A',
        pointHoverBorderColor: '#fff',
        fill: false
      },
      {
        data: [],
        label: "Available",
        order: 1,
        backgroundColor: '#76885B',
        borderColor: '#76885B',
        pointBackgroundColor: '#76885B',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#76885B',
        pointHoverBorderColor: '#fff',
        fill: false
      },
      {
        data: [],
        label: "Unavailable",
        order: 1,
        backgroundColor: '#E72929',
        borderColor: 'red',
        pointBackgroundColor: '#E72929',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#E72929',
        pointHoverBorderColor: '#fff',
        fill: false
      },
      // { data: [], label: "Nodes Average", fill: false, borderColor: "grey", borderDash: [10,4], radius: 0 },
    ],
    labels: []
  }
  nodeAvailabilityPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Job By User Chart]
  jobByUserChartOptions: ChartOptions = {
    responsive: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Users"
        }
      },
      y: {
        title: {
          display: true,
          text: "Number of Jobs"
        }
      }
    },
    plugins: {
      legend: {
        display: false,
        position: "right",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job By Users - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.jobByUserChartData.datasets[0].data);
        },
      },
    }
  };
  jobByUserChartType: ChartType = "bar";
  jobByUserChartData: ChartData<'bar'> = {
    datasets: [
      { data: [], label: "Succeeded", borderColor: '#95cd41', backgroundColor: '#95cd41', hoverBackgroundColor: '#95cd41', stack: "a" },
      { data: [], label: "Cancelled", borderColor: '#f6d860', backgroundColor: '#f6d860', hoverBackgroundColor: '#f6d860', stack: "a" },
      { data: [], label: "Failed", borderColor: '#ff4646', backgroundColor: '#ff4646', hoverBackgroundColor: '#ff4646', stack: "a" },
    ],
    labels: []
  }
  jobByUserChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Job By Group Chart]
  jobByGroupChartOptions: ChartOptions = {
    responsive: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job By Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.jobByGroupChartData.datasets[0].data);
        },
      },
    }
  };
  jobByGroupChartType: ChartType = "doughnut";
  jobByGroupChartData: ChartData<'doughnut'> = {
    datasets: [{ data: [] }],
    labels: []
  }
  jobByGroupChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Cores BY Application]
  coresByApplicationChartOptions: ChartOptions = {
    responsive: false,
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        title: {
          display: true,
          text: "Applications"
        }
      },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        min: 0,
        title: {
          display: true,
          text: 'Core Usage'
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Cores By Application - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        align: 'top',
        font: {
          weight: 'bold'
        },
        clamp: true, // Prevent labels from overflowing outside the chart area
        display: (context) => {
          if (this.graphDataLabelsForm.get('coresByApplication').value === false) {
            return false;
          }
          return +context.dataset.data[context.dataIndex] > 0
        },
        formatter: Math.round
      }
    },
  };
  coresByApplicationChartType: ChartType = "bar";
  coresByApplicationChartData: ChartData<'bar'> = {
    datasets: [
      { data: [], label: "Cores", borderColor: '#95cd41', backgroundColor: '#95cd41', hoverBackgroundColor: '#95cd41', stack: "a" },
    ],
    labels: []
  }
  coresByApplicationChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Core Hours By Users]
  coreHoursByUsersChartOptions: ChartOptions = {
    responsive: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Users"
        }
      },
      y: {
        title: {
          display: true,
          text: "Core Hours"
        }
      }
    },
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Core Hours By Users - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        color: "white",
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.coreHoursByUsersChartData.datasets[0].data);
        },
      },
    }
  };
  coreHoursByUsersChartType: ChartType = "bar";
  coreHoursByUsersChartData: ChartData<'bar'> = {
    datasets: [
      { data: [], label: "Cores", backgroundColor: [], hoverBackgroundColor: [], borderColor: [] },
    ],
    labels: []
  }
  coreHoursByUsersChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Core Hours BY Users Pie]
  coreHoursByUsersPieOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job Status Summary - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: 'top',
        padding: 30
      },
      datalabels: {
        color: "black",
        display: true,
        //anchor: 'end', // Position of the data labels. 'start', 'center', or 'end'
        //align: 'end', // Alignment of the data labels. 'start', 'center', or 'end'
        //offset: 0, // Adjust the position of the data labels from the chart
        font: {
          weight: 'bold' // Optional, change the font weight of the data labels
        },
      },
    },
  };
  coreHoursByUsersPieData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  coreHoursByUsersPieType: ChartType = 'pie';
  coreHoursByUsersPieLegend = true;
  coreHoursByUsersPiePlugins = [DatalabelsPlugin]; //ChartDataLabels
  coreHoursByUsersPieColors = [
    {
      backgroundColor: [],
    },
  ];
  //#endregion

  //#region [core hours bar chart]
  coreHoursByGroupsChartOptions: ChartConfiguration['options'] = {
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        labels: {
          boxWidth: 15
        },
      },
      title: {
        display: true,
        text: `Core Hours By Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        color: "white",
        display: (context) => {
          const threshold = this.getDataLabelUsableValue(this.coreHoursByGroupsChartData[0].data);
          return +context.dataset.data[context.dataIndex] > threshold;
        },
        formatter: Math.round,
      },
    },
    responsive: false,
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        title: {
          display: true,
          text: "User Groups"
        }
      },
      y: {
        ticks: {},
        title: {
          display: true,
          text: 'Core Hours'
        }
      }
    }
  };
  coreHoursByGroupsChartType: ChartType = "bar";
  coreHoursByGroupsChartLegend = true;
  coreHoursByGroupsChartPlugins = [DatalabelsPlugin];
  coreHoursByGroupsChartData: ChartData<'bar'> = {
    datasets: [
      { data: [], label: "Cores", backgroundColor: [], hoverBackgroundColor: [], borderColor: [] },
    ],
    labels: []
  }
  //#endregion

  //#region [core hours pie chart]
  coreHoursByGroupsPieOptions: ChartConfiguration['options'] = {
    responsive: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Core Hour By Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
        padding: 30
      },
      datalabels: {
        color: "black",
        display: true,
        font: {
          weight: 'bold' // Optional, change the font weight of the data labels
        },
      },
    },
  }
  coreHoursByGroupsPieData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  coreHoursByGroupsPieType: ChartType = "pie";
  coreHoursByGroupsPieLegend = true;
  coreHoursByGroupsPiePlugins = [DatalabelsPlugin];
  coreHoursByGroupsPieColors = [
    {
      backgroundColor: [],
    },
  ];
  //#endregion

  //#region [Prime Core Usage]
  primeCoreUsageChartOptions: ChartOptions = {
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        title: {
          display: true,
          text: "Average Cores"
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          boxWidth: 10,
        },
      },
      title: {
        display: true,
        text: `Prime - Avg Used and Queued Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.primeCoreUsageChartData.datasets[0].data);
        },
        font: {
          size: 10
        }
      },
    },
    responsive: false,
  };
  primeCoreUsageChartType: ChartType = "bar";
  primeCoreUsageChartLegend = true;
  primeCoreUsageChartData: ChartData<'bar'> = {
    datasets: [
      { data: [], label: 'Used', backgroundColor: [], hoverBackgroundColor: [], borderColor: [], hoverBorderColor: [], stack: "a" },
      { data: [], label: 'Queued', backgroundColor: [], hoverBackgroundColor: [], borderColor: [], hoverBorderColor: [], stack: "a" }
    ],
    labels: []
  }
  primeCoreUsageChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Non Prime Core Usage]
  nonPrimeCoreUsageChartOptions: ChartOptions = {
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        title: {
          display: true,
          text: "Average Cores"
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          boxWidth: 10,
        },
      },
      title: {
        display: true,
        text: `Non Prime - Avg Used and Queued Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.nonPrimeCoreUsageChartData.datasets[0].data);
        },
        font: {
          size: 10
        }
      },
    },
    responsive: false,
  };
  nonPrimeCoreUsageChartType: ChartType = "bar";
  nonPrimeCoreUsageChartLegend = true;
  nonPrimeCoreUsageChartData: ChartData<'bar'> = {
    datasets: [
      { data: [], label: 'Used', backgroundColor: [], stack: "a" },
      { data: [], label: 'Queued', backgroundColor: [], stack: "a" }
    ],
    labels: []
  }
  nonPrimeCoreUsageChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Active Sessions By Profile Chart Variables]
  activeSessionsByProfileDataTotal: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: '',
        backgroundColor: 'rgba(255, 161, 181,0.2)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.2)',
        pointHoverBorderColor: '#fff',
        fill: 'origin',
      },
      {
        data: [],
        label: '',
        backgroundColor: 'rgba(0, 255, 0, 0.2)',
        borderColor: 'green',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(77,83,96,1)',
        fill: 'origin',
      },
      {
        data: [],
        label: '',
        backgroundColor: 'rgba(255,225,153,0.2)',
        borderColor: 'gold',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
      {
        data: [],
        label: '',
        backgroundColor: 'rgba(134,199,243,0.2)',
        borderColor: 'blue',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: 'origin',
      },
    ],
    labels: [],
  };

  activeSessionsByProfileOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
      },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        min: 0,
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Active Sessions By Deployments - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: 'top',
      },
      datalabels: {
        display: false,
      },
    },
  };
  //#endregion

  //#region [HPC Units Consumed]
  hpcUnitsConsumedDataTotal: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: '',
        backgroundColor: 'rgba(255, 161, 181,0.2)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: 'rgba(255, 161, 181,0.2)',
        pointHoverBorderColor: '#fff',
        fill: 'origin',
      },
    ],
    labels: [],
  };
  hpcUnitsConsumedOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        title: {
          text: "Date"
        }
      },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        min: 0,
        title: {
          display: true,
          text: "HPC Units"
        }
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `HPC Units Consumed - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: 'top',
      },
      datalabels: {
        display: false,
      },
    },
  };
  //#endregion

  //#region [CPU Usage by nodes chart]
  cpuUsageByNodesChartOptions: ChartConfiguration['options'] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Node'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'CPU Usage (%)'
        }
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `CPU Usage By Nodes - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'top',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > 0;
        },
      },
    }, elements: {
      line: {
        tension: 0,
      },
    },
  };
  cpuUsageByNodesChartType: ChartType = 'bar';
  cpuUsageByNodesChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: '#0072c6',
        borderColor: '#0072c6',
        pointBackgroundColor: '#0072c6',
        pointBorderColor: '#0072c6',
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a"
      }
    ],
  };
  cpuUsageByNodesChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [CPU Usage by node groups chart]
  cpuUsageByNodeGroupsChartOptions: ChartConfiguration['options'] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Node Groups'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'CPU Usage (%)'
        }
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `CPU Usage By Node Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'top',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > 0;
        },
      },
    }, elements: {
      line: {
        tension: 0,
      },
    },
  };
  cpuUsageByNodeGroupsChartType: ChartType = 'bar';
  cpuUsageByNodeGroupsChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: '#0072c6',
        borderColor: '#0072c6',
        pointBackgroundColor: '#0072c6',
        pointBorderColor: '#0072c6',
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a"
      }
    ],
  };
  cpuUsageByNodeGroupsChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Core Usage by nodes chart]
  coreUsageByNodesChartOptions: ChartConfiguration['options'] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Node'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Core Usage (%)'
        }
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `Core Usage By Nodes - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'top',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > 0;
        },
      },
    }, elements: {
      line: {
        tension: 0,
      },
    },
  };
  coreUsageByNodesChartType: ChartType = 'bar';
  coreUsageByNodesChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: '#0072c6',
        borderColor: '#0072c6',
        pointBackgroundColor: '#0072c6',
        pointBorderColor: '#0072c6',
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a"
      }
    ],
  };
  coreUsageByNodesChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Core Usage by node groups chart]
  coreUsageByNodeGroupsChartOptions: ChartConfiguration['options'] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Node Groups'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Core Usage (%)'
        }
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `Core Usage By Node Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: "top",
      },
      datalabels: {
        anchor: 'center',
        align: 'top',
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > 0;
        },
      },
    }, elements: {
      line: {
        tension: 0,
      },
    },
  };
  coreUsageByNodeGroupsChartType: ChartType = 'bar';
  coreUsageByNodeGroupsChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: '#0072c6',
        borderColor: '#0072c6',
        pointBackgroundColor: '#0072c6',
        pointBorderColor: '#0072c6',
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a"
      }
    ],
  };
  coreUsageByNodeGroupsChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [JobDurationsByDay]
  jobDurationsByDayOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {},
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Timespan in minutes",
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          filter: (legendItem, chartData) => {
            // Only show legend items for datasets that don't include 'Mean' in their label
            return !legendItem.text.includes('Mean');
          }
        }
      },
      title: {
        display: true,
        text: `Job Duration By Day - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobDurationsByDayType: ChartType = "bar";
  jobDurationsByDayData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Run Time (Sum)",
        backgroundColor: "#95cd41",
        borderColor: "#95cd41",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: "#95cd41",
        order: 1,
      },
      {
        data: [],
        label: "Wait Time (Sum)",
        backgroundColor: "#f6d860",
        borderColor: "#f6d860",
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        hoverBackgroundColor: "#f6d860",
        fill: "origin",
      },
      {
        data: [],
        label: "Run Time (Avg)",
        backgroundColor: '#ED7D31',
        borderColor: '#ED7D31',
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: '#ED7D31',
        order: 1,
      },
      {
        data: [],
        label: "Wait Time (Avg)",
        backgroundColor: '#3876BF',
        borderColor: '#3876BF',
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        hoverBackgroundColor: '#3876BF',
        fill: "origin",
      }
    ],
  };
  jobDurationsByDayPlugins = [DatalabelsPlugin];
  jobDurationsByDayBarColors = ["#95cd41", "#f6d860", '#ED7D31', '#3876BF']
  //#endregion

  //#region [JobByTagsPerDay]
  jobByTagsPerDayChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Tags"
        }
      },
      y: {
        min: 0,
        ticks: {},
        title: {
          display: true,
          text: "Number Of Jobs"
        }
      },
    },
    plugins: {
      datalabels: {
        align: "top",
        font: {
          weight: "bold",
        },
        clamp: true, // Prevent labels from overflowing outside the chart area

      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: `Job By Tags By Interval - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
        position: "top",
      },
    },
  };
  jobByTagsPerDayChartType: ChartType = "line";
  jobByTagsPerDayChartLegend = false;
  jobByTagsPerDayChartPlugins = [DatalabelsPlugin];
  jobByTagsPerDayChartData: ChartConfiguration["data"] = {
    datasets: [
      // {
      //   data: [],
      //   label: "NA",
      //   order: 1,
      //   pointBackgroundColor: "#1f77b4",
      //   pointBorderColor: "#1f77b4",
      //   fill: false,
      //   borderColor: "#bcd7e8",
      //   radius: 3,
      // }
    ],
    labels: [],
  };
  jobByTagsPerDayChartDataTemp: ChartConfiguration["data"] = {
    datasets: [
    ],
    labels: [],
  };
  //#endregion

  //#region [Running and Queued Jobs Per Node Group]
  runningQueuedJobsPerNodeGroupChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    scales: {
      x: {},
      y: {
        min: 0,
        ticks: {},
        title: {
          display: true,
          text: "Average Number Of Jobs",
        },
      },
    },
    plugins: {
      datalabels: {
        align: "top",
        font: {
          weight: "bold",
        },
        clamp: true, // Prevent labels from overflowing outside the chart area

      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: `Job By Node Group By Interval - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
        position: "top",
      },
    },
  };
  runningQueuedJobsPerNodeGroupChartType: ChartType = "line";
  runningQueuedJobsPerNodeGroupChartLegend = false;
  runningQueuedJobsPerNodeGroupChartPlugins = [DatalabelsPlugin];
  runningQueuedJobsPerNodeGroupChartData: ChartConfiguration["data"] = {
    datasets: [
    ],
    labels: [],
  };
  runningQueuedJobsPerNodeGroupDataTemp: ChartConfiguration["data"] = {
    datasets: [
    ],
    labels: [],
  };
  //#endregion

  //#region [Prime - Non Prime Hours Jobs Submission]
  primeNonPrimeHoursJobsSubmissionOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        min: 0,
        title: {
          display: true,
          text: "Number Of Jobs",
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Job Submit Count By Working Hours - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };
  primeNonPrimeHoursJobsSubmissionType: ChartType = "line";
  primeNonPrimeHoursJobsSubmissionData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "Office Hours",
        backgroundColor: "#0072c6",
        borderColor: "#0072c6",
        pointBackgroundColor: "#0072c6",
        pointBorderColor: "#0072c6",
        hoverBackgroundColor: "#0072c6",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(77,83,96,1)",
        fill: false,
      },
      {
        data: [],
        label: "Non-Office Hours",
        backgroundColor: "black",
        borderColor: "black",
        pointBackgroundColor: "black",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "black",
        pointHoverBorderColor: "#fff",
        fill: false,
      }
    ],
    labels: [],
  };
  //#endregion

  //#region [Jobs By User Per Day]
  jobsByUserByDayOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        min: 0,
        title: {
          display: true,
          text: "Number Of Jobs",
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Jobs By User Per Day - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
        position: "top",
      },
      datalabels: {
        display: true,
      },
    },
  };
  jobsByUserByDayType: ChartType = "line";
  jobsByUserByDayData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "Office Hours",
        backgroundColor: "#0072c6",
        borderColor: "#0072c6",
        pointBackgroundColor: "#0072c6",
        pointBorderColor: "#0072c6",
        hoverBackgroundColor: "#0072c6",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(77,83,96,1)",
        fill: false,

      },
      {
        data: [],
        label: "Non-Office Hours",
        backgroundColor: "black",
        borderColor: "black",
        pointBackgroundColor: "black",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "black",
        pointHoverBorderColor: "#fff",
        fill: false,
      },
      {
        data: [],
        label: "Total",
        backgroundColor: "#95cd41",
        borderColor: "#95cd41",
        borderDash: [5, 5],
        pointBackgroundColor: "#95cd41",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#95cd41",
        pointHoverBorderColor: "#fff",
        fill: false,
      }
    ],
    labels: [],
  };
  //#endregion

  //#endregion

  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;
  @ViewChild('pdfContent') pdfContent!: ElementRef;
  @ViewChild('pdfContentSessionEndStart') pdfContentSessionEndStart!: ElementRef;
  @ViewChild('pdfContentSessionConDisConnect') pdfContentSessionConDisConnect!: ElementRef;
  @ViewChild('chart') chart: any;
  statusMapping = {
    1: 'Cancelled',
    5: 'Failed',
    11: 'Succeeded'
  };
  // tabular data
  displayedColumns: string[] = [];
  ELEMENT_DATA = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  nodeGroupValue = "none";
  nodeGroups: string[] = [];
  nodeUtilizationByNodeGroup: NodeUsage[] = [];
  selectedNodeGroups: string[] = this.nodeGroups;
  dynamicControls: DynamicControl[] = [];
  @ViewChild(MatSort) sort: MatSort;

  @Output() refreshRequested = new EventEmitter<void>();
  requestRefresh() {
    this.refreshRequested.emit();
  }


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private sessionService: SessionService,
    private chartService: ChartsService,
    private actionLogService: ActionLogService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private deploymentService: DeploymentService,
    private appService: ApplicationService,
    private jobService: JobsService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private nodeService: NodeService,
    private spinner: NgxSpinnerService,
    private headerService: HeaderService,
    private fb: FormBuilder
  ) {
    Chart.register(Annotation);
    Chart.register(...registerables)
  }

  quickAccessControls: QuickAccessControl = { deployments: null, licenseServerNames: null };

  async ngOnInit() {
    const fullUrl = window.location.href;
    const decodedFullUrl = decodeURIComponent(fullUrl);

    const routes = decodedFullUrl.split('/');

    if (routes[routes.length - 1] == 'graphs') {
      this.depName = routes[routes.length - 2];
    }
    else {
      this.quickAccessControls = await lastValueFrom(this.headerService.getQuickAccessControlSummary());
      this.deployments = this.quickAccessControls.deployments.filter(x => x.userRole != UserRolesInt.JobOperator).map((d) => d.name);
      if (this.deployments && this.deployments.length > 0) {
        this.deployments = this.deployments?.sort((a, b) => a.localeCompare(b));
      }
      this.depName = this.deployments?.[0];
    }

    this.authenticationService.currentUser.subscribe((user) => {
      if (user) {
        this.loggedInUser = user.username;
        this.loadDynamicControls();
      }
    });
    this.date.setDate(this.date.getDate() - 7);
    this.daysValue = 'From ' +
      new DatePipe('en-US').transform(this.date, 'yyyy-MM-dd, HH:mm:ss') +
      ' To ' +
      new DatePipe('en-US').transform(this.currentDate, 'yyyy-MM-dd, HH:mm:ss');
    this.navService.sendParentData('Reports');
    this.navService.sendLeftPanelIndex(6);
    this.nodeService.getAllWSNames(this.depName, "All").subscribe((data) => {
      if (data) {
        this.wsNames = JSON.parse(JSON.stringify(data))?.wsSelected;
        this.nodeGroups = JSON.parse(JSON.stringify(data))?.nodeGroups;
      }
    });
    this.loadUsers();
    this.graphFilterForm = this.fb.group({
      userNames: [this.selectedItems],
      userGroupNames: [this.selectedItems],
      jobTags: [this.selectedItems],
      coreHourUserNames: [this.selectedItems]
    });
    this.createGraphDataLabelForm();
    this.getUserName();
    this.getUserGroupNames();
    this.getJobTags();
    // this.loadAllCharts();
    this.chartHeight = String(window.innerHeight * 0.21);
    this.chartWidth = String(window.innerWidth * 0.38);
    this.checkIsVdiDeployment();


  }

  ngOnDestroy() {
    this.dataReloadSubscription?.unsubscribe();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  createGraphDataLabelForm() {
    this.graphDataLabelsForm = new FormGroup({
      jobCountSubmitted: new FormControl(false),
      jobCountSucceeded: new FormControl(false),
      jobCountCancelled: new FormControl(false),
      jobCountFailed: new FormControl(false),
      storageUsage: new FormControl(false),
      coresByApplication: new FormControl(false),
      jobByTagsPerDayForm: this.fb.array([]),
      jobByApplicationPerDayForm: this.fb.array([]),
      allNodeGroupsForm: this.fb.array([])
    })
    this.graphDataLabelsForm.valueChanges.subscribe((val) => {
      this.charts.forEach((child) => {
        child?.chart ? child?.chart?.update() : child?.update();
      });
    })
  }

  loadUsers() {
    this.userService
      .getAllDeploymentUserForJobFilter(this.depName, true)
      .subscribe({
        next: (data: any) => {
          if (!data) return;
          if (data?.users != "") {
            this.userNamesForSessionGraph = data?.users?.split(",");
            this.userNamesForSessionGraph = this.userNamesForSessionGraph?.sort((a, b) =>
              a.localeCompare(b)
            );
          }
          else {

          }
        }, error: (err) => {

        }
      });
  }

  loadApps() {
    this.appService.getAllApplicationsForUser(this.depName).subscribe({
      next: (data: Application[]) => {
        data.forEach((d) => {
          this.appNames.push(d.appName);
        });
      },
    });
  }

  loadCompletedJobs(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getAllCharts(this.depName, this.dateFilterValue, this.granularityValue)
        .subscribe({
          next: (data) => {
            this.loadTabularData(JSON.parse(JSON.stringify(data)));
            this.allChartsData = JSON.parse(JSON.stringify(data));

            this.allJobsData.datasets = [
              {
                data: [],
              },
            ];
            this.allJobsData.labels = [];
            this.spinner.hide("loadingGraphs");

            if (this.allChartsData && this.allChartsData['coreUsage']?.length != 0) {
              this.daysValue =
                'From ' +
                new DatePipe('en-US').transform(
                  this.allChartsData['coreUsage'][0]
                    ? new Date(this.allChartsData['coreUsage'][0].timeStamp)
                    : new Date(),
                  'yyyy-MM-dd, HH:mm:ss'
                ) +
                ' To ' +
                new DatePipe('en-US').transform(
                  new Date(
                    this.allChartsData['coreUsage'][
                      this.allChartsData['coreUsage']?.length - 1
                    ].timeStamp
                  ),
                  'yyyy-MM-dd, HH:mm:ss'
                );
            } else {
              this.daysValue = 'From - to -'
            }
            this.queuedJobs = this.allChartsData['queuedJobCount'];
            this.runningJobs = this.allChartsData['runningJobCount'];
            this.completedJobs = this.allChartsData['completedJobCount'];
            if (toDownload) {
              this.downloadCsv([this.queuedJobs, this.runningJobs, this.completedJobs], ['Queued', 'Running', 'Completed'], `${Graphs.JobCompleted}-${this.depName}.csv`);
            }

            if (this.queuedJobs != 0) {
              this.allJobsData.datasets[0].data.push(
                this.queuedJobs,
              );
            }
            else {
              this.allJobsData.datasets[0].data.push(
                null
              );
            }
            if (this.runningJobs != 0) {
              this.allJobsData.datasets[0].data.push(
                this.runningJobs
              );
            }
            else {
              this.allJobsData.datasets[0].data.push(
                null
              );
            }
            if (this.completedJobs != 0) {
              this.allJobsData.datasets[0].data.push(
                this.completedJobs
              );
            }
            else {
              this.allJobsData.datasets[0].data.push(
                null
              );
            }

            this.allJobsData.labels.push('Queued', 'Running', 'Completed');
            this.allJobsOptions = {
              responsive: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'bottom',
                  labels: {
                    boxWidth: 15,
                  },
                },
                title: {
                  display: true,
                  text: `Job Status Summary (${this.depName}) - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: 'top',
                },
                datalabels: {
                  formatter: (value) => {
                    var perc = value;
                    return perc;
                  },
                },
              },
            };
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          },
          complete: () => {
            // this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (e) {
      console.error("Error in loading completed jobs", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  loadJobSummary(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getAllCharts(
          this.depName,
          this.dateFilterValue,
          this.granularityValue,
          this.userSelected
        )
        .subscribe({
          next: (data) => {
            this.loadTabularData(JSON.parse(JSON.stringify(data)));
            this.allChartsData = JSON.parse(JSON.stringify(data));

            this.jobsSummaryData.datasets = [
              {
                data: [],
              },
            ];
            this.jobsSummaryData.labels = [];
            this.spinner.hide("loadingGraphs");

            if (this.allChartsData && this.allChartsData['coreUsage']?.length != 0) {
              this.daysValue =
                'From ' +
                new DatePipe('en-US').transform(
                  this.allChartsData['coreUsage'][0]
                    ? new Date(this.allChartsData['coreUsage'][0].timeStamp)
                    : new Date(),
                  'yyyy-MM-dd, HH:mm:ss'
                ) +
                ' To ' +
                new DatePipe('en-US').transform(
                  new Date(
                    this.allChartsData['coreUsage'][
                      this.allChartsData['coreUsage']?.length - 1
                    ].timeStamp
                  ),
                  'yyyy-MM-dd, HH:mm:ss'
                );
            } else {
              this.daysValue = 'From - to -'
            }
            this.failedJobs = this.allChartsData['failedJobCount'];
            this.cancelledJobs = this.allChartsData['canceledJobCount'];
            this.succeededJobs = this.allChartsData['succeedJobCount'];
            this.jobsSummaryData.datasets[0].data.push(
              this.failedJobs,
              this.cancelledJobs,
              this.succeededJobs
            );
            this.totalJobsCompleted =
              this.failedJobs + this.cancelledJobs + this.succeededJobs;
            if (toDownload) {
              this.downloadCsv([this.failedJobs, this.cancelledJobs, this.succeededJobs], ['Failed', 'Cancelled', 'Succeeded'], `${Graphs.JobSummary}-${this.depName}.csv`);
            }
            this.jobsSummaryData.labels.push('Failed', 'Cancelled', 'Succeeded');
            this.jobsSummaryOptions = {
              responsive: false,
              plugins: {
                legend: {
                  position: 'bottom',
                  labels: {
                    boxWidth: 15,
                  },
                },
                title: {
                  display: true,
                  text: 'Jobs Completed : ' + this.totalJobsCompleted + ` Jobs - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: 'top',
                },
                datalabels: {
                  formatter: (value) => {
                    var perc = value;
                    return perc;
                  },
                  display: (context) => {
                    return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.coreUsageByNodeGroupsChartData.datasets[0].data, 0);
                  },
                },
              },
            };
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            console.error("Error in loading job summary", err);
          },
          complete: () => {
            // this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (e) {
      console.error("Error in loading job summary", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  loadCoresPerDay(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getSpecificChart(
          this.depName,
          Graphs.CoreUsage,
          this.dateFilterValue,
          this.granularityValue,
          this.userSelected
        )
        .subscribe({
          next: (data) => {
            this.spinner.hide("loadingGraphs");
            this.coresPerDayData['datasets'][0].data = [];
            this.coresPerDayData['datasets'][1].data = [];
            this.coresPerDayData['datasets'][2].data = [];
            this.coresPerDayData['datasets'][3].data = [];
            this.coresPerDayData.labels = [];
            this.loadTabularData(JSON.parse(JSON.stringify(data)));
            this.coresData = <CoreUsage[]>JSON.parse(JSON.stringify(data));
            let avgRunCoresData = [];
            let medRunCoresData = [];
            this.coresPerDayData.labels = [];
            let runningCores = this.coresData.map(d => d.runningCores)
            let totalRunningCores = runningCores.reduce((sum, current) => sum + current, 0);
            let totalRunningCoresAverage = Math.round(totalRunningCores / this.coresData.length);
            let median = this.calculateMedian(runningCores);
            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(data, headers, `${Graphs.CoreUsage}-${this.depName}.csv`);
            }
            this.realQueuedCores = [];
            this.realRunningCores = [];
            this.realActiveCores = [];
            this.spinner.hide("loadingGraphs");
            if (this.coresData && this.coresData?.length != 0) {
              this.daysValue =
                'From ' +
                new DatePipe('en-US').transform(
                  this.coresData[0].timeStamp
                    ? new Date(this.coresData[0].timeStamp)
                    : new Date(),
                  'yyyy-MM-dd, HH:mm:ss'
                ) +
                ' To ' +
                new DatePipe('en-US').transform(
                  new Date(
                    this.coresData[this.coresData?.length - 1].timeStamp
                  ),
                  'yyyy-MM-dd, HH:mm:ss'
                );
            } else {
              this.daysValue = 'From - to -'
            }
            this.coresData.forEach((x) => {
              this.coresPerDayData['datasets'][0].data.push(x.queuedCores);
              this.realQueuedCores.push(x.queuedCores);
              this.realRunningCores.push(x.runningCores);
              this.realActiveCores.push(x.activeCores);
              avgRunCoresData.push(totalRunningCoresAverage);
              this.coresPerDayData['datasets'][1].data.push(x.runningCores);
              let date;
              this.coresPerDayData['datasets'][3].data.push(x.activeCores);
              medRunCoresData.push(median);
              if (this.granularityValue == 'One Hour') {
                date = formatDate(
                  new Date(x.timeStamp),
                  'shortTime',
                  'en-US'
                ).split(' ')[0];
              } else {
                date = formatDate(new Date(x.timeStamp), 'longDate', 'en-US').split(
                  ','
                )[0];
              }
              this.coresPerDayData['labels'].push(date);
            });
            this.coresPerDayData['datasets'][2].data = avgRunCoresData;
            this.coresPerDayData['datasets'][4].data = medRunCoresData;
            this.coresPerDayOptions = {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: {
                  title: {
                    display: true,
                    text: "Date"
                  }
                },
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: "Average Cores"
                  }
                },
              },
              plugins: {
                legend: {
                  position: "bottom",
                },

                title: {
                  display: true,
                  text: `Average Core Usage - ${totalRunningCoresAverage} Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: "top",
                },
                datalabels: {
                  anchor: "end",
                  align: "end",
                  display: (context) => {
                    return (
                      +context.dataset.data[context.dataIndex] >
                      this.getDataLabelUsableValue(this.coresPerDayData.datasets[0].data)
                    );
                  },
                },
              },
            };
            this.updateGraphs();
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            console.error("Error in loading cores per day", err);
          },
          complete: () => {
            // this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (e) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loading cores per day", e);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  loadStorageCharts(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();

    try {
      this.chartService
        .getSpecificChart(
          this.depName,
          Graphs.StorageUsage,
          this.dateFilterValue,
          this.granularityValue,
          this.userSelected
        )
        .subscribe({
          next: (data) => {
            this.spinner.hide("loadingGraphs");
            this.storageChartData.datasets.forEach(d => d.data = []);
            this.storageChartData.labels = [];
            this.loadTabularData(JSON.parse(JSON.stringify(data)));
            let storageUsage = [];
            this.storageData = [];
            this.storageData = <StorageUsage[]>JSON.parse(JSON.stringify(data));
            this.spinner.hide("loadingGraphs");
            if (this.storageData && this.storageData?.length != 0) {
              this.daysValue =
                'From ' +
                new DatePipe('en-US').transform(
                  this.storageData[0]
                    ? new Date(this.storageData[0].timeStamp)
                    : new Date(),
                  'yyyy-MM-dd, HH:mm:ss'
                ) +
                ' To ' +
                new DatePipe('en-US').transform(
                  new Date(
                    this.storageData[
                      this.storageData?.length - 1
                    ].timeStamp
                  ),
                  'yyyy-MM-dd, HH:mm:ss'
                );
            } else {
              this.daysValue = 'From - to -'
            }
            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(data, headers, `${Graphs.StorageUsage}-${this.depName}.csv`);
              this.spinner.hide("loadingGraphs");
            }
            this.storageData.forEach((x) => {
              storageUsage.push(x.storageUsage);
              this.storageChartData.datasets[0].data.push(x.storageUsage);
              let date;
              if (this.granularityValue == 'One Hour') {
                date = formatDate(
                  new Date(x.timeStamp),
                  'shortTime',
                  'en-US'
                ).split(',')[0];
              } else {
                date = formatDate(new Date(x.timeStamp), 'longDate', 'en-US').split(
                  ','
                )[0];
              }
              //this.storageChartData.labels.push(date);
            });

            let dateFilter = this.dateFilterValue;
            if (this.dateFilterValue.indexOf('hr') != -1 || this.dateFilterValue.indexOf('days') != -1) {
              dateFilter = this.dateFilterValue.indexOf('hr') != -1 ? this.dateFilterValue.trim().slice(0, -2).trim() : this.dateFilterValue.trim().slice(0, -4).trim();
            }
            let uniqueDates;
            if (
              dateFilter != "1" &&
              (this.dateFilterValue.indexOf("days") != -1 ||
                this.dateFilterValue.indexOf("to") != -1)
            ) {
              uniqueDates = [
                ...new Set(
                  this.storageData?.map(
                    (item) =>
                      formatDate(
                        new Date(item.timeStamp),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0]
                  )
                ),
              ];
            }
            else {
              uniqueDates = [
                ...new Set(this.storageData.map((item) => item.timeStamp)),
              ];
            }
            uniqueDates.forEach((unq) => {
              let date;
              if (
                dateFilter != "1" &&
                this.dateFilterValue != "1" &&
                this.dateFilterValue.indexOf("days") != -1
              ) {
                date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                  ","
                )[0];
              }
              else if (this.dateFilterValue.indexOf("to") != -1) {
                date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                  ","
                )[0];
              }
              else {
                date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                  ")"
                )[0];
              }
              this.storageChartData.labels.push(date);
            })

            this.storageChartOptions = {
              ...this.storageChartOptions,
              scales: {
                x: {
                  grid: {
                    color: 'rgba(255,0,0,0.1)',
                    borderColor: 'black',
                  },
                  title: {
                    display: true,
                    text: "Date"
                  }
                },
                'y-axis-0': {
                  position: 'left',
                  grid: {
                    color: 'rgba(255,0,0,0.1)',
                    borderColor: 'black',
                  },
                  min: 0,
                  max: Math.max(...storageUsage) + 10,
                  title: {
                    display: true,
                    text: 'Usage in GB'
                  }
                },
              },
              plugins: {
                ...this.storageChartOptions.plugins,
                title: {
                  display: true,
                  text: `Storage Usage (GB) - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: 'top',
                },
              },
            };
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            console.error("Error in loading storage charts", err);
          },
          complete: () => {

          }
        });
    }
    catch (e) {
      console.error("Error in loading storage charts", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  sortedData: any = {};
  sortedKeys: string[] = [];

  loadJobByApplicationData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getJobByApplicationData(
          this.depName,
          this.dateFilterValue,
          this.granularityValue
        )
        .subscribe({
          next: (data) => {
            this.spinner.hide("loadingGraphs");
            this.jobByApplicationData.datasets.forEach((d) => (d.data = []));
            this.jobByApplicationData["labels"] = [];
            let jobByApplicationCompleteData: JobByApplicationGraphDataI = JSON.parse(
              JSON.stringify(data)
            );
            let jobByApplicationData: JobByApplicationI[] = JSON.parse(
              JSON.stringify(jobByApplicationCompleteData?.jobByApplication)
            );
            let jobByApplicationPerDayData: JobByApplicationsPerDayI[] = JSON.parse(
              JSON.stringify(jobByApplicationCompleteData?.jobByApplicationsPerDay)
            );

            this.loadTabularData(JSON.parse(JSON.stringify(jobByApplicationData)));

            var filteredData = this.groupByApplication(
              jobByApplicationData,
              "jobApplication"
            );

            if (filteredData) {
              this.sortedData = {};
              this.sortedKeys = [];
              const appTotals = Object.entries(filteredData).map(([appName, jobs]) => {
                const sum = (jobs as any[]).reduce((total, job) => total + job.totalCount, 0);
                return { appName, sum };
              });
              if (appTotals && appTotals.length > 0) {
                appTotals.sort((a, b) => b.sum - a.sum);
                this.sortedKeys = appTotals.map(item => item.appName);

                if (this.sortedKeys && this.sortedKeys.length > 0) {
                  const sortedObj = {};
                  this.sortedKeys.forEach(key => {
                    sortedObj[key] = filteredData[key];
                  });
                  if (sortedObj && Object.keys(sortedObj).length > 0) {
                    filteredData = sortedObj;
                  }
                }
              }
            }

            var filteredDataPerDay = this.groupByNodes(
              jobByApplicationPerDayData,
              "timeStamp"
            );

            if (toDownload) {
              let headers = Object.keys(jobByApplicationData[0]);
              let jobAppData = JSON.parse(JSON.stringify(jobByApplicationData));
              jobAppData.forEach((e) => {
                if (e.jobStageStatus == 1) {
                  e.jobStageStatus = "Cancelled";
                } else if (e.jobStageStatus == 5) {
                  e.jobStageStatus = "Failed";
                } else if (e.jobStageStatus == 11) {
                  e.jobStageStatus = "Succeeded";
                }
              });
              this.downloadCsv(
                jobAppData,
                headers,
                `${Graphs.JobByApplication}-${this.depName}.csv`
              );
            }
            Object.keys(filteredData).forEach((key, idx) => {
              let totalJobs = 0;
              this.jobByApplicationData["datasets"][0].data[idx] = 0;
              this.jobByApplicationData["datasets"][1].data[idx] = 0;
              this.jobByApplicationData["datasets"][2].data[idx] = 0;
              filteredData[key].forEach((e) => {
                if (e.jobStageStatus == 1) {
                  this.jobByApplicationData["datasets"][1].data[idx] +=
                    e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
                } else if (e.jobStageStatus == 5) {
                  this.jobByApplicationData["datasets"][2].data[idx] +=
                    e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
                } else if (e.jobStageStatus == 11) {
                  this.jobByApplicationData["datasets"][0].data[idx] +=
                    e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
                }
              });
              this.jobByApplicationData['labels'].push(key + " : " + totalJobs);
            });
            this.jobByApplicationOptions = {
              ...this.jobByApplicationOptions,
              plugins: {
                ...this.jobByApplicationOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job By Application - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                },
              },
            };

            this.applicationNames = [];
            this.appsArray?.clear();
            this.applicationNames = jobByApplicationCompleteData?.applicationNames?.split(',');
            this.applicationNames.forEach(() => this.appsArray.push(new FormControl(false)));

            this.jobByApplicationsPerDayChartData["datasets"] = []
            this.jobByApplicationsPerDayChartData["labels"] = []

            this.applicationNames.forEach((name, index) => {
              this.jobByApplicationsPerDayChartData["datasets"].push({
                data: [],
                type: 'line',
                label: name,
                order: 1,
                fill: false,
              })
            })

            if (filteredDataPerDay) {
              Object.keys(filteredDataPerDay).forEach((key, idx) => {
                if (filteredDataPerDay[key]) {
                  this.applicationNames.forEach((name, index) => {
                    const count = filteredDataPerDay[key].filter(tag => tag.application.toLowerCase() == name.toLowerCase()).map(x => x.totalCount)[0]
                    if (count) {
                      this.jobByApplicationsPerDayChartData["datasets"][index].data[idx] = count;
                    }
                    else {
                      this.jobByApplicationsPerDayChartData["datasets"][index].data[idx] = 0;
                    }
                  })
                }

                if (key) {
                  let date;
                  let dateFilter = this.dateFilterValue;
                  if (
                    dateFilter != "1" &&
                    (this.dateFilterValue.indexOf("days") != -1 ||
                      this.dateFilterValue.indexOf("to") != -1)
                  ) {
                    date = formatDate(new Date(key), "mediumDate", "en-US").split(
                      ","
                    )[0];
                  } else {
                    date = formatDate(new Date(key), "h:mm aa", "en-US").split(
                      ")"
                    )[0];
                  }
                  if (date) {
                    this.jobByApplicationsPerDayChartData["labels"].push(date);
                  }
                  else {
                    this.jobByApplicationsPerDayChartData["labels"].push(key);
                  }
                }
              });
            }

            this.jobByApplicationOptions = {
              ...this.jobByApplicationOptions,
              plugins: {
                ...this.jobByApplicationOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job By Application - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                },
              },
            };

            this.jobByApplicationDataTemp = JSON.parse(JSON.stringify(this.jobByApplicationData));

            this.updateGraphs();

          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            console.error("Error in loading job by application data", err);
          },
          complete: () => {
            // this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (e) {
      console.error("Error in loading job by application data", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  loadJobByNodesData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService.getJobByNodesData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          this.jobByNodesData['datasets'].forEach(d => d.data = []);
          this.jobByNodesData['labels'] = [];

          this.loadTabularData(JSON.parse(JSON.stringify(data)));

          let jobByNodesData: JobByNodesI[] = JSON.parse(JSON.stringify(data));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            Object.keys(data).forEach(e => { data[e].jobStageStatus = this.statusMapping[data[e].jobStageStatus] });
            this.downloadCsv(data, headers, `${Graphs.JobByNodes}-${this.depName}.csv`);

          }

          let soloNodes: JobByNodesI[] = jobByNodesData.filter(n => !n.jobAllocatedNodes.includes(","));
          let multiNodes: JobByNodesI[] = jobByNodesData.filter(n => n.jobAllocatedNodes.includes(","));
          multiNodes.forEach(element => {
            element.jobAllocatedNodes.split(",").forEach(node => {
              soloNodes.push({ ...element, jobAllocatedNodes: node })
            })
          });
          jobByNodesData = soloNodes;

          var filteredData = this.groupByNodes(jobByNodesData, "jobAllocatedNodes");
          this.jobByNodesData['labels'] = [];
          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobs = 0;
            this.jobByNodesData['datasets'][0].data[idx] = 0;
            this.jobByNodesData['datasets'][1].data[idx] = 0;
            this.jobByNodesData['datasets'][2].data[idx] = 0;
            filteredData[key].forEach(e => {
              if (e.jobStageStatus == 1) {
                this.jobByNodesData['datasets'][1].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 5) {
                this.jobByNodesData['datasets'][2].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 11) {
                this.jobByNodesData['datasets'][0].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              }
            });
            this.jobByNodesData["labels"].push(key + " : " + totalJobs);
          });
          this.jobByNodesOptions = {
            ...this.jobByNodesOptions,
            plugins: {
              ...this.jobByNodesOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Nodes - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          console.error("Error in loading job by nodes data", err);
        }
      });
    }
    catch (e) {
      console.error("Error in loading job by nodes data", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  loadJobByNodeGraphData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getJobByNodeGroupData(
          this.depName,
          this.dateFilterValue,
          this.granularityValue
        )
        .subscribe({
          next: (data) => {
            this.spinner.hide("loadingGraphs");
            this.jobByNodesData["datasets"].forEach((d) => (d.data = []));
            this.jobByNodesData['labels'] = [];

            this.loadTabularData(JSON.parse(JSON.stringify(data)));

            let jobByNodesData: JobByNodesI[] = JSON.parse(JSON.stringify(data));
            if (toDownload) {
              let headers = Object.keys(data[0]);
              Object.keys(data).forEach((e) => {
                data[e].jobStageStatus =
                  this.statusMapping[data[e].jobStageStatus];
              });
              this.downloadCsv(
                data,
                headers,
                `${Graphs.JobByNodeGroup}-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
            }
            let soloNodes: JobByNodesI[] = jobByNodesData.filter(
              (n) => !n.jobAllocatedNodes.includes(",")
            );
            let multiNodes: JobByNodesI[] = jobByNodesData.filter((n) =>
              n.jobAllocatedNodes.includes(",")
            );
            multiNodes.forEach((element) => {
              element.jobAllocatedNodes.split(",").forEach((node) => {
                soloNodes.push({ ...element, jobAllocatedNodes: node });
              });
            });
            jobByNodesData = soloNodes;

            var filteredData = this.groupByNodes(
              jobByNodesData,
              "jobAllocatedNodes"
            );
            this.jobByNodesData["labels"] = [];
            Object.keys(filteredData).forEach((key, idx) => {
              let totalJobs = 0;
              this.jobByNodesData["datasets"][0].data[idx] = 0;
              this.jobByNodesData["datasets"][1].data[idx] = 0;
              this.jobByNodesData["datasets"][2].data[idx] = 0;
              filteredData[key].forEach((e) => {
                if (e.jobStageStatus == 1) {
                  this.jobByNodesData["datasets"][1].data[idx] += e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
                } else if (e.jobStageStatus == 5) {
                  this.jobByNodesData["datasets"][2].data[idx] += e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
                } else if (e.jobStageStatus == 11) {
                  this.jobByNodesData["datasets"][0].data[idx] += e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
                }
              });
              this.jobByNodesData["labels"].push(key + " : " + totalJobs);
            });
            this.jobByNodesOptions = {
              ...this.jobByNodesOptions,
              scales: {
                x: {
                  title: {
                    display: true,
                    text: "Node Groups"
                  }
                },
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: "Number of Jobs"
                  }
                },
              },
              plugins: {
                ...this.jobByNodesOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job By Node Groups - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                },
              },
            };
            this.updateGraphs();
            this.spinner.hide("loadingGraphs");
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            console.error("Error in loading job by node group data", err);
          },
          complete: () => {
            // this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (e) {
      console.error("Error in loading job by node graph data", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }


  loadJobWaitTimeData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService.getJobWaitTimeData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data) => {
          this.jobWaitTimeChartData['datasets'].forEach(d => d.data = []);
          this.jobWaitTimeChartData['labels'] = [];
          this.loadTabularData(JSON.parse(JSON.stringify(data)));
          let jobWaitData = <JobWaitTimeI[]>JSON.parse(JSON.stringify(data));
          let avgJobInitDuration = jobWaitData.map(j => j.jobInitDuration).reduce((sum, current) => sum + current, 0);
          let avgCopyDataDuration = jobWaitData.map(j => j.jobDataCopyDuration).reduce((sum, current) => sum + current, 0);
          let avgJobSubmitDuration = jobWaitData.map(j => j.jobSubmitDuration).reduce((sum, current) => sum + current, 0);
          let avgResourceDuration = jobWaitData.map(j => j.jobResourceWaitDuration).reduce((sum, current) => sum + current, 0);
          let avgLicenseWaitDuration = jobWaitData.map(j => j.jobLicenseWaitDuration).reduce((sum, current) => sum + current, 0);
          let avgExtraDuration = jobWaitData.map(j => j.jobExtraWaitDuration).reduce((sum, current) => sum + current, 0);
          if (toDownload) {
            this.downloadCsv([avgJobInitDuration, avgCopyDataDuration, avgJobSubmitDuration, avgResourceDuration, avgLicenseWaitDuration, avgExtraDuration], ['JobInitAvg', 'JobDataCopyAvg', 'JobSubmitAvg', 'NoResourceAvg', 'NoLicenseAvg', 'OtherAvg'], `${Graphs.JobWaitTime}-${this.depName}.csv`);
          }
          this.jobWaitTimeChartData['datasets'][0].data = [Number(avgJobInitDuration), Number(avgCopyDataDuration), Number(avgJobSubmitDuration), Number(avgResourceDuration), Number(avgLicenseWaitDuration), Number(avgExtraDuration)];
          this.jobWaitTimeChartData['labels'] = [`JobInit : Avg ${avgJobInitDuration}`, `JobDataCopy : Avg ${avgCopyDataDuration}`, `JobSubmit : Avg ${avgJobSubmitDuration}`, `NoResource : Avg ${avgResourceDuration}`, `NoLicense : Avg ${avgLicenseWaitDuration}`, `Others : Avg ${avgExtraDuration}`];
          //this.jobWaitTimeChartData['datasets'][0].backgroundColor, this.jobWaitTimeChartData['datasets'][0].hoverBackgroundColor, this.jobWaitTimeChartData['datasets'][0].borderColor = [this.getDynamicColor(),this.getDynamicColor(),this.getDynamicColor(),this.getDynamicColor(),this.getDynamicColor()]
          this.spinner.hide("loadingGraphs");
          this.jobWaitTimeChartOptions = {
            ...this.jobWaitTimeChartOptions,
            plugins: {
              ...this.jobWaitTimeChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job Avg Wait Time ( In Mins ) - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          console.error("Error in loading job wait time data", err);
        }
      })
    }
    catch (e) {
      console.error("Error in loading job wait time data", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  loadNodeAvailabilityDataCount(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService.getNodeAvailabilityData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data: NodeAvailabilityI[]) => {
          this.spinner.hide("loadingGraphs");
          this.nodeAvailabilityData['datasets'].forEach(d => d.data = []);
          this.nodeAvailabilityData['labels'] = [];
          this.loadTabularData(JSON.parse(JSON.stringify(data)));
          if (data == null) return;
          let availableNodeData = [];
          let unAvailableNodeData = [];
          let busyNodeData = [];
          let totalBusy = data.map(d => d.busyNodes).reduce((sum, current) => sum + current, 0);
          let average = +parseFloat((totalBusy / data.length).toString()).toFixed(2);
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(data, headers, `${Graphs.NodeAvailability}-${this.depName}.csv`);
          }
          this.nodeAvailabilityChartOptions = {
            ...this.nodeAvailabilityChartOptions,
            plugins: {
              ...this.nodeAvailabilityChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Nodes Utilization - Average ${average} Busy Nodes - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          }
          let nodesAvgData = [];
          let nodesLabel = [];
          data = data.sort((a, b) => Date.parse(a.timeStamp) - Date.parse(b.timeStamp));
          data.forEach(e => {
            availableNodeData.push(e.availableNodes + e.busyNodes);
            unAvailableNodeData.push(e.unAvailableNodes);
            busyNodeData.push(e.busyNodes);
            nodesAvgData.push(average);
            let date;
            if (this.granularityValue == "One Hour") {
              date = formatDate(new Date(e.timeStamp), "h:mm aa", "en-US").split(")")[0];
            } else {
              date = formatDate(new Date(e.timeStamp), "mediumDate", "en-US").split(",")[0];
            }
            nodesLabel.push(date);
          });
          this.nodeAvailabilityData['datasets'][0].data = availableNodeData;
          this.nodeAvailabilityData['datasets'][1].data = unAvailableNodeData;
          this.nodeAvailabilityData['datasets'][2].data = busyNodeData;
          // this.nodeAvailabilityChartData[3].data = nodesAvgData;
          this.nodeAvailabilityData['labels'] = nodesLabel;
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          console.error("Error in loading node availability data", err);
        }
      });
    }
    catch (e) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loading node availability data", e);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  loadJobByUserData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {

      let uNames = this.graphFilterForm.value?.userNames?.map(
        (un) => un.item_text
      );
      if (uNames.length == 0) {
        this.snackbar.open("Please select minimum 1 user to proceed.", "Ok", {
          duration: 4000,
        });
        this.spinner.hide("loadingGraphs");
        return;
      }

      this.chartService
        .getByUserData(
          this.depName,
          this.dateFilterValue,
          this.granularityValue,
          uNames
        )
        .subscribe({
          next: (data) => {
            this.spinner.hide("loadingGraphs");
            this.jobByUserChartData["datasets"].forEach((d) => (d.data = []));
            this.jobByUserChartData["labels"] = [];

            this.loadTabularData(JSON.parse(JSON.stringify(data)));
            let jobByUsers = <JobByUserI[]>JSON.parse(JSON.stringify(data));

            if (toDownload) {
              let headers = Object.keys(data[0]);
              let jobUserData = JSON.parse(JSON.stringify(jobByUsers));
              jobUserData.forEach((e) => {
                e.jobStageStatus = this.statusMapping[e.jobStageStatus];
              });
              this.downloadCsv(
                jobUserData,
                headers,
                `${Graphs.JobByUser}-${this.depName}.csv`
              );
            }
            //jobByUsers.length = jobByUsers.length >= 15 ? 15 : jobByUsers.length;
            let colors = [];
            jobByUsers.forEach((job, i) => {
              this.jobByUserChartData["datasets"][0].data.push(job.totalJobs);
              // this.jobByUserChartData['labels'].push(`${job.userProfileId}`);
              // colors.push(this.getDynamicColor());
            });
            // this.jobByUserChartData['datasets'][0].backgroundColor = colors;
            let filteredData = this.groupByApplication(
              jobByUsers,
              "userProfileId"
            );

            if (filteredData) {
              const myDictionary: Dictionary = Object.keys(filteredData).reduce((acc, key) => {
                let totalJobsPerUser = 0
                totalJobsPerUser = filteredData[key].reduce(
                  (accumulator, currentValue) =>
                    accumulator + currentValue.totalJobs,
                  0
                );
                acc[key] = totalJobsPerUser;
                return acc;
              }, {} as Dictionary);

              if (myDictionary) {
                const entries: [string, number][] = Object.entries(myDictionary);
                entries?.sort((a, b) => b[1] - a[1]);
                let keys = entries?.map(x => x[0])

                if (keys) {
                  keys.forEach((key, idx) => {
                    //if (idx <= 14) {
                    let totalJobsPerUser = filteredData[key].reduce(
                      (accumulator, currentValue) =>
                        accumulator + currentValue.totalJobs,
                      0
                    );

                    this.jobByUserChartData["datasets"][0].data[idx] = 0;
                    this.jobByUserChartData["datasets"][1].data[idx] = 0;
                    this.jobByUserChartData["datasets"][2].data[idx] = 0;
                    filteredData[key].forEach((e: any) => {
                      if (e.jobStageStatus == 1) {
                        this.jobByUserChartData["datasets"][1].data[idx] +=
                          e.totalJobs;
                      } else if (e.jobStageStatus == 5) {
                        this.jobByUserChartData["datasets"][2].data[idx] +=
                          e.totalJobs;
                      } else if (e.jobStageStatus == 11) {
                        this.jobByUserChartData["datasets"][0].data[idx] +=
                          e.totalJobs;
                      }
                    });
                    this.jobByUserChartData.labels.push(
                      key + " : " + totalJobsPerUser + " Jobs"
                    );
                    //}
                  })
                }
              }
            }
            this.jobByUserChartOptions = {
              ...this.jobByUserChartOptions,
              plugins: {
                ...this.jobByUserChartOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job By Users - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                },
              },
            };
            this.updateGraphs();
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          },
        });
    }
    catch (e) {
      console.error("Error in loading job by user data", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  loadJobDataCount(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService.getJobCountData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data: JobCountData[]) => {
          this.spinner.hide("loadingGraphs");
          this.loadTabularData(JSON.parse(JSON.stringify(data)));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(data, headers, `${Graphs.JobDataCount}-${this.depName}.csv`);
          }

          this.jobCountChartData['datasets'].forEach(d => d.data = []);
          this.jobCountChartData['labels'] = [];

          let totalJobData = [];
          let succeededJobData = [];
          let failedJobData = [];
          let cancelledJobData = [];
          let totalJobsArr = data.map(d => d.totalJobCount);
          let totalJobs = totalJobsArr.reduce((sum, current) => sum + current, 0);
          let average = Math.round(totalJobs / data.length);
          let median = this.calculateMedian(totalJobsArr);
          if (data == null) return;
          let jobAvgData = [];
          let jobLabel = [];
          let jobAvgMedian = [];
          data = data.sort((a, b) => Date.parse(a.timeStamp) - Date.parse(b.timeStamp));
          data.forEach(e => {
            totalJobData.push(e.totalJobCount);
            succeededJobData.push(e.succeededCount);
            failedJobData.push(e.failedCount);
            cancelledJobData.push(e.cancelledCount);
            jobAvgData.push(average);
            jobAvgMedian.push(median);
            let date;
            if (this.granularityValue == "One Hour") {
              date = formatDate(new Date(e.timeStamp), "h:mm aa", "en-US").split(")")[0];
            } else {
              date = formatDate(new Date(e.timeStamp), "mediumDate", "en-US").split(",")[0];
            }
            jobLabel.push(date);
          });
          this.jobCountChartData['datasets'][0].data = totalJobData;
          this.jobCountChartData['datasets'][1].data = succeededJobData;
          this.jobCountChartData['datasets'][2].data = failedJobData;
          this.jobCountChartData['datasets'][3].data = cancelledJobData;
          this.jobCountChartData['datasets'][4].data = jobAvgData;
          this.jobCountChartData['datasets'][5].data = jobAvgMedian;
          this.jobCountChartData['labels'] = jobLabel;
          this.jobCountChartOptions = {
            ...this.jobCountChartOptions,
            plugins: {
              ...this.jobCountChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job Submit Count - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          console.error("Error in loading job data count", err);
        },
        complete: () => {
          // this.spinner.hide("loadingGraphs");
        }
      });
    }
    catch (e) {
      console.error("Error in loading job data count", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  loadJobByGroupsData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      let gNames = this.graphFilterForm.value?.userGroupNames?.map(gn => gn.item_text);
      if (gNames?.length == 0) {
        this.snackbar.open("Please select minimum 1 group to proceed.", "Ok", { duration: 4000 });
        this.spinner.hide("loadingGraphs");
        return;
      }
      this.chartService.getByGroupData(this.depName, this.dateFilterValue, this.granularityValue, gNames.toString()).subscribe({
        next: (data: any) => {
          this.spinner.hide("loadingGraphs");
          this.jobByGroupChartData['datasets'][0].data = [];
          this.jobByGroupChartData['labels'] = [];
          this.loadTabularData(JSON.parse(JSON.stringify(data)));
          data = data.reduce((ob, curr) => {
            const avl = ob.find(o => o.groupName == curr.groupName);
            if (avl) {
              avl.totalJobs += curr.totalJobs;
              return ob;
            }
            ob.push(curr);
            return ob;
          }, []);
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(data, headers, `${Graphs.JobByGroup}-${this.depName}.csv`);
          }
          let jobByGroups = <JobByGroupI[]>JSON.parse(JSON.stringify(data));

          let colors = [];
          jobByGroups.forEach((job, i) => {
            this.jobByGroupChartData['datasets'][0].data.push(job.totalJobs);
            this.jobByGroupChartData['labels'].push(`${job.groupName} : ${job.totalJobs}`);
            colors.push(this.getDynamicColor());
          });
          //this.jobByGroupChartData['datasets'][0].backgroundColor, this.jobByGroupChartData['datasets'][0].hoverBackgroundColor, this.jobByGroupChartData['datasets'][0].borderColor = colors;
          this.jobByGroupChartOptions = {
            ...this.jobByGroupChartOptions,
            plugins: {
              ...this.jobByGroupChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          console.error("Error in loading job by group data", err);
        }
      })
    }
    catch (e) {
      console.error("Error in loading job by group data", e);
      this.spinner.hide("loadingGraphs");
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  loadCoresByApplication(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService.getCoresByApplicationData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          this.coresByApplicationChartData['datasets'].forEach(d => d.data = []);
          this.loadTabularData(JSON.parse(JSON.stringify(data)));
          let coresByApplicationData: CoresByApplicationI[] = JSON.parse(JSON.stringify(data));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(coresByApplicationData, headers, `${Graphs.CoresByApplication}-${this.depName}.csv`);
          }
          let coresData = [];
          let coresLabels = []
          coresByApplicationData.forEach(data => {
            coresData.push(data.totalCores);
            coresLabels.push(data.jobApplication);
          })
          this.coresByApplicationChartData['datasets'][0].data = coresData;
          this.coresByApplicationChartData['labels'] = coresLabels;
          this.coresByApplicationChartOptions = {
            ...this.coresByApplicationChartOptions,
            plugins: {
              ...this.coresByApplicationChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Cores By Application - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          console.error("Error in loading cores by application data", err);
        },
        complete: () => {
          // this.spinner.hide("loadingGraphs");
        }
      });
    }
    catch (e) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loading cores by application data", e);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  loadCoreHoursByUsers(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      let uNames = this.graphFilterForm.value?.coreHourUserNames?.map(un => un.item_text);
      if (uNames.length == 0) {
        this.snackbar.open("Please select minimum 1 user to proceed.", "Ok", { duration: 4000 });
        this.spinner.hide("loadingGraphs");
        return;
      }
      this.chartService.getCoreHoursByUsersData(this.depName, this.dateFilterValue, uNames.join(",")).subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          this.coreHoursByUsersChartData['datasets'][0].data = [];
          this.coreHoursByUsersChartData['labels'] = [];
          this.coreHoursByUsersPieData['datasets'][0].data = [];
          this.coreHoursByUsersPieData['labels'] = [];

          this.loadTabularData(JSON.parse(JSON.stringify(data)));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(data, headers, `${Graphs.CoreHoursByUsers}-${this.depName}.csv`);
          }
          let coreHourByUsers = <CoreHoursByUsers[]>JSON.parse(JSON.stringify(data));
          coreHourByUsers = coreHourByUsers.sort((a, b) => b.jobCores - a.jobCores);
          let limit = 15;
          let colors = [];
          coreHourByUsers.forEach((job, i) => {
            if (i < limit) {
              this.coreHoursByUsersPieData['datasets'][0].data.push(job.jobCores);
              this.coreHoursByUsersPieData['labels'].push(`${job.userProfileId}`);
              this.coreHoursByUsersChartData['datasets'][0].data.push(job.jobCores);
              this.coreHoursByUsersChartData['labels'].push(`${job.userProfileId}`);
              colors.push(this.getDynamicColor());
            }
          });
          if (coreHourByUsers.length > limit) {
            this.coreHoursByUsersPieData['datasets'][0].data.push(coreHourByUsers.slice(limit).reduce((a, b) => a + b.jobCores, 0));
            this.coreHoursByUsersPieData['labels'].push(`Others`);
            this.coreHoursByUsersChartData['datasets'][0].data.push(coreHourByUsers.slice(limit).reduce((a, b) => a + b.jobCores, 0));
            this.coreHoursByUsersChartData['labels'].push(`Others`);
            colors.push(this.getDynamicColor());
          }
          this.coreHoursByUsersChartData['datasets'][0].backgroundColor = "#0072c6";
          this.coreHoursByUsersChartData['datasets'][0].borderColor = "#0072c6";
          this.coreHoursByUsersChartData['datasets'][0].hoverBorderColor = "#0072c6";
          this.coreHoursByUsersChartData['datasets'][0].hoverBackgroundColor = "#0072c6";

          this.coreHoursByUsersPieColors = [{
            backgroundColor: colors
          }];
          this.coreHoursByUsersChartOptions = {
            ...this.coreHoursByUsersChartOptions,
            plugins: {
              ...this.coreHoursByUsersChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Users - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.coreHoursByUsersPieOptions = {
            ...this.coreHoursByUsersPieOptions,
            plugins: {
              ...this.coreHoursByUsersPieOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Users - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };

          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          console.error("Error in loading core hours by users data", err);
        },
        complete: () => {
          // this.spinner.hide("loadingGraphs");
        }
      });
    }
    catch (e) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loading core hours by users data", e);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  getPrimeNonPrimeCoreHours(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService.getPrimeNonPrimeCoresHoursData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data) => {
          this.spinner.hide('loadingGraphs')
          this.primeCoreUsageChartData['datasets'].forEach(d => { d.data = [] });
          this.primeCoreUsageChartData['labels'] = [];
          this.nonPrimeCoreUsageChartData['datasets'].forEach(d => { d.data = [] });
          this.nonPrimeCoreUsageChartData['labels'] = [];
          this.loadTabularData(JSON.parse(JSON.stringify(data)));

          let primeNonPrimeHoursData = <PrimeNonPrimCoresDataI>JSON.parse(JSON.stringify(data));

          if (toDownload) {
            let headers = Object.keys(primeNonPrimeHoursData.primeHours[0]);
            this.downloadCsv(primeNonPrimeHoursData.primeHours, headers, `PrimeHourUsage-${this.depName}.csv`);
            headers = Object.keys(primeNonPrimeHoursData.nonPrimeHours[0]);
            this.downloadCsv(primeNonPrimeHoursData.nonPrimeHours, headers, `NonPrimeHourUsage-${this.depName}.csv`);
          }

          let usedColors = [];
          let queuedColors = [];

          primeNonPrimeHoursData.primeHours?.forEach(data => {
            this.primeCoreUsageChartData['datasets'][0].data.push(data.usedCores);
            this.primeCoreUsageChartData['datasets'][1].data.push(data.queuedCores);
            usedColors.push("#0072c6")
            queuedColors.push("#C4B0FF")
            let date;
            if (this.granularityValue == "One Hour") {
              date = formatDate(new Date(data.timeStamp), "h:mm aa", "en-US").split(")")[0];
            } else {
              date = formatDate(new Date(data.timeStamp), "mediumDate", "en-US").split(",")[0];
            }
            this.primeCoreUsageChartData['labels'].push(date);
          })
          this.primeCoreUsageChartData['datasets'][0].backgroundColor = usedColors;
          this.primeCoreUsageChartData['datasets'][0].hoverBackgroundColor = usedColors;
          this.primeCoreUsageChartData['datasets'][1].backgroundColor = queuedColors;
          this.primeCoreUsageChartData['datasets'][1].hoverBackgroundColor = queuedColors;
          this.updateGraphs();

          usedColors = [];
          queuedColors = [];

          primeNonPrimeHoursData.nonPrimeHours?.forEach(data => {
            this.nonPrimeCoreUsageChartData['datasets'][0].data.push(data.usedCores);
            this.nonPrimeCoreUsageChartData['datasets'][1].data.push(data.queuedCores);
            usedColors.push("#0072c6");
            queuedColors.push("#C4B0FF");
            let date;
            if (this.granularityValue == "One Hour") {
              date = formatDate(new Date(data.timeStamp), "h:mm aa", "en-US").split(")")[0];
            } else {
              date = formatDate(new Date(data.timeStamp), "mediumDate", "en-US").split(",")[0];
            }
            this.nonPrimeCoreUsageChartData['labels'].push(date);
          })
          this.nonPrimeCoreUsageChartData['datasets'][0].backgroundColor = usedColors;
          this.nonPrimeCoreUsageChartData['datasets'][0].hoverBackgroundColor = usedColors;
          this.nonPrimeCoreUsageChartData['datasets'][1].backgroundColor = queuedColors;
          this.nonPrimeCoreUsageChartData['datasets'][1].hoverBackgroundColor = queuedColors;
          this.primeCoreUsageChartOptions = {
            ...this.primeCoreUsageChartOptions,
            plugins: {
              ...this.primeCoreUsageChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Prime - Avg Used and Queued Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.nonPrimeCoreUsageChartOptions = {
            ...this.nonPrimeCoreUsageChartOptions,
            plugins: {
              ...this.nonPrimeCoreUsageChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Non Prime - Avg Used and Queued Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        }, error: (err) => {
          this.spinner.hide('loadingGraphs')
          console.error("Error in loading prime non prime core hours data", err);
        }
      })
    }
    catch (e) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loading prime non prime core hours data", e);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  getUserName() {
    this.userService.getUserNamesForDeployment(this.depName).subscribe({
      next: (data: any) => {
        data?.forEach(d => {
          this.userNames.push({ item_id: d, item_text: d })
        })
        this.coreHourUserNames = this.userNames;
        this.graphFilterForm.controls["userNames"].setValue(this.userNames);
        this.graphFilterForm.controls["coreHourUserNames"].setValue(this.coreHourUserNames);
      },
      error: (err) => {

      }
    })
  }

  getUserGroupNames() {
    this.userService.getUserGroupNamesForDeployment(this.depName).subscribe({
      next: (data: any) => {
        data.forEach(d => {
          this.userGroupNames.push({ item_id: d, item_text: d })
        })
        this.graphFilterForm.controls["userGroupNames"].setValue(this.userGroupNames);
      },
      error: (err) => {

      }
    })
  }

  groupByApplication(obj, key) {
    return obj.reduce(function (start, current) {
      (start[current[key]] = start[current[key]] || []).push(current);
      return start;
    }, {});
  }

  groupByNodes(obj, key) {
    return obj.reduce(function (start, current) {
      if (current[key].split(",").length > 1) {
        current[key].split(",").forEach(eleKey => {
          (start[current[eleKey]] = start[current[eleKey]] || []).push({ ...current, jobAllocatedNodes: eleKey });
          return start;
        });
      } else {
        (start[current[key]] = start[current[key]] || []).push(current);
      }
      return start;
    }, {});
  }

  resetAllData() {

    this.graphStartEnd = [];
    this.graphOption = [];
    this.graphConnDiscon = [];

    this.selectedJobTag = null;


    this.failedJobs = 0;
    this.succeededJobs = 0;
    this.cancelledJobs = 0;

    this.allJobsData.datasets = [
      {
        data: [],
      },
    ];
    this.allJobsData.labels = [];
    this.queuedJobs = 0;
    this.runningJobs = 0;
    this.completedJobs = 0;

    this.storageChartLegend = false;
    this.storageChartPlugins = [];

    switch (this.selectedMetric) {
      case Graphs.JobSummary:
        this.allJobsData.datasets = [
          {
            data: [],
          },
        ];
        this.allJobsData.labels = [];
        this.allJobsOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobCompleted:
        this.jobsSummaryData.datasets = [
          {
            data: [],
          },
        ];
        this.jobsSummaryData.labels = [];
        this.jobsSummaryOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobDataCount:
        this.jobCountChartData['datasets'].forEach(d => d.data = []);
        this.jobCountChartData['labels'] = [];
        this.jobCountChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.PrimeNonPrimeJobSubmission:
        this.primeNonPrimeHoursJobsSubmissionData["datasets"]?.forEach((d) => (d.data = []));
        this.primeNonPrimeHoursJobsSubmissionData["labels"] = [];
        this.primeNonPrimeHoursJobsSubmissionOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobByApplication:
        this.jobByApplicationData.datasets.forEach((d) => (d.data = []));
        this.jobByApplicationData["labels"] = [];
        this.jobByApplicationOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobByNodes:
      case Graphs.JobByNodeGroup:
        this.jobByNodesData['datasets'].forEach(d => d.data = []);
        this.jobByNodesData['labels'] = [];
        this.jobByNodesOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.RunningQueuedJobsPerNodeGroup:
        this.runningQueuedJobsPerNodeGroupChartData["datasets"]?.forEach((d) => (d.data = []))
        this.runningQueuedJobsPerNodeGroupChartData["labels"] = [];
        this.runningQueuedJobsPerNodeGroupChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobWaitTime:
        this.jobWaitTimeChartData['datasets'].forEach(d => d.data = []);
        this.jobWaitTimeChartData['labels'] = [];
        this.jobWaitTimeChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobByUser:
        this.jobByUserChartData["datasets"].forEach((d) => (d.data = []));
        this.jobByUserChartData["labels"] = [];
        this.jobByUserChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobByGroup:
        this.jobByGroupChartData['datasets'].forEach(d => d.data = []);
        this.jobByGroupChartData['labels'] = [];
        this.jobByGroupChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobByTags:
        this.jobByTagsData["datasets"].forEach((d) => (d.data = []));
        this.jobByTagsData["labels"] = [];
        this.jobByTagsOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobByTagsPerDay:
        this.jobByTagsPerDayChartData["datasets"] = [];
        this.jobByTagsPerDayChartData["labels"] = [];
        this.jobByTagsPerDayChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.StorageUsage:
        this.storageChartData.datasets.forEach(d => d.data = []);
        this.storageChartData.labels = [];
        this.storageChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CoresByApplication:
        this.coresByApplicationChartData['datasets'].forEach(d => d.data = []);
        this.coresByApplicationChartData['labels'] = [];
        this.coresByApplicationChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CoreHoursByUsers:
        this.coreHoursByUsersChartData['datasets'][0].data = [];
        this.coreHoursByUsersChartData['labels'] = [];
        this.coreHoursByUsersPieData['datasets'][0].data = [];
        this.coreHoursByUsersPieData['labels'] = [];
        this.coreHoursByUsersChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CoreHoursByGroups:
        this.coreHoursByGroupsPieData['datasets'][0].data = [];
        this.coreHoursByGroupsPieData['labels'] = [];
        this.coreHoursByGroupsChartData['datasets'][0].data = [];
        this.coreHoursByGroupsChartData['labels'] = [];
        this.coreHoursByGroupsChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CoreUsage:
        this.coresPerDayData.labels = [];
        this.coresPerDayData.datasets.forEach(d => d.data = []);
        this.coresPerDayOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.NodeAvailability:
        this.nodeAvailabilityData['datasets'].forEach(d => d.data = []);
        this.nodeAvailabilityData['labels'] = [];
        this.nodeAvailabilityChartOptions.plugins.title.text = ''
        this.updateGraphs();
        break;

      case Graphs.NodeUtilization:
      case Graphs.SingleNodeUtilization:
      case Graphs.NodeUtilizationByNodeGroup:
        this.nodeUtilizationDataTotal['datasets'].forEach(d => d.data = []);
        this.nodeUtilizationDataTotal['labels'] = [];
        this.nodeUtilizationDataOffice['datasets'].forEach(d => d.data = []);
        this.nodeUtilizationDataOffice['labels'] = [];
        this.nodeUtilizationDataNonOffice['datasets'].forEach(d => d.data = []);
        this.nodeUtilizationDataNonOffice['labels'] = [];
        this.nodeUtilizationOptionsTotal = {
          ...this.nodeUtilizationOptionsTotal,
          scales: {
            ...this.nodeUtilizationOptionsTotal.scales,
            'y-axis-0': {
              ...this.nodeUtilizationOptionsTotal.scales['y-axis-0'],
              max: 100,
            }
          }
        };
        // Update Office hours chart options
        this.nodeUtilizationOptionsTotalOffice = {
          ...this.nodeUtilizationOptionsTotalOffice,
          scales: {
            ...this.nodeUtilizationOptionsTotalOffice.scales,
            'y-axis-0': {
              ...this.nodeUtilizationOptionsTotalOffice.scales['y-axis-0'],
              max: 100,
            }
          }
        };
        // Update Non-office hours chart options
        this.nodeUtilizationOptionsNonOffice = {
          ...this.nodeUtilizationOptionsNonOffice,
          scales: {
            ...this.nodeUtilizationOptionsNonOffice.scales,
            'y-axis-0': {
              ...this.nodeUtilizationOptionsNonOffice.scales['y-axis-0'],
              max: 100,
            }
          }
        };
        this.updateGraphs();
        break;

      case Graphs.ActiveSessions:
        this.activeSessionsByProfileDataTotal.datasets = [];
        this.activeSessionsByProfileDataTotal.labels = [];
        this.activeSessionsByProfileOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.PrimeNonPrimeCoreUsage:
        this.primeCoreUsageChartData['datasets'].forEach(d => { d.data = [] });
        this.primeCoreUsageChartData['labels'] = [];
        this.nonPrimeCoreUsageChartData['datasets'].forEach(d => { d.data = [] });
        this.nonPrimeCoreUsageChartData['labels'] = [];
        this.primeCoreUsageChartOptions.plugins.title.text = '';
        this.nonPrimeCoreUsageChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.HpcUnitsConsumed:
        this.hpcUnitsConsumedDataTotal.datasets[0].data = [];
        this.hpcUnitsConsumedDataTotal.labels = [];
        this.hpcUnitsConsumedOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CpuUsageByNodes:
        this.cpuUsageByNodesChartData.datasets.forEach(d => d.data = []);
        this.cpuUsageByNodesChartData.labels = [];
        this.cpuUsageByNodesChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CpuUsageByNodeGroups:
        this.cpuUsageByNodeGroupsChartData.datasets.forEach(d => d.data = []);
        this.cpuUsageByNodeGroupsChartData.labels = [];
        this.cpuUsageByNodeGroupsChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CoreUsageByNodes:
        this.coreUsageByNodesChartData.datasets.forEach(d => d.data = []);
        this.coreUsageByNodesChartData.labels = [];
        this.coreUsageByNodesChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.CoreUsageByNodeGroups:
        this.coreUsageByNodeGroupsChartData.datasets.forEach(d => d.data = []);
        this.coreUsageByNodeGroupsChartData.labels = [];
        this.coreUsageByNodeGroupsChartOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobDurationsByDay:
        this.jobDurationsByDayData["datasets"].forEach((d) => (d.data = []));
        this.jobDurationsByDayData["labels"] = [];
        this.jobDurationsByDayOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.JobsByUserByDay:
        this.jobsByUserByDayData.datasets[0].data = [];
        this.jobsByUserByDayData.datasets[1].data = [];
        this.jobsByUserByDayData.datasets[2].data = [];
        this.jobsByUserByDayData.labels = [];
        this.jobsByUserByDayOptions.plugins.title.text = '';
        this.updateGraphs();
        break;

      case Graphs.NodeStartStopStatus:
        this.nodeStatusTimelineChartData.dataTable = [];
        this.updateGraphs();
        break;
    }
  }

  loadAllCharts() {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    try {
      this.chartService
        .getAllCharts(
          this.depName,
          this.dateFilterValue,
          this.granularityValue,
          this.userSelected
        )
        // .pipe(takeUntil(this.graphRequests[this.selectedMetric]))
        .subscribe({
          next: (data) => {
            this.allChartsData = JSON.parse(JSON.stringify(data));
            let storageUsage = [];
            if (this.allChartsData && this.allChartsData['coreUsage']?.length != 0) {
              this.daysValue =
                'From ' +
                new DatePipe('en-US').transform(
                  this.allChartsData['coreUsage'][0]
                    ? new Date(this.allChartsData['coreUsage'][0].timeStamp)
                    : new Date(),
                  'yyyy-MM-dd, HH:mm:ss'
                ) +
                ' To ' +
                new DatePipe('en-US').transform(
                  new Date(
                    this.allChartsData['coreUsage'][
                      this.allChartsData['coreUsage']?.length - 1
                    ].timeStamp
                  ),
                  'yyyy-MM-dd, HH:mm:ss'
                );
            } else {
              this.daysValue = 'From - to -'
            }
            let medRunCoresData = [];
            let avgRunCoresData = [];
            this.coresPerDayData['datasets'].forEach((d) => (d.data = []));
            this.coresPerDayData['labels'] = [];
            let runningCores = this.allChartsData['coreUsage'].map(d => d.runningCores)
            let totalRunningCores = runningCores?.map(d => d.runningCores).reduce((sum, current) => sum + current, 0) || 0;
            let totalRunningCoresAverage = Math.round(totalRunningCores / this.allChartsData['coreUsage'].length) || 0;
            let median = this.calculateMedian(runningCores);
            this.allChartsData['coreUsage'].forEach((data) => {
              this.coresPerDayData.datasets[0].data.push(data.queuedCores);
              runningCores.push(data.runningCores);
              this.coresPerDayData.datasets[1].data.push(data.runningCores);
              this.coresPerDayData.datasets[3].data.push(data.activeCores);
              this.realActiveCores.push(data.activeCores);
              avgRunCoresData.push(totalRunningCoresAverage);
              medRunCoresData.push(median);
              let date;
              if (this.granularityValue == 'One Hour') {
                date = formatDate(
                  new Date(data.timeStamp),
                  'shortTime',
                  'en-US'
                ).split(',')[0];
              } else {
                date = formatDate(
                  new Date(data.timeStamp),
                  'longDate',
                  'en-US'
                ).split(',')[0];
              }
              this.coresPerDayData.labels.push(date);
            });
            this.coresPerDayData.datasets[2].data = avgRunCoresData;
            this.coresPerDayData.datasets[4].data = medRunCoresData;

            this.coresPerDayOptions = {
              ...this.coresPerDayOptions,
              plugins: {
                legend: {
                  position: "bottom",
                },

                title: {
                  display: true,
                  text: `Average Core Usage - ${totalRunningCoresAverage} Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: "top",
                },
                datalabels: {
                  anchor: "end",
                  align: "end",
                  display: false
                },
              },
            };

            //storageusage
            this.storageChartData.datasets[0].data = [];
            this.storageChartData.labels = [];
            this.allChartsData['storageUsage'].forEach((data) => {
              storageUsage.push(data.storageUsage);
              this.storageChartData.datasets[0].data.push(data.storageUsage);
              let date;
              if (this.granularityValue == 'One Hour') {
                date = formatDate(
                  new Date(data.timeStamp),
                  'shortTime',
                  'en-US'
                ).split(',')[0];
              } else {
                date = formatDate(
                  new Date(data.timeStamp),
                  'longDate',
                  'en-US'
                ).split(',')[0];
              }
              this.storageChartData.labels.push(date);
            });
            this.storageChartOptions = {
              ...this.storageChartOptions,
              scales: {
                x: {},
                y: {
                  beginAtZero: true,
                },
              },
              plugins: {
                ...this.storageChartOptions.plugins,
                title: {
                  display: true,
                  text: `Storage Usage (GB) - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: 'top',
                },
              },
            };
            this.queuedJobs = this.allChartsData['queuedJobCount'];
            this.runningJobs = this.allChartsData['runningJobCount'];
            this.completedJobs = this.allChartsData['completedJobCount'];
            this.allJobsData.datasets[0].data = [];
            if (this.queuedJobs != 0) {
              this.allJobsData.datasets[0].data.push(
                this.queuedJobs,
              );
            }
            else {
              this.allJobsData.datasets[0].data.push(
                null
              );
            }
            if (this.runningJobs != 0) {
              this.allJobsData.datasets[0].data.push(
                this.runningJobs
              );
            }
            else {
              this.allJobsData.datasets[0].data.push(
                null
              );
            }
            if (this.completedJobs != 0) {
              this.allJobsData.datasets[0].data.push(
                this.completedJobs
              );
            }
            else {
              this.allJobsData.datasets[0].data.push(
                null
              );
            }
            this.allJobsData.labels = [];
            this.allJobsData.labels.push('Queued', 'Running', 'Completed');
            this.jobsSummaryData.datasets[0].data = [];
            this.jobsSummaryData.labels = [];
            this.allJobsOptions = {
              responsive: false,
              plugins: {
                legend: {
                  position: 'bottom',
                  labels: {
                    boxWidth: 15,
                  },
                },
                title: {
                  display: true,
                  text: `Job Status Summary - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: 'top',
                },
                datalabels: {
                  formatter: (value) => {
                    var perc = value;
                    return perc;
                  },
                },
              },
            };
            this.failedJobs = this.allChartsData['failedJobCount'];
            this.cancelledJobs = this.allChartsData['canceledJobCount'];
            this.succeededJobs = this.allChartsData['succeedJobCount'];
            this.jobsSummaryData.datasets[0].data.push(
              this.failedJobs,
              this.cancelledJobs,
              this.succeededJobs
            );
            this.totalJobsCompleted =
              this.failedJobs + this.cancelledJobs + this.succeededJobs;
            this.jobsSummaryData.labels.push('Failed', 'Cancelled', 'Succeeded');
            this.jobsSummaryOptions = {
              responsive: false,
              plugins: {
                legend: {
                  position: 'bottom',
                  labels: {
                    boxWidth: 15,
                  },
                },
                title: {
                  display: true,
                  text: 'Completed Jobs : ' + this.totalJobsCompleted + ` - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                  position: 'top',
                },
                datalabels: {
                  formatter: (value) => {
                    var perc = value;
                    return perc;
                  },
                  display: (context) => {
                    return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.coreUsageByNodeGroupsChartData.datasets[0].data, 0);
                  },
                },
              },
            };
            this.updateGraphs();
            this.spinner.hide("loadingGraphs");
          },
          error: (error) => {
            this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (e) {
      this.spinner.hide("loadingGraphs");
    }

    this.primeNonPrimeHoursJobsSubmissionData["datasets"]?.forEach((d) => (d.data = []));
    this.primeNonPrimeHoursJobsSubmissionData["labels"] = [];
    this.primeNonPrimeHoursJobsSubmissionOptions.plugins.title.text = '';
    this.loadJobDataCount();
    this.loadJobByApplicationData();
    this.getPrimeNonPrimeHoursJobSubmissions();
  }

  applyFilters(
    metric,
    selectedUser,
    date,
    granularity,
    wsName,
    user,
    application, toDownload?: boolean
  ) {
    try {
      this.disableApplyFilter = true;
      this.dateFilterValue = date;
      this.snackbar.dismiss();
      if (date?.indexOf('hr') != -1) {
        let days = date.trim().slice(0, -2);
        if (parseInt(days) <= 0 || parseInt(days) > 24) {
          this.snackbar.open("Hour value should be between 1 to 24", "Ok", { duration: 5000 });
          this.spinner.hide("loadingGraphs");
          return;
        }
      }
      if (this.graphRequests[this.selectedMetric]) {
        this.graphRequests[this.selectedMetric].next();
        this.graphRequests[this.selectedMetric].complete();
      }
      //this.spinner.show("loadingGraphs")
      this.graphRequests[this.selectedMetric] = new Subject();
      this.metricValue = '';
      let metricWord = this.selectedMetric.split(/(?=[A-Z])/);
      metricWord.forEach((x) => {
        this.metricValue = this.metricValue + x + ' ';
      });
      this.userValue = user;
      this.wsNameValue = wsName;
      // this.selectedMetric = metric;
      if (date == "custom") {
        let startDate = formatDate(new Date(this.dateTimePeriod.value[0]), "dd/MM/yy", "en-US").split("/").join("-");
        let endDate = formatDate(new Date(this.dateTimePeriod.value[1]), "dd/MM/yy", "en-US").split("/").join("-");
        this.dateFilterValue = startDate + "to" + endDate;

        let newStartDate = new Date(this.dateTimePeriod.value[0]);
        let newEndDate = new Date(this.dateTimePeriod.value[1]);

        const differenceInMilliseconds = newEndDate.getTime() - newStartDate.getTime();
        this.differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

        if (this.differenceInDays == 0 || this.differenceInDays == 1) {
          this.granularityValue = Granularity.OneHour;
        } else {
          this.granularityValue = Granularity.OneDay;
        }
      } else {
        this.dateFilterValue = date;
      }
      this.selectedUser = selectedUser;
      this.userSelected = user;
      this.appSelected = application;
      if (this.selectedMetric == 'all') {
        this.resetAllData();
        this.updateResponsiveFlag(false)
        if (this.isVdi) {
          this.loadNodeUtilization(null, toDownload);
        }
        else {
          this.loadAllCharts();
        }
      } else {
        this.manageActiveChartType();
        this.updateResponsiveFlag(false)
        if (this.selectedMetric == Graphs.StorageUsage) {
          this.loadStorageCharts(toDownload);
        }
        else if (this.selectedMetric == Graphs.CoreUsage) {
          this.loadCoresPerDay(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobCompleted) {
          this.loadJobSummary(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobSummary) {
          this.loadCompletedJobs(toDownload);
        }
        else if (this.selectedMetric == Graphs.NodeUtilization) {
          if (this.wsNames.length == 0) {
            this.snackbar.open(
              'No Workstation Attached To This Deployment...',
              'Ok',
              {
                duration: 5000,
              }
            );
            this.spinner.hide("loadingGraphs")
            return;
          } else {
            this.loadNodeUtilization(null, toDownload);
          }
        }
        else if (this.selectedMetric == Graphs.SessionGraph) {
          if (this.selectedUser === 'none') {
            this.snackbar.open('Please select the User.', 'Ok', {
              duration: 5000,
            });
            this.spinner.hide("loadingGraphs")
            return;
          }
          this.getSessionData('Connect-Disconnect', toDownload);
          this.getSessionData('Start-End', toDownload);
        }
        else if (this.selectedMetric == Graphs.JobDataCount) {
          this.loadJobDataCount(toDownload);
        }
        else if (this.selectedMetric == Graphs.SingleNodeUtilization && wsName != 'none') {
          this.loadSingleNodeUtilization(wsName, toDownload);
        }
        else if (this.selectedMetric == Graphs.SingleNodeUtilization && wsName == 'none') {
          this.snackbar.open('Please Select Workstation...', 'Ok', {
            duration: 5000,
          });
          this.spinner.hide("loadingGraphs")
          return;
        }
        else if (this.selectedMetric == Graphs.JobByApplication) {
          this.loadJobByApplicationData(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobByNodes) {
          this.loadJobByNodesData(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobByNodeGroup) {
          this.loadJobByNodeGraphData(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobWaitTime) {
          this.loadJobWaitTimeData(toDownload);
        }
        else if (this.selectedMetric == Graphs.NodeAvailability) {
          this.loadNodeAvailabilityDataCount(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobByUser) {
          this.loadJobByUserData(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobByGroup) {
          this.loadJobByGroupsData(toDownload);
        }
        else if (this.selectedMetric == Graphs.CoresByApplication) {
          this.loadCoresByApplication(toDownload);
        }
        else if (this.selectedMetric == Graphs.CoreHoursByUsers) {
          this.loadCoreHoursByUsers(toDownload);
        }
        else if (this.selectedMetric == Graphs.PrimeNonPrimeCoreUsage) {
          this.getPrimeNonPrimeCoreHours(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobByTags) {
          this.loadJobByTagsData(toDownload);
        }
        else if (this.selectedMetric == Graphs.ActiveSessions) {
          this.getActiveSessionsPerDeployment(this.depName, toDownload);
        }
        else if (this.selectedMetric == Graphs.AllUserSessions) {
          this.getSessionDataPerUser();
        }
        else if (this.selectedMetric == Graphs.CoreHoursByGroups) {
          this.loadCoreHoursByGroups(toDownload);
        }
        else if (this.selectedMetric == Graphs.NodeStartStopStatus) {
          this.getNodeStatusGraph();
        }
        else if (this.selectedMetric == Graphs.HpcUnitsConsumed) {
          this.getHpcUnitsConsumedGraph(toDownload);
        }
        else if (this.selectedMetric == Graphs.NodeUtilizationByNodeGroup) {
          if (this.nodeGroupValue == 'none') {
            this.snackbar.open('Please Select Node Group...', 'Ok', {
              duration: 5000,
            });
            this.spinner.hide("loadingGraphs")
            return;
          }
          else {
            this.loadNodeUtilization(this.nodeGroupValue, toDownload);
          }
        }
        else if (this.selectedMetric == Graphs.CpuUsageByNodes) {
          this.cpuUsageByNodes(toDownload);
        }
        else if (this.selectedMetric == Graphs.CpuUsageByNodeGroups) {
          this.cpuUsageByNodeGroups(toDownload);
        }
        else if (this.selectedMetric == Graphs.CoreUsageByNodes) {
          this.coreUsageByNodes(toDownload);
        }
        else if (this.selectedMetric == Graphs.CoreUsageByNodeGroups) {
          this.coreUsageByNodeGroups(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobDurationsByDay) {
          this.loadAvgJobDurationsByDayData(toDownload);
        }
        else if (this.selectedMetric == Graphs.JobByTagsPerDay) {
          this.loadJobByTagsPerDayData(toDownload);
        }
        else if (this.selectedMetric == Graphs.RunningQueuedJobsPerNodeGroup) {
          this.loadRunningQueuedJobsPerNodeGroupsData(toDownload)
        } else if (this.selectedMetric == Graphs.PrimeNonPrimeJobSubmission) {
          this.getPrimeNonPrimeHoursJobSubmissions(toDownload)
        }
        else if (this.selectedMetric == Graphs.JobsByUserByDay) {
          this.getJobsByUserByDay(toDownload);
        }
      }
      this.graphDataLabelsForm.reset({
        jobCountSubmitted: false,
        jobCountSucceeded: false,
        jobCountCancelled: false,
        jobCountFailed: false,
        storageUsage: false,
        coresByApplication: false,
      });
    }
    catch (error) {
      this.disableApplyFilter = false;
    }
    finally {
      this.disableApplyFilter = false;
    }
  }

  downloadJobData() {
    let dialog = this.dialog.open(JobInfoDownloadComponent, {
      width: '40%',
      autoFocus: true,
      disableClose: true,
      data: { depName: this.depName },
    });
    dialog.afterClosed().subscribe((res: string[]) => {
      if (res) {
        this.jobService.getJobDownloadInfo(this.depName, this.dateFilterValue).subscribe({
          next: (data: any) => {
            try {
              this.snackbar.open('Job info will be downloaded soon...');
              let infoes: Job[] = JSON.parse(JSON.stringify(data));
              const redux = this.filterOutJobInfo(infoes, res);
              const ids = redux.map((o) => o.jobName);
              const filtered = redux.filter(
                ({ jobName }, index) => !ids.includes(jobName, index + 1)
              );
              this.downloadCsv(filtered, res, `jobInfo_${this.depName}.csv`);
              this.snackbar.dismiss();
            } catch (error) {
              this.snackbar.dismiss();
            }
          },
          error: (err) => {
            if (err.error.actionMessage) {
              this.snackbar.open(err.error.actionMessage, 'Ok', {
                duration: 5000,
              });
            }
          },
        });
      }
    });
  }

  downloadSessionInfo() {
    this.sessionService.downloadSessionInfo().subscribe({
      next: (data: any) => {
        try {
          let infoes = <Session[]>JSON.parse(JSON.stringify(data));

          if (infoes.length > 0) {
            let keys = Object.keys(infoes[0]);
            let newInfoes = infoes?.map((sess) => {
              return {
                ...sess,
                apps: sess.apps?.join(' | '),
              };
            });
            this.downloadCsv(newInfoes, keys, 'sessionInfo');
          }
          else {
            throw new Error('No Session Info to download');
          }
        } catch (error) {
          this.snackbar.open(error.message, 'Ok', {
            duration: 5000,
          });
        }
      },
      error: (err) => {
        if (err.error.actionMessage) {
          this.snackbar.open(err.error.actionMessage, 'Ok', {
            duration: 5000,
          });
        }
      },
    });
  }

  downloadCsv(infos, headers, fileName) {
    let makeUpper = new MakeUpperPipe();
    headers.map(head => head = head.charAt(0).toUpperCase() + head.slice(1)).forEach((head, index) => {
      headers[index] = makeUpper.transform(head);
    });

    const header = headers;
    let csv = infos.map(action =>
      Object.keys(action)
        .map(key => action[key])
        .join(",")
    );
    if (csv.every(c => c == "")) {
      csv = [infos.join(',')];
    }
    csv.unshift(header.join(","));
    let csvArray = csv.join(" \r\n ");

    var blob = new Blob([csvArray], { type: "text/csv" });
    saveAs(blob, fileName);
  }

  downloadAllCanvas() {
    for (
      let index = 0;
      index < document.getElementsByTagName('canvas').length;
      index++
    ) {
      let elementAnchor = document.createElement('a');
      document.body.appendChild(elementAnchor);
      elementAnchor.setAttribute('style', 'display: none');
      let element = document.getElementsByTagName('canvas')[index];
      elementAnchor.href = element.toDataURL();
      elementAnchor.download = `${element.id}.jpg`;
      elementAnchor.click();
      elementAnchor.remove();
      this.actionLogService.addActionLog(
        this.depName,
        'Report Downloaded',
        `${element.id}`,
        'Deployment',
        `Downloaded Report of ${element.id}`
      );
    }
  }

  filterOutJobInfo(array: any, keys_to_keep) {
    let tempArr = [];
    array.map((o) =>
      keys_to_keep.reduce((acc, curr) => {
        let resWord = curr.charAt(0).toLowerCase() + curr.slice(1);
        acc[resWord] = o[resWord];
        tempArr.push(acc);
        return acc;
      }, {})
    );
    return tempArr;
  }

  loadNodeUtilization(nodeGroup?: string, toDownload?: boolean) {
    this.spinner.show("loadingGraphs")
    this.resetAllData();
    try {
      let group = '';
      if (nodeGroup) {
        group = nodeGroup;
      }
      this.chartService
        .getNodeUsage(
          this.depName,
          Graphs.NodeUtilization,
          this.dateFilterValue,
          this.granularityValue,
          this.userSelected,
          '',
          false,
          group
        )
        .subscribe({
          next: (data) => {
            this.spinner.hide("loadingGraphs")
            this.nodeUtilizationDataTotal['datasets'].forEach(d => d.data = []);
            this.nodeUtilizationDataTotal['labels'] = [];
            this.nodeUtilizationDataOffice['datasets'].forEach(d => d.data = []);
            this.nodeUtilizationDataOffice['labels'] = [];
            this.nodeUtilizationDataNonOffice['datasets'].forEach(d => d.data = []);
            this.nodeUtilizationDataNonOffice['labels'] = [];
            this.nodeUtilization = <NodeUsage[]>JSON.parse(JSON.stringify(data));

            if (this.nodeUtilization && this.nodeUtilization?.length != 0) {
              this.daysValue =
                'From ' +
                new DatePipe('en-US').transform(
                  this.nodeUtilization[0]
                    ? new Date(this.nodeUtilization[0].timeStamp)
                    : new Date(),
                  'yyyy-MM-dd, HH:mm:ss'
                ) +
                ' To ' +
                new DatePipe('en-US').transform(
                  new Date(
                    this.nodeUtilization[this.nodeUtilization.length - 1]
                      .timeStamp
                  ),
                  'yyyy-MM-dd, HH:mm:ss'
                );
            } else {
              this.daysValue = 'From - to -'
            }

            let dateFilter = this.dateFilterValue;
            if (this.dateFilterValue.indexOf('hr') != -1 || this.dateFilterValue.indexOf('days') != -1) {
              dateFilter = this.dateFilterValue.indexOf('hr') != -1 ? this.dateFilterValue.trim().slice(0, -2).trim() : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            //const uniqueDates = [...new Set(this.nodeUtilization.map(item => item.timeStamp))];
            let uniqueDates;
            if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
              uniqueDates = [
                ...new Set(
                  this.nodeUtilization.map(
                    (item) =>
                      formatDate(
                        new Date(item.timeStamp),
                        'mediumDate',
                        'en-US'
                      ).split(',')[0]
                  )
                ),
              ];
            } else {
              uniqueDates = [
                ...new Set(this.nodeUtilization.map((item) => item.timeStamp)),
              ];
            }
            this.nodeUtilization.forEach((x) => {
              if (x.officeHours == 1) {
                this.nodeUtilizationDataOffice.datasets[0].data.push(x.cpuPercent);
                this.nodeUtilizationDataOffice.datasets[1].data.push(x.ramPercent);
                this.nodeUtilizationDataOffice.datasets[2].data.push(x.gpuPercent);
                this.nodeUtilizationDataOffice.datasets[3].data.push(
                  x.gpuMemoryUsage
                );
                let date;
                if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'mediumDate',
                    'en-US'
                  ).split(',')[0];
                } else {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'h:mm aa',
                    'en-US'
                  ).split(')')[0];
                }
                this.nodeUtilizationDataOffice.labels.push(date);
              } else if (x.officeHours == 0) {
                this.nodeUtilizationDataNonOffice.datasets[0].data.push(
                  x.cpuPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[1].data.push(
                  x.ramPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[2].data.push(
                  x.gpuPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[3].data.push(
                  x.gpuMemoryUsage
                );
                let date;
                if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'mediumDate',
                    'en-US'
                  ).split(',')[0];
                } else {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'h:mm aa',
                    'en-US'
                  ).split(')')[0];
                }
                this.nodeUtilizationDataNonOffice.labels.push(date);
              }
            });
            uniqueDates.forEach((unq) => {
              let count = 0;
              let ramUsage = 0;
              let cpuUsage = 0;
              let gpuUsage = 0;
              let gpuMemoryUsage = 0;
              this.nodeUtilization.forEach((n) => {
                if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                  if (
                    formatDate(new Date(n.timeStamp), 'mediumDate', 'en-US').split(
                      ','
                    )[0] === unq
                  ) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                } else {
                  if (n.timeStamp === unq) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                }
              });
              this.nodeUtilizationDataTotal.datasets[0].data.push(cpuUsage / count);
              this.nodeUtilizationDataTotal.datasets[1].data.push(ramUsage / count);
              this.nodeUtilizationDataTotal.datasets[2].data.push(gpuUsage / count);
              this.nodeUtilizationDataTotal.datasets[3].data.push(
                gpuMemoryUsage / count
              );
              let date;
              if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                date = formatDate(new Date(unq), 'mediumDate', 'en-US').split(
                  ','
                )[0];
              } else {
                date = formatDate(new Date(unq), 'h:mm aa', 'en-US').split(')')[0];
              }
              this.nodeUtilizationDataTotal.labels.push(date);
            });

            const totalMax = this.calculateDynamicMax(this.nodeUtilizationDataTotal.datasets);
            const officeMax = this.calculateDynamicMax(this.nodeUtilizationDataOffice.datasets);
            const nonOfficeMax = this.calculateDynamicMax(this.nodeUtilizationDataNonOffice.datasets);

            this.nodeUtilizationOptionsTotal = {
              ...this.nodeUtilizationOptionsTotal,
              scales: {
                ...this.nodeUtilizationOptionsTotal.scales,
                'y-axis-0': {
                  ...this.nodeUtilizationOptionsTotal.scales['y-axis-0'],
                  max: totalMax,
                }
              }
            };

            // Update Office hours chart options
            this.nodeUtilizationOptionsTotalOffice = {
              ...this.nodeUtilizationOptionsTotalOffice,
              scales: {
                ...this.nodeUtilizationOptionsTotalOffice.scales,
                'y-axis-0': {
                  ...this.nodeUtilizationOptionsTotalOffice.scales['y-axis-0'],
                  max: officeMax,
                }
              }
            };

            // Update Non-office hours chart options
            this.nodeUtilizationOptionsNonOffice = {
              ...this.nodeUtilizationOptionsNonOffice,
              scales: {
                ...this.nodeUtilizationOptionsNonOffice.scales,
                'y-axis-0': {
                  ...this.nodeUtilizationOptionsNonOffice.scales['y-axis-0'],
                  max: nonOfficeMax,
                }
              }
            };

            this.updateGraphs();
          },
          error: (error) => {
            this.spinner.hide("loadingGraphs");
            this.snackbar.open("Unable to load the data.", "Ok", { duration: 3000 });
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs")
      console.error('error in loadNodeUtilization', error);
    }
    finally {
      // this.spinner.hide("loadingGraphs")
    }
  }

  optionClicked() {
    this.resetAllData();
    this.snackbar.open('Please click on "Apply Filter" after selecting the option.');
    if (this.selectedMetric == 'SessionGraph') {
      this.userFilterFlag = false;
    }
    else if (this.selectedMetric === 'SingleNodeUtilization') {
      if (this.wsNames.length == 0) {
        this.snackbar.open(
          'No Workstation Attached To This Deployment...',
          'Ok',
          {
            duration: 5000,
          }
        );
        return;
      } else {
        this.SingleNodeUtilizationValue = true;
      }
    }
    else if (this.selectedMetric == Graphs.JobByTagsPerDay) {
      if (this.jobTags) {
        this.jobTags.forEach(() => this.tagsArray.push(new FormControl(false)));
        //this.tagsArray.at(0).setValue(true);
      }
    }
    else if (this.selectedMetric == Graphs.JobByApplication) {
      if (this.applicationNames) {
        this.applicationNames.forEach(() => this.appsArray.push(new FormControl(false)));
      }
    }
    else {
      this.SingleNodeUtilizationValue = false;
    }
  }

  loadSingleNodeUtilization(wsName, toDownload?: boolean) {
    this.spinner.show("loadingGraphs")
    this.resetAllData();
    try {
      this.chartService
        .getNodeUsage(
          this.depName,
          Graphs.NodeUtilization,
          this.dateFilterValue,
          this.granularityValue,
          '',
          wsName,
          false,
          ''
        )
        .subscribe({
          next: (data) => {

            this.nodeUtilizationDataTotal['datasets'].forEach(d => d.data = []);
            this.nodeUtilizationDataTotal['labels'] = [];
            this.nodeUtilizationDataOffice['datasets'].forEach(d => d.data = []);
            this.nodeUtilizationDataOffice['labels'] = [];
            this.nodeUtilizationDataNonOffice['datasets'].forEach(d => d.data = []);
            this.nodeUtilizationDataNonOffice['labels'] = [];
            this.nodeUtilization = <NodeUsage[]>JSON.parse(JSON.stringify(data));

            if (this.nodeUtilization && this.nodeUtilization?.length != 0) {
              this.daysValue =
                'From ' +
                new DatePipe('en-US').transform(
                  this.nodeUtilization[0]
                    ? new Date(this.nodeUtilization[0].timeStamp)
                    : new Date(),
                  'yyyy-MM-dd, HH:mm:ss'
                ) +
                ' To ' +
                new DatePipe('en-US').transform(
                  new Date(
                    this.nodeUtilization[this.nodeUtilization.length - 1]
                      .timeStamp
                  ),
                  'yyyy-MM-dd, HH:mm:ss'
                );
            } else {
              this.daysValue = 'From - to -'
            }

            let dateFilter = this.dateFilterValue;
            if (this.dateFilterValue.indexOf('hr') != -1 || this.dateFilterValue.indexOf('days') != -1) {
              dateFilter = this.dateFilterValue.indexOf('hr') != -1 ? this.dateFilterValue.trim().slice(0, -2).trim() : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            let uniqueDates;
            if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
              uniqueDates = [
                ...new Set(
                  this.nodeUtilization.map(
                    (item) =>
                      formatDate(
                        new Date(item.timeStamp),
                        'mediumDate',
                        'en-US'
                      ).split(',')[0]
                  )
                ),
              ];
            } else {
              uniqueDates = [
                ...new Set(this.nodeUtilization.map((item) => item.timeStamp)),
              ];
            }
            this.nodeUtilization.forEach((x) => {
              if (x.officeHours == 1) {
                this.nodeUtilizationDataOffice.datasets[0].data.push(x.cpuPercent);
                this.nodeUtilizationDataOffice.datasets[1].data.push(x.ramPercent);
                this.nodeUtilizationDataOffice.datasets[2].data.push(x.gpuPercent);
                this.nodeUtilizationDataOffice.datasets[3].data.push(
                  x.gpuMemoryUsage
                );
                let date;
                if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'mediumDate',
                    'en-US'
                  ).split(',')[0];
                } else {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'h:mm aa',
                    'en-US'
                  ).split(')')[0];
                }
                this.nodeUtilizationDataOffice.labels.push(date);
              } else if (x.officeHours == 0) {
                this.nodeUtilizationDataNonOffice.datasets[0].data.push(
                  x.cpuPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[1].data.push(
                  x.ramPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[2].data.push(
                  x.gpuPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[3].data.push(
                  x.gpuMemoryUsage
                );
                let date;
                if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'mediumDate',
                    'en-US'
                  ).split(',')[0];
                } else {
                  date = formatDate(
                    new Date(x.timeStamp),
                    'h:mm aa',
                    'en-US'
                  ).split(')')[0];
                }
                this.nodeUtilizationDataNonOffice.labels.push(date);
              }
            });
            uniqueDates.forEach((unq) => {
              let count = 0;
              let ramUsage = 0;
              let cpuUsage = 0;
              let gpuUsage = 0;
              let gpuMemoryUsage = 0;
              this.nodeUtilization.forEach((n) => {
                if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                  if (
                    formatDate(new Date(n.timeStamp), 'mediumDate', 'en-US').split(
                      ','
                    )[0] === unq
                  ) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                } else {
                  if (n.timeStamp === unq) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                }
              });
              this.nodeUtilizationDataTotal.datasets[0].data.push(cpuUsage / count);
              this.nodeUtilizationDataTotal.datasets[1].data.push(ramUsage / count);
              this.nodeUtilizationDataTotal.datasets[2].data.push(gpuUsage / count);
              this.nodeUtilizationDataTotal.datasets[3].data.push(
                gpuMemoryUsage / count
              );
              let date;
              if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                date = formatDate(new Date(unq), 'mediumDate', 'en-US').split(
                  ','
                )[0];
              } else {
                date = formatDate(new Date(unq), 'h:mm aa', 'en-US').split(')')[0];
              }
              this.nodeUtilizationDataTotal.labels.push(date);
            });

            const totalMax = this.calculateDynamicMax(this.nodeUtilizationDataTotal.datasets);
            const officeMax = this.calculateDynamicMax(this.nodeUtilizationDataOffice.datasets);
            const nonOfficeMax = this.calculateDynamicMax(this.nodeUtilizationDataNonOffice.datasets);

            this.nodeUtilizationOptionsTotal = {
              ...this.nodeUtilizationOptionsTotal,
              scales: {
                ...this.nodeUtilizationOptionsTotal.scales,
                'y-axis-0': {
                  ...this.nodeUtilizationOptionsTotal.scales['y-axis-0'],
                  max: totalMax,
                }
              }
            };

            // Update Office hours chart options
            this.nodeUtilizationOptionsTotalOffice = {
              ...this.nodeUtilizationOptionsTotalOffice,
              scales: {
                ...this.nodeUtilizationOptionsTotalOffice.scales,
                'y-axis-0': {
                  ...this.nodeUtilizationOptionsTotalOffice.scales['y-axis-0'],
                  max: officeMax,
                }
              }
            };

            // Update Non-office hours chart options
            this.nodeUtilizationOptionsNonOffice = {
              ...this.nodeUtilizationOptionsNonOffice,
              scales: {
                ...this.nodeUtilizationOptionsNonOffice.scales,
                'y-axis-0': {
                  ...this.nodeUtilizationOptionsNonOffice.scales['y-axis-0'],
                  max: nonOfficeMax,
                }
              }
            };

            this.updateGraphs();
            this.spinner.hide("loadingGraphs");
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs")
      console.error('error in loadNodeUtilization', error);
    }
    finally {
      //this.spinner.hide("loadingGraphs")
    }
  }

  downloadNodeUtilization() {
    this.deploymentService
      .getCsvGraphData(this.depName, this.dateFilterValue)
      .subscribe((res: any) => {
        if (res?.data == '' || res?.data == null) {
          this.snackbar.open(
            'No Data available for the selected deployment',
            'Ok',
            {
              duration: 5000,
            }
          );
        } else {
          this.snackbar.open('Download in progress', 'Ok', {
            duration: 3000,
          });
          let x = res?.data;
          var blob = new Blob([x], { type: 'text/csv' });
          saveAs(blob, `${this.depName}_Node_Utilization.csv`);
        }
      });
  }

  getSessionData(type, toDownload?: boolean) {
    this.spinner.show("loadingGraphs")
    this.resetAllData();
    try {
      this.sessionService
        .getSessionData(this.selectedUser, type, this.dateFilterValue)
        .subscribe({
          next: (data) => {
            if (data) {
              let sessinfo = <SessionInfo>JSON.parse(JSON.stringify(data));
              this.spinner.hide("loadingGraphs")
              if (!sessinfo) {
                this.snackbar.open('No Data Available', 'Ok', { duration: 5000 });
                return;
              }
              sessinfo.perDaySessions.forEach((e) => {
                let option = {
                  hAxis: {
                    minValue: new Date(e.date).setHours(0, 0, 0, 0),
                    maxValue: new Date(e.date).setHours(23, 59, 59, 999),
                    format: 'HH:mm',
                  },
                  is3D: true,
                };

                let singleDatedata = [];
                e.data.forEach((data) => {
                  singleDatedata.push([
                    e.date.split('T')[0],
                    data.node,
                    new Date(data.sessionStart),
                    new Date(data.sessionEnd),
                  ]);
                });

                if (type === 'Connect-Disconnect') {
                  this.graphConnDiscon.push({
                    data: singleDatedata,
                    options: option,
                  });
                } else {
                  this.graphStartEnd.push({
                    data: singleDatedata,
                    options: option,
                  });
                }
              });
            }
            else {
              this.spinner.hide("loadingGraphs")
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs")
            console.error('error in getSessionData', err);
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs")
      console.error('error in getSessionData', error);
    }
  }

  resetFilter() {
    this.selectedMetric = 'all';
    this.granularityValue = 'One Day';
    this.SingleNodeUtilizationValue = false;
    this.dateFilterValue = '7 days';
    this.selectedUser = 'none';
    this.userFilterValue = 'none';
    this.disableButton();
    this.loadAllCharts();
  }

  changeGranularityOptions(days) {
    switch (days) {
      case '1':
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneHour);
        break;
      case '7':
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneDay);
        this.availableGranularity.push(GraphDataGranularity.OneWeek);
        break;
      case '30':
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneDay);
        this.availableGranularity.push(GraphDataGranularity.OneWeek);
        this.availableGranularity.push(GraphDataGranularity.OneMonth);
        break;
      case '90':
        this.availableGranularity = [];
        this.availableGranularity.push(GraphDataGranularity.OneDay);
        this.availableGranularity.push(GraphDataGranularity.OneWeek);
        this.availableGranularity.push(GraphDataGranularity.OneMonth);
        break;
    }
    this.granularityValue = this.availableGranularity[0]
  }

  disableButton() {
    this.disableApplyFilter = true;
  }

  updateGraphs() {
    try {
      this.charts.forEach((child) => {
        child?.chart ? child?.chart?.update() : child?.update();
      });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
    }

  }

  getDynamicColor() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  }

  getGranularityForMetric(activeChart, period) {
    if (
      [
        Graphs.JobSummary,
        Graphs.JobCompleted,
        Graphs.JobByUser,
        Graphs.JobByGroup,
        Graphs.JobWaitTime,
        Graphs.JobByApplication,
        Graphs.JobByNodes,
        Graphs.CoresByApplication,
        Graphs.CoreHoursByUsers,
        Graphs.JobDurationsByDay,
        Graphs.JobByTagsPerDay
      ].includes(activeChart)) {
      setTimeout(() => {
        if (this.granularityValue != "One Day") this.granularityValue = Granularity.OneDay;
      }, 1);
      return [];
    }
    return this.sortGranularityAsPerPeriod(period, activeChart);
  }

  sortGranularityAsPerPeriod(period, activeChart = null) {
    let granularity = [];
    if (period.toLocaleLowerCase().indexOf('hr') != -1) {
      granularity = [Granularity.OneHour];
      return granularity;
    }
    else if (period.toLowerCase().indexOf('days') != -1) {
      let days = period.trim().slice(0, -4);
      if (parseInt(days) <= 0 && parseInt(days) > 180) {
        //this.snackbar.open("Should be between 1 to 24", "Ok", { duration: 5000 });
      }
      else if (parseInt(days) == 1) {
        granularity = [Granularity.OneHour];
        return granularity;
      }
      else {
        if (activeChart) {
          if ([
            Graphs.RunningQueuedJobsPerNodeGroup
          ].includes(activeChart)) {
            granularity = [Granularity.OneDay];
            return granularity;
          }
        }
        else {
          if (parseInt(days) > 1 && parseInt(days) <= 30) {
            if (parseInt(days) == 30) {
              granularity = [Granularity.OneDay, Granularity.OneWeek];
            }
            granularity = [Granularity.OneDay];
            return granularity;
          }
          else if (parseInt(days) > 1 && parseInt(days) >= 180) {
            granularity = [Granularity.OneMonth];
            return granularity;
          }
          else {
            granularity = [Granularity.OneWeek, Granularity.OneMonth];
            return granularity;
          }
        }
      }
    }
    let days = period.trim().slice(0, -4)?.trim();
    switch (days) {
      case "1":
        granularity = [Granularity.OneHour];
        break;

      case "7":
        granularity = [Granularity.OneDay];
        break;

      case "30":
        granularity = [Granularity.OneDay, Granularity.OneWeek];
        break;

      case "90":
        granularity = [Granularity.OneWeek, Granularity.OneMonth];
        break;

      case "180":
        granularity = [Granularity.OneWeek, Granularity.OneMonth];
        break;

      case "365":
        granularity = [Granularity.OneMonth];
        break;

      // case "custom":
      //   if(!this.range.valid){
      //     granularity = [Granularity.OneDay];
      //     break;
      //   }

      //   let startDate = this.range.value.start;
      //   let endDate = this.range.value.end;
      //   // get diff between startDate and endDate in days
      //   let diff = (startDate.getTime() - endDate.getTime()) / 86400000;
      //   diff = diff < 0 ? diff * -1 : diff;
      //   if(diff <= 21){
      //     granularity = [Granularity.OneDay];
      //   } else if(diff <= 60){
      //     granularity = [Granularity.OneDay, Granularity.OneWeek];
      //   } else if(diff <= 90){
      //     granularity = [Granularity.OneWeek, Granularity.OneMonth];
      //   } else if(diff <= 180){
      //     granularity = [Granularity.OneWeek, Granularity.OneMonth];
      //   } else {
      //     granularity = [Granularity.OneMonth];
      //   }
      //   break;

      default:
        granularity = [Granularity.OneDay];
        break;
    }
    if (!granularity.includes(this.granularityValue)) {
      setTimeout(() => { this.granularityValue = granularity[0] }, 1);
    }
    return granularity;
  }

  getJobTags() {
    this.jobService.getJobTagsOfAllJobs(this.depName).subscribe({
      next: (data: any) => {
        this.jobTags = data.map((d) => {
          return { item_id: d, item_text: d }
        });
      },
      error: (err) => {

      }
    })
  }

  loadJobByTagsData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      let tNames = this.graphFilterForm.value?.jobTags?.map((gn) => gn.item_text || gn);
      if (tNames?.length == 0) {
        this.snackbar.open("Please select minimum 1 tag to proceed.", "Ok", {
          duration: 4000,
        });
        this.spinner.hide("loadingGraphs");
        return;
      }
      this.chartService
        .getJobTagData(
          this.depName,
          this.dateFilterValue,
          this.granularityValue,
          tNames?.toString()
        )
        .subscribe({
          next: (data) => {
            this.spinner.hide("loadingGraphs");
            this.jobByTagsData["datasets"].forEach((d) => (d.data = []));
            this.jobByTagsData["labels"] = [];
            this.loadTabularData(JSON.parse(JSON.stringify(data)));
            let jobByTagsData: JobByTagsI[] = JSON.parse(JSON.stringify(data));
            if (toDownload) {
              let headers = Object.keys(data[0]);
              Object.keys(data).forEach((e) => {
                data[e].jobStageStatus =
                  this.statusMapping[data[e].jobStageStatus];
              });
              this.downloadCsv(
                data,
                headers,
                `${Graphs.JobByTags}-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
            }
            let soloNodes: JobByTagsI[] = jobByTagsData.filter(
              (n) => !n.jobTag?.includes(",")
            );
            let multiNodes: JobByTagsI[] = jobByTagsData.filter((n) =>
              n.jobTag?.includes(",")
            );
            multiNodes.forEach((element) => {
              element.jobTag?.split(",").forEach((node) => {
                if (tNames != null && tNames?.indexOf(node) != -1) {
                  soloNodes.push({ ...element, jobTag: node });
                }
              });
            });
            jobByTagsData = soloNodes;

            var filteredData = this.groupByNodes(jobByTagsData, "jobTag");

            if (filteredData) {
              const myDictionary: Dictionary = Object.keys(filteredData).reduce((acc, key) => {
                let totalJobsPeTag = 0
                totalJobsPeTag = filteredData[key].reduce(
                  (accumulator, currentValue) =>
                    accumulator + currentValue.totalCount,
                  0
                );
                acc[key] = totalJobsPeTag;
                return acc;
              }, {} as Dictionary);

              if (myDictionary) {
                const entries: [string, number][] = Object.entries(myDictionary);
                entries?.sort((a, b) => b[1] - a[1]);
                let keys = entries?.map(x => x[0])

                if (keys) {
                  keys.forEach((key, idx) => {
                    let totalJobsPerTag = filteredData[key].reduce(
                      (accumulator, currentValue) =>
                        accumulator + currentValue.totalCount,
                      0
                    );
                    this.jobByTagsData["datasets"][0].data[idx] = 0;
                    this.jobByTagsData["datasets"][1].data[idx] = 0;
                    this.jobByTagsData["datasets"][2].data[idx] = 0;

                    filteredData[key].forEach((e: any) => {
                      if (e.jobStageStatus == 1) {
                        this.jobByTagsData["datasets"][1].data[idx] += e.totalCount;
                      } else if (e.jobStageStatus == 5) {
                        this.jobByTagsData["datasets"][2].data[idx] += e.totalCount;
                      } else if (e.jobStageStatus == 11) {
                        this.jobByTagsData["datasets"][0].data[idx] += e.totalCount;
                      }
                    });
                    this.jobByTagsData["labels"].push(
                      key + " : " + totalJobsPerTag + " Jobs"
                    );
                  })
                }
              }
            }

            this.jobByTagsOptions = {
              ...this.jobByTagsOptions,
              plugins: {
                ...this.jobByTagsOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job By Tags - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                },
              },
            };
            this.updateGraphs();
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          },
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loadJobByTagsData: ", error);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  checkIsVdiDeployment() {
    if (this.depName.toLowerCase() != 'all') {
      this.deploymentService.checkIsVdi(this.depName).subscribe({
        next: (data) => {
          this.isVdi = Boolean(data);
          this.applyFilters("all", this.selectedUser, this.dateFilterValue, this.granularityValue, '', '', '', false);
        },
        error: (err) => {

        }
      })
    }
  }

  deploymentFilterApplied() {
    this.spinner.show("loadingGraphs");
    try {
      this.selectedMetric = 'all';
      let dep = this.depName;
      if (dep.toLowerCase() == "all") {
        this.selectedMetric = "all";
        this.wsValue = "none";
        return;
      }
      this.checkIsVdiDeployment();
      //this.getAllWorkstationList(dep);
      this.loadUsers();
      this.getUserName();
      this.getUserGroupNames();
      this.getJobTags();
      this.nodeService.getAllWSNames(this.depName, "All").subscribe((data) => {
        if (data) {
          this.wsNames = JSON.parse(JSON.stringify(data))?.wsSelected;
          this.nodeGroups = JSON.parse(JSON.stringify(data))?.nodeGroups;
        }
      });
      this.dynamicControls = [];
      this.loadDynamicControls();
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
    }
    finally {
      //this.spinner.hide("loadingGraphs");
    }

  }

  minThreshold: number = 10;
  getDataLabelUsableValue(data: any, minThreshold: number = 10): number {
    if (!data || data.length == 0) {
      return minThreshold;
    }
    let maxNum = Math.max(data.reduce((acc, val) => { return acc + val; }, 0));
    let usableNum = maxNum / 35;
    return usableNum > minThreshold ? usableNum : minThreshold;
  }

  getDataLabelUsableValueForPrimeGraph(): number {
    if (this.primeCoreUsageChartData[0].data.length == 0 && this.primeCoreUsageChartData[1].data.length == 0) {
      return this.minThreshold;
    }
    let usedMax: number[] = <number[]>this.primeCoreUsageChartData[0].data;
    let queuedMax: number[] = <number[]>this.primeCoreUsageChartData[1].data;
    let maxNum = Math.max(usedMax?.reduce((acc, val) => { return acc + val; }, 0), queuedMax?.reduce((acc, val) => { return acc + val; }, 0));
    let usableNum = maxNum / 35;
    return usableNum > this.minThreshold ? usableNum : this.minThreshold;
  }

  getDataLabelUsableValueForNonPrimeGraph(): number {
    if (this.nonPrimeCoreUsageChartData[0].data.length == 0 && this.nonPrimeCoreUsageChartData[1].data.length == 0) {
      return this.minThreshold;
    }
    let usedMax: number[] = <number[]>this.nonPrimeCoreUsageChartData[0].data;
    let queuedMax: number[] = <number[]>this.nonPrimeCoreUsageChartData[1].data;
    let maxNum = Math.max(usedMax?.reduce((acc, val) => { return acc + val; }, 0), queuedMax?.reduce((acc, val) => { return acc + val; }, 0));
    let usableNum = maxNum / 35;
    return usableNum > this.minThreshold ? usableNum : this.minThreshold;
  }

  //To get active sessions per deployment graph
  getActiveSessionsPerDeployment(depName, toDownload?: boolean) {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    try {
      this.chartService.getActiveSessionsPerDep(depName, this.dateFilterValue, this.granularityValue)
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.spinner.hide("loadingGraphs");
              this.activeSessionsByProfileDataTotal.datasets = [];
              this.loadTabularData(JSON.parse(JSON.stringify(data)));
              this.predefinedDatasets.forEach(x => {
                x.label = '';
                x.data = [];
              })
              let dateFilter = this.dateFilterValue;
              if (this.dateFilterValue.indexOf('hr') != -1 || this.dateFilterValue.indexOf('days') != -1) {
                dateFilter = this.dateFilterValue.indexOf('hr') != -1 ? this.dateFilterValue.trim().slice(0, -2).trim() : this.dateFilterValue.trim().slice(0, -4).trim();
              }

              this.activeSessionsPerDepData = JSON.parse(JSON.stringify(data));
              this.activeSessionsPerDepData = this.activeSessionsPerDepData?.sort((a, b) => 0 - (b.deploymentName.toLowerCase() < a.deploymentName.toLowerCase() ? 1 : -1))
              let uniqueDates;
              if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                uniqueDates = [
                  ...new Set(
                    this.activeSessionsPerDepData.map(
                      (item) =>
                        formatDate(
                          new Date(item.entryTime),
                          'mediumDate',
                          'en-US'
                        ).split(',')[0]
                    )
                  ),
                ];
              } else {
                uniqueDates = [
                  ...new Set(this.activeSessionsPerDepData.map((item) => item.entryTime)),
                ];
              }

              if (uniqueDates) {
                uniqueDates = uniqueDates?.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
              }

              var filteredData = this.groupByNodes(this.activeSessionsPerDepData, "deploymentName");
              uniqueDates.forEach((unq) => {
                let date;
                if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                  date = formatDate(new Date(unq), 'mediumDate', 'en-US').split(
                    ','
                  )[0];
                } else {
                  date = formatDate(new Date(unq), 'h:mm aa', 'en-US').split(')')[0];
                }
                this.activeSessionsByProfileDataTotal.labels.push(date);
              })
              Object.keys(filteredData).forEach((key, idx) => {
                if (this.activeSessionsByProfileDataTotal.datasets.length == 0) {
                  this.predefinedDatasets[idx].label = key;
                  this.activeSessionsByProfileDataTotal.datasets = [this.predefinedDatasets[idx]];
                }
                else {
                  this.predefinedDatasets[idx].label = key;
                  this.activeSessionsByProfileDataTotal.datasets.push(this.predefinedDatasets[idx]);
                }
                uniqueDates.forEach((unq) => {

                  if (dateFilter != '1' && (this.dateFilterValue.indexOf('days') != -1 || this.dateFilterValue.indexOf('to') != -1)) {
                    //this.nodeUtilizationDataTotal.datasets[idx].data.push(filteredData[key].find(obj => obj.entryTime === unq) ?? 0)
                    const foundObject = filteredData[key].find(obj => (formatDate(new Date(obj.entryTime), 'mediumDate', 'en-US').split(',')[0]) === unq);
                    const activeSessions = foundObject ? foundObject.activeSessions : 0;
                    this.activeSessionsByProfileDataTotal.datasets[idx].data.push(activeSessions);
                  }
                  else {
                    //this.nodeUtilizationDataTotal.datasets[idx].data.push(filteredData[key].find(obj => obj.entryTime === unq) ?? 0)
                    const foundObject = filteredData[key].find(obj => obj.entryTime === unq);
                    const activeSessions = foundObject ? foundObject.activeSessions : 0;
                    this.activeSessionsByProfileDataTotal.datasets[idx].data.push(activeSessions);
                  }
                })
              });

              this.spinner.hide("loadingGraphs");
              this.updateGraphs();
            }
            else {
              this.spinner.hide("loadingGraphs");
              this.snackbar.open("No data found to visualize", "Ok", { duration: 3000 });
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            this.snackbar.open("Unable to load data", "Ok", { duration: 3000 });
          },
          complete: () => {
            // this.spinner.hide("loadingGraphs");
          }
        })
    }
    catch (error) {
      this.spinner.hide("loadingGraphs")
      console.error('error in get active sessions per deployment', error);
    }
    finally {
      // this.spinner.hide("loadingGraphs")
    }

  }

  async generatePdfVDI(sendEmail) {
    this.snackbar.open("Please wait while PDF is generating. It may take few minutes.");

    switch (this.selectedMetric) {
      case Graphs.ActiveSessions:
      case Graphs.NodeUtilization:
      case Graphs.SingleNodeUtilization:
        this.generatePdfHPC(sendEmail);
        this.snackbar.open("Pdf generated successfully, pdf will be downloaded soon.", "Ok", { duration: 2000 });
        break;

      case Graphs.SessionGraph:
      case Graphs.NodeStartStopStatus:
      case Graphs.AllUserSessions:
        try {
          this.showFilters = true;
          this.downloadingPdf = true;
          const pdf = new jsPDF('l', 'mm', 'a4'); // Use landscape for wide timeline content

          if (this.selectedMetric == Graphs.SessionGraph) {
            for (let sectionIndex = 1; sectionIndex < 3; sectionIndex++) {
              let content;
              if (sectionIndex == 1) {
                content = this.pdfContentSessionEndStart.nativeElement;
              } else if (sectionIndex == 2) {
                content = this.pdfContentSessionConDisConnect.nativeElement;
              }

              // Add page for each section (except first)
              if (sectionIndex > 1) {
                pdf.addPage();
              }

              await this.captureFullScrollableContent(content, pdf);
            }
          } else {
            let content;
            content = this.pdfContent.nativeElement;
            await this.captureFullScrollableContent(content, pdf);
          }

          const fileName = `${this.depName}_${this.selectedMetric}_Report_${this.headerService.getUserNewDate().toISOString().slice(0, 10)}.pdf`;

          if (sendEmail) {
            const file = new File([pdf.output('blob')], fileName);
            this.uploadFiles(file);
          }
          else {
            // Save the PDF
            pdf.save(fileName);
          }

          this.snackbar.open("Pdf generated successfully, pdf will be downloaded soon.", "Ok", { duration: 2000 });
          return;
        }
        catch (error) {
          console.error('Error generating PDF:', error);
          this.showFilters = false;
          this.downloadingPdf = false;
        }
        finally {
          this.showFilters = false;
          this.downloadingPdf = false;
        }

        break;

      default:
        this.generatePdfHPC(sendEmail);
        this.snackbar.open("Pdf generated successfully, pdf will be downloaded soon.", "Ok", { duration: 2000 });
        break;
    }
  }

  async captureFullScrollableContent(element, pdf) {
    // Store original scroll positions
    const originalScrollLeft = element.scrollLeft;
    const originalScrollTop = element.scrollTop;

    // Get full content dimensions
    const fullWidth = element.scrollWidth;
    const fullHeight = element.scrollHeight;
    const viewportWidth = element.clientWidth;
    const viewportHeight = element.clientHeight;

    console.log('Content dimensions:', {
      fullWidth, fullHeight, viewportWidth, viewportHeight
    });

    try {
      // Method 1: Try to capture entire content in one go (best quality)
      const fullCanvas = await this.captureEntireContent(element);

      if (fullCanvas) {
        await this.addCanvasToPDF(fullCanvas, pdf);
      } else {
        // Method 2: Fallback - tile capture for very large content
        await this.captureContentByTiling(element, pdf, fullWidth, fullHeight, viewportWidth, viewportHeight);
      }

    } finally {
      // Restore original scroll position
      element.scrollTo(originalScrollLeft, originalScrollTop);
    }
  }

  async captureEntireContent(element) {
    try {
      // Temporarily modify element to show all content
      const originalStyles = {
        height: element.style.height,
        width: element.style.width,
        overflow: element.style.overflow,
        overflowX: element.style.overflowX,
        overflowY: element.style.overflowY,
        maxHeight: element.style.maxHeight,
        maxWidth: element.style.maxWidth
      };

      // Make element show full content
      element.style.height = element.scrollHeight + 'px';
      element.style.width = element.scrollWidth + 'px';
      element.style.overflow = 'visible';
      element.style.overflowX = 'visible';
      element.style.overflowY = 'visible';
      element.style.maxHeight = 'none';
      element.style.maxWidth = 'none';

      // Wait for layout to settle
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Capture with full dimensions
      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: 'white',
        scale: 1.5,
        width: element.scrollWidth,
        height: element.scrollHeight,
        scrollX: 0,
        scrollY: 0
      });

      // Restore original styles
      Object.keys(originalStyles).forEach(key => {
        element.style[key] = originalStyles[key];
      });

      return canvas;

    } catch (error) {
      console.warn('Full capture failed, will use tiling method:', error);
      return null;
    }
  }

  async captureContentByTiling(element, pdf, fullWidth, fullHeight, viewportWidth, viewportHeight) {
    const horizontalSteps = Math.ceil(fullWidth / viewportWidth);
    const verticalSteps = Math.ceil(fullHeight / viewportHeight);

    console.log(`Tiling: ${horizontalSteps}x${verticalSteps} tiles`);

    // Create a large canvas to combine all tiles
    const combinedCanvas = document.createElement('canvas');
    combinedCanvas.width = fullWidth;
    combinedCanvas.height = fullHeight;
    const combinedCtx = combinedCanvas.getContext('2d');

    for (let row = 0; row < verticalSteps; row++) {
      for (let col = 0; col < horizontalSteps; col++) {
        // Calculate scroll position for this tile
        const scrollLeft = col * viewportWidth;
        const scrollTop = row * viewportHeight;

        // Scroll to position
        element.scrollTo(scrollLeft, scrollTop);

        // Wait for content to load
        await new Promise(resolve => setTimeout(resolve, 500));

        // Capture this tile
        const tileCanvas = await html2canvas(element, {
          useCORS: true,
          allowTaint: true,
          backgroundColor: 'white',
          scale: 1.5,
          width: Math.min(viewportWidth, fullWidth - scrollLeft),
          height: Math.min(viewportHeight, fullHeight - scrollTop)
        });

        // Add tile to combined canvas
        combinedCtx.drawImage(tileCanvas, scrollLeft, scrollTop);

        console.log(`Captured tile ${row * horizontalSteps + col + 1}/${horizontalSteps * verticalSteps}`);
      }
    }

    await this.addCanvasToPDF(combinedCanvas, pdf);
  }

  // Add canvas to PDF with optimal scaling and page management
  async addCanvasToPDF(canvas, pdf) {
    const imgData = canvas.toDataURL('image/PNG', 0.9);

    // PDF dimensions (landscape A4)
    const pdfWidth = 297; // A4 landscape width
    const pdfHeight = 210; // A4 landscape height
    const margin = 10;

    const availableWidth = pdfWidth - (2 * margin);
    const availableHeight = pdfHeight - (2 * margin);

    // Calculate scaling to fit width (common for timeline data)
    const scale = availableWidth / (canvas.width * 0.264583); // px to mm conversion
    const scaledWidth = availableWidth;
    const scaledHeight = (canvas.height * 0.264583) * scale;

    if (scaledHeight <= availableHeight) {
      // Content fits on one page
      const yOffset = margin + (availableHeight - scaledHeight) / 2; // Center vertically
      pdf.addImage(imgData, 'PNG', margin, yOffset, scaledWidth, scaledHeight);
    } else {
      // Split into multiple pages
      const pagesNeeded = Math.ceil(scaledHeight / availableHeight);
      const pageContentHeight = canvas.height / pagesNeeded;

      for (let page = 0; page < pagesNeeded; page++) {
        if (page > 0) pdf.addPage();

        // Create canvas for this page
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = pageContentHeight;

        const pageCtx = pageCanvas.getContext('2d');
        pageCtx.drawImage(
          canvas,
          0, page * pageContentHeight, canvas.width, pageContentHeight,
          0, 0, canvas.width, pageContentHeight
        );

        const pageImgData = pageCanvas.toDataURL('image/PNG', 0.9);
        pdf.addImage(pageImgData, 'PNG', margin, margin, scaledWidth, availableHeight);
      }
    }
  }

  async generatePdfHPC(sendEmail) {
    this.showFilters = true;
    this.downloadingPdf = true;
    await new Promise((r) => setTimeout(r, 1000));

    const div = document.getElementById('html2Pdf');

    // Enhanced options for better quality and full content capture
    const options = {
      background: 'white',
      height: div.scrollHeight,
      width: div.scrollWidth,
      scale: 2, // Higher resolution
      useCORS: true,
      allowTaint: true,
      scrollX: 0,
      scrollY: 0
    };

    try {
      const canvas = await html2canvas(div, options);

      // A4 dimensions in mm
      const a4Width = 210;
      const a4Height = 297;
      const margin = 8; // Slightly reduced margin

      // Convert canvas dimensions to mm for analysis
      const pxToMm = 0.264583;
      const contentWidthMm = canvas.width * pxToMm;
      const contentHeightMm = canvas.height * pxToMm;
      const contentAspectRatio = contentWidthMm / contentHeightMm;

      // Determine optimal orientation based on content
      let pdfOrientation = 'p'; // default portrait
      let pdfWidth = a4Width;
      let pdfHeight = a4Height;

      // If content is significantly wider than tall, use landscape
      if (contentAspectRatio > 1.4) { // Content is wide (like your graph)
        pdfOrientation = 'l'; // landscape
        pdfWidth = a4Height; // 297mm
        pdfHeight = a4Width; // 210mm
        console.log('Using landscape orientation for wide content');
      }

      // Create PDF with optimal orientation
      let doc = new jsPDF('l', 'mm', 'a4');

      const imgData = canvas.toDataURL('image/PNG', 0.95);

      // Calculate available space
      const availableWidth = pdfWidth - (2 * margin);
      const availableHeight = pdfHeight - (2 * margin);

      // Calculate scaling options
      const scaleByWidth = availableWidth / contentWidthMm;
      const scaleByHeight = availableHeight / contentHeightMm;

      // Choose scale that maximizes content usage while fitting the page
      const optimalScale = Math.min(scaleByWidth, scaleByHeight);

      // Final dimensions
      const finalWidth = contentWidthMm * optimalScale;
      const finalHeight = contentHeightMm * optimalScale;

      // Center the content on the page
      const xOffset = margin + (availableWidth - finalWidth) / 2;
      const yOffset = margin + (availableHeight - finalHeight) / 2;

      // Check if content fits on one page
      if (finalHeight <= availableHeight && finalWidth <= availableWidth) {
        // Content fits on one page - center it
        doc.addImage(
          imgData,
          'PNG',
          xOffset,
          yOffset,
          finalWidth,
          finalHeight,
          undefined,
          'FAST'
        );
      } else {
        // Multi-page handling
        const pageContentHeight = availableHeight;
        const totalPages = Math.ceil(finalHeight / pageContentHeight);

        for (let i = 0; i < totalPages; i++) {
          if (i > 0) {
            doc.addPage();
          }

          // Calculate source area for this page
          const sourcePageHeight = pageContentHeight / optimalScale;
          const sourceY = i * sourcePageHeight;
          const actualSourceHeight = Math.min(sourcePageHeight, canvas.height - sourceY);

          // Create a canvas for this page section
          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = canvas.width;
          pageCanvas.height = actualSourceHeight;

          const pageCtx = pageCanvas.getContext('2d');
          pageCtx.drawImage(
            canvas,
            0, sourceY, canvas.width, actualSourceHeight,
            0, 0, canvas.width, actualSourceHeight
          );

          const pageImgData = pageCanvas.toDataURL('image/PNG', 0.95);

          // Calculate height for this page
          const pageDisplayHeight = actualSourceHeight * optimalScale;

          doc.addImage(
            pageImgData,
            'PNG',
            xOffset,
            margin, // Start from top margin for multi-page
            finalWidth,
            pageDisplayHeight,
            undefined,
            'FAST'
          );
        }
      }

      // Generate filename
      const fileName = `${this.depName}_${this.selectedMetric}_Report_${this.headerService.getUserNewDate().toISOString().slice(0, 10)}.pdf`;

      if (sendEmail) {
        const file = new File([doc.output('blob')], fileName);
        this.uploadFiles(file);
      }
      else {
        // Save the PDF
        doc.save(fileName);
      }

    } catch (error) {
      console.error('PDF generation failed:', error);
    } finally {
      this.showFilters = false;
      this.downloadingPdf = false;
    }
  }

  uploadFiles(file) {
    let myFile: File = file;
    let message;

    if (this.selectedMetric == Graphs.SingleNodeUtilization) {
      message = `node utilization of workstation ${this.wsValue} of deployment ${this.depName}`;
    }
    else if (this.selectedMetric == Graphs.NodeUtilization) {
      message = `average node utilization of all workstations of ${this.depName}`;
    }
    else if (this.selectedMetric == Graphs.SessionGraph) {
      message = `session activity graph of user ${this.userFilterValue} of ${this.depName}`;
    }
    else {
      message = `graph of ${this.selectedMetric} of ${this.depName}`;
    }

    this.chartService.uploadReportsFile("pdf", myFile, this.dateFilterValue, message)
      .subscribe({
        next: (event: any) => {
          this.snackbar.open("Email sent successfully.", "Ok", { duration: 3000 });
        },
        error: (err: any) => {
          this.snackbar.open("Error occurred try again.", "Ok", { duration: 3000 });
        }
      });
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${hours}-${minutes}-${seconds}`;
  }

  public timelineChartData: any = {
    chartType: 'Timeline',
    dataTable: [
      []
    ],
    options: {
      timeline: {
        singleColor: '#818db5', // Specify the default color for all rows
        colors: ['#818db5', '#00FF00'], // Specify individual colors for each row
      }
    }
  }

  getSessionDataPerUser() {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getSessionDataPerUser(this.selectedUser, 'Connect-Disconnect', this.dateFilterValue, this.depName)
        .subscribe({
          next: (data: any) => {
            this.sessinfoPerUser = <SessionLogPerUser[]>JSON.parse(JSON.stringify(data));
            this.spinner.hide("loadingGraphs")
            if (!this.sessinfoPerUser) {
              this.snackbar.open('No Data Available', 'Ok', { duration: 5000 });
              return;
            }
            this.timelineChartData.dataTable = [];

            let filteredData;
            const userTotalDuration: { [key: string]: string } = {};

            if (this.showUserNameAndTotalHours) {
              filteredData = this.groupByNodes(this.sessinfoPerUser, "userName");

              if (filteredData) {
                Object.keys(filteredData).forEach((key, idx) => {
                  let allSumTotalSessionTime = filteredData[key].reduce((acc, obj) => acc + obj.totalTime, 0);
                  if (allSumTotalSessionTime > 0) {
                    let hours = Math.floor(allSumTotalSessionTime / 60);
                    let minutes = allSumTotalSessionTime % 60;
                    userTotalDuration[key] = `${hours}:${minutes}`;
                  }
                })
              }
            }

            this.sessinfoPerUser.forEach((s) => {
              if (s.node.toLowerCase() != "na") {
                let date;
                if (s.sessionEnd == null) {
                  date = this.currentDate;
                }
                else {
                  date = s.sessionEnd;
                }
                let option = {
                  hAxis: {
                    minValue: new Date(s.sessionStart).setHours(0, 0, 0, 0),
                    maxValue: new Date(s.sessionEnd).setHours(23, 59, 59, 999),
                    format: 'd MMM',
                  },
                  timeline: {
                    singleColor: '#818db5', // Specify the default color for all rows
                    colors: ['#818db5', '#00FF00'], // Specify individual colors for each row
                  },
                  is3D: true,
                  //height: 400, 
                  //width: 800,  
                };

                let duration = "0";
                if (s.totalTime > 0) {
                  let hours = Math.floor(s.totalTime / 60);
                  let minutes = s.totalTime % 60;
                  duration = `${hours}:${minutes}`;
                }

                let node = '';
                if (this.showOnlyMachineName) {
                  node = s.node;
                }
                else if (this.showOnlyDuration) {
                  node = duration;
                }
                else if (this.showBothMachineAndTime) {
                  node = s.node + " (" + duration + " hrs)";
                }

                let userName = s.firstName + " " + s.lastName;

                if (this.showUserNameAndTotalHours) {
                  let individualTotalDuration = "0";
                  if (userTotalDuration[s.userName]) {
                    individualTotalDuration = userTotalDuration[s.userName];
                  }
                  userName = s.firstName + " " + s.lastName + " (" + individualTotalDuration + " hrs)";
                }

                if (new Date(s.sessionStart) < new Date(s.sessionEnd) || s.sessionEnd == null) {
                  this.timelineChartData.dataTable.push([
                    userName,
                    node,
                    new Date(s.sessionStart),
                    new Date(date)
                  ]);
                  this.timelineChartData.options = option;
                }
              }
            });

            this.chartHeight = String(window.innerHeight * 0.60);
            this.chartWidth = String(window.innerWidth * 0.80);

            if (this.chart && this.chart.wrapper) {
              this.chart.wrapper.draw();
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs")
            this.snackbar.open('No Data Available', 'Ok', { duration: 5000 });
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in getSessionDataPerUser: ", error);
    }

  }

  showDataLabelOptions() {
    if (
      ["StorageUsage", "JobDataCount", "CoresByApplication", "JobByTagsPerDay", 'JobByApplication', "RunningQueuedJobsPerNodeGroup"].includes(
        this.selectedMetric
      )
    ) {
      return true;
    }
    return false;
  }

  updateChartDataLabel() {
    this.charts.forEach((child) => {
      child.chart.update();
    });
    // this.chart?.update();
  }

  calculateMedian(numbers: number[]): number {
    const sortedNumbers = numbers.slice().sort((a, b) => a - b);
    const mid = Math.floor(sortedNumbers.length / 2);

    if (sortedNumbers.length % 2 === 0) {
      // Array has even number of elements, so median is the average of the two middlemost numbers
      return (sortedNumbers[mid - 1] + sortedNumbers[mid]) / 2;
    } else {
      // Array has odd number of elements, so median is the middlemost number
      return sortedNumbers[mid];
    }
  }

  updateResponsiveFlag(flag: boolean) {
    this.allJobsOptions.responsive = flag;
    this.jobsSummaryOptions.responsive = flag;
    this.coresPerDayOptions.responsive = flag;
    this.storageChartOptions.responsive = flag;
    this.jobCountChartOptions.responsive = flag;
    this.jobByApplicationOptions.responsive = flag;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    this.dataSource.sort = this.sort;
  }

  getColumnHeader(column: string): string {
    // You can customize the column headers here if needed.
    // For simplicity, we'll just use the column name as the header.
    return column.charAt(0).toUpperCase() + column.slice(1);
  }

  loadTabularData(data: any) {
    if (!data || this.availableChartTypes.length <= 1 || data.length < 1) return;
    if (data[0]?.jobStageStatus) {
      data.forEach(e => { e.jobStageStatus = this.statusMapping[e?.jobStageStatus] })
    };
    if (data[0]?.timeStamp) {
      data.forEach(e => { e.timeStamp = formatDate(new Date(e?.timeStamp), "dd/MM/yy hh:mm:ss a", "en-US") })
      data = data.reverse();
    }
    this.displayedColumns = ['#', ...Object.keys(data[0])];
    this.ELEMENT_DATA = data.map((item, index) => ({
      ...item,
      "#": index + 1,
    }));
    this.dataSource.data = this.ELEMENT_DATA;
  }

  manageActiveChartType() {
    let avlChartTypes = ["Table"];
    switch (this.selectedMetric) {
      case Graphs.CoreUsage:
      case Graphs.StorageUsage:
      case Graphs.JobDataCount:
      case Graphs.NodeAvailability:
        avlChartTypes.unshift("Line");
        break;

      case Graphs.JobByApplication:
      case Graphs.JobByNodes:
      case Graphs.JobByUser:
      case Graphs.JobByTags:
      case Graphs.CoresByApplication:
        avlChartTypes.unshift("Bar");
        break;

      case Graphs.CoreHoursByUsers:
      case Graphs.CoreHoursByGroups:
        avlChartTypes.unshift("Bar", "Pie");
        break;

      case Graphs.JobCompleted:
      case Graphs.JobSummary:
        avlChartTypes = ["Pie"];
        break;

      case Graphs.JobWaitTime:
      case Graphs.JobByGroup:
        avlChartTypes = ["Doughnut"];
        break;

      default:
        avlChartTypes = ["Bar"];
        break;
    }

    this.activeChartType = avlChartTypes[0].toLowerCase();
    this.availableChartTypes = avlChartTypes;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadCoreHoursByGroups(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      let gNames = this.graphFilterForm.value?.userGroupNames?.map(un => un.item_text);
      if (gNames.length == 0) {
        this.snackbar.open("Please select minimum 1 user group to proceed.", "Ok", { duration: 4000 });
        this.spinner.hide("loadingGraphs");
      }
      this.chartService.getCoreHoursByGroupsData(this.depName, this.dateFilterValue, gNames.join(",")).subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          this.coreHoursByGroupsPieData['datasets'][0].data = [];
          this.coreHoursByGroupsPieData['labels'] = [];
          this.coreHoursByGroupsChartData['datasets'][0].data = [];
          this.coreHoursByGroupsChartData['labels'] = [];
          this.loadTabularData(JSON.parse(JSON.stringify(data)));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(data, headers, `${Graphs.CoreHoursByGroups}-${this.depName}.csv`);
          }

          this.coreHoursByGroupsChartData['datasets'][0].backgroundColor = [];

          let coreHourByGroups = <CoreHoursByGroups[]>JSON.parse(JSON.stringify(data));
          coreHourByGroups = coreHourByGroups.sort((a, b) => b.totalCores - a.totalCores);
          let limit = 15;
          let Groups = coreHourByGroups.map((x, i) => { if (i < limit) return x.groupName });
          let colors = [];
          coreHourByGroups.forEach((job, i) => {
            if (i < limit) {
              this.coreHoursByGroupsChartData['datasets'][0].data.push(job.totalCores);
              this.coreHoursByGroupsPieData['datasets'][0].data.push(job.totalCores);
              this.coreHoursByGroupsChartData['labels'].push(job.groupName);
              this.coreHoursByGroupsPieData['labels'].push(job.groupName);
              colors.push(this.getDynamicColor());
            }
          });
          if (coreHourByGroups.length > limit) {
            this.coreHoursByGroupsChartData['datasets'][0].data.push(coreHourByGroups.slice(limit).reduce((acc, curr) => acc + curr.totalCores, 0));
            this.coreHoursByGroupsPieData['datasets'][0].data.push(coreHourByGroups.slice(limit).reduce((acc, curr) => acc + curr.totalCores, 0));
            this.coreHoursByGroupsChartData['labels'].push("Others");
            this.coreHoursByGroupsPieData['labels'].push("Others");
            colors.push(this.getDynamicColor());
          }

          this.coreHoursByGroupsChartData['datasets'][0].backgroundColor = "#0072c6";
          this.coreHoursByGroupsChartData['datasets'][0].borderColor = "#0072c6";
          this.coreHoursByGroupsChartData['datasets'][0].hoverBorderColor = "#0072c6";
          this.coreHoursByGroupsChartData['datasets'][0].hoverBackgroundColor = "#0072c6";

          this.coreHoursByGroupsPieColors = [{
            backgroundColor: colors
          }];

          this.coreHoursByGroupsChartOptions = {
            ...this.coreHoursByGroupsChartOptions,
            plugins: {
              ...this.coreHoursByGroupsChartOptions,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              }
            }
          };
          this.coreHoursByGroupsPieOptions = {
            ...this.coreHoursByGroupsPieOptions,
            plugins: {
              ...this.coreHoursByGroupsPieOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        }
      });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loadCoreHoursByGroups: ", error);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  public nodeStatusTimelineChartData: any = {
    chartType: 'Timeline',
    dataTable: [
      []
    ],
    options: {
      timeline: {
      }
    }
  }

  getNodeStatusGraph() {
    this.spinner.show("loadingGraphs")
    this.resetAllData();

    try {
      this.chartService
        .getNodeStatusGraphService(this.selectedUser, 'Connect-Disconnect', this.dateFilterValue, this.depName)
        .subscribe({
          next: (data: any) => {
            this.spinner.hide("loadingGraphs")
            this.nodeStatusTimelineChartData.dataTable = [];
            this.nodeStatusList = <NodeStartStopStatus[]>JSON.parse(JSON.stringify(data));

            if (!this.nodeStatusList) {
              this.snackbar.open('No Data Available', 'Ok', { duration: 5000 });
              return;
            }

            let dateFilter = this.dateFilterValue;
            let localthisDateFilterValue = this.dateFilterValue;
            if (this.dateFilterValue.indexOf('hr') != -1 || this.dateFilterValue.indexOf('days') != -1) {
              dateFilter = this.dateFilterValue.indexOf('hr') != -1 ? this.dateFilterValue.trim().slice(0, -2).trim() : this.dateFilterValue.trim().slice(0, -4).trim();
            }


            let format = 'd MMM';

            if (this.dateFilterValue?.toLowerCase()?.indexOf('to') != -1) {
              dateFilter = this.differenceInDays;
            }

            let filteredData;
            const userTotalDuration: { [key: string]: string } = {};

            if (Number.parseInt(dateFilter) != 1) {
              format = 'd MMM';
            }
            else {
              format = 'h:mm aa';
            }
            this.nodeStatusList.forEach((s) => {
              if (s.vmName.toLowerCase() != "na") {
                let date;
                if (s.updateTime == null) {
                  date = new Date(this.currentDate).setSeconds(new Date(this.currentDate).getSeconds() + 60);
                }
                else {
                  date = s.updateTime;
                }
                let option = {
                  hAxis: {
                    minValue: new Date(s.entryTime).setHours(0, 0, 0, 0),
                    maxValue: new Date(s.updateTime).setHours(23, 59, 59, 999),
                    format: format,
                  },
                  timeline: {
                    colors: ['#818db5', '#00FF00'], // Specify individual colors for each row
                  },
                  is3D: true,
                };

                let node = '';

                node = s.vmName;
                let status
                status = s.status;

                if (new Date(s.entryTime) < new Date(s.updateTime) || s.updateTime == null) {
                  this.nodeStatusTimelineChartData.dataTable.push([
                    node,
                    status,
                    new Date(s.entryTime),
                    new Date(date)
                  ]);
                  this.nodeStatusTimelineChartData.options = option;
                }
              }
            });

            this.chartHeight = String(window.innerHeight * 0.60);
            this.chartWidth = String(window.innerWidth * 0.80);

            if (this.chart && this.chart.wrapper) {
              this.chart.wrapper.draw();
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs")
            this.snackbar.open('No Data Available', 'Ok', { duration: 5000 });
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs")
      console.error('error in getNodeStatusGraph', error);
    }
    finally {
      //this.spinner.hide("loadingGraphs")
    }
  }

  getHpcUnitsConsumedGraph(toDownload?: boolean) {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    try {
      this.chartService.getHpcUnitsConsumed(this.depName, "HpcUnitsConsumed", this.dateFilterValue, this.granularityValue)
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.spinner.hide("loadingGraphs");
              this.hpcUnitsConsumedDataTotal.datasets[0].data = [];
              this.hpcUnitsConsumedDataTotal.labels = [];
              this.loadTabularData(JSON.parse(JSON.stringify(data)));

              let hpcUnitsConsumedData: any;

              hpcUnitsConsumedData = JSON.parse(JSON.stringify(data));
              hpcUnitsConsumedData = hpcUnitsConsumedData?.sort((a, b) => 0 - (b.deploymentName.toLowerCase() < a.deploymentName.toLowerCase() ? 1 : -1))
              hpcUnitsConsumedData = hpcUnitsConsumedData?.sort((a, b) => new Date(a?.entryTime)?.getTime() - new Date(b?.entryTime)?.getTime());

              if (toDownload) {
                let headers = Object.keys(data[0]);
                this.downloadCsv(hpcUnitsConsumedData, headers, `${Graphs.HpcUnitsConsumed}-${this.depName}.csv`);
                this.spinner.hide("loadingGraphs");
              }

              let dateFilter = this.dateFilterValue;
              if (
                this.dateFilterValue.indexOf("hr") != -1 ||
                this.dateFilterValue.indexOf("days") != -1
              ) {
                dateFilter =
                  this.dateFilterValue.indexOf("hr") != -1
                    ? this.dateFilterValue.trim().slice(0, -2).trim()
                    : this.dateFilterValue.trim().slice(0, -4).trim();
              }

              let uniqueDates;
              if (
                dateFilter != "1" &&
                (this.dateFilterValue.indexOf("days") != -1 ||
                  this.dateFilterValue.indexOf("to") != -1)
              ) {
                uniqueDates = [
                  ...new Set(
                    hpcUnitsConsumedData?.map(
                      (item) =>
                        formatDate(
                          new Date(item.entryTime),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0]
                    )
                  ),
                ];
              }
              else {
                uniqueDates = [
                  ...new Set(hpcUnitsConsumedData.map((item) => item.entryTime)),
                ];
              }

              //if (uniqueDates) {
              //  uniqueDates = uniqueDates?.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
              //}

              var filteredData = this.groupByNodes(hpcUnitsConsumedData, "entryTime");
              uniqueDates.forEach((unq) => {
                let date;
                if (
                  dateFilter != "1" &&
                  this.dateFilterValue.indexOf("days") != -1
                ) {
                  date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                    ","
                  )[0];
                }
                else if (this.dateFilterValue.indexOf("to") != -1) {
                  date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                    ","
                  )[0];
                }
                else {
                  date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                    ")"
                  )[0];
                }
                this.hpcUnitsConsumedDataTotal.labels.push(date);
              })

              const sortedKeys = Object.keys(filteredData)?.sort();

              sortedKeys?.forEach((key, idx) => {
                let units: any = 0;
                units = filteredData[key].reduce(
                  (accumulator, currentValue) => accumulator + currentValue.hpcUnitsUsed,
                  0
                );

                this.hpcUnitsConsumedDataTotal.datasets[0].data.push(units)
              });

              this.hpcUnitsConsumedOptions = {
                ...this.hpcUnitsConsumedOptions,
                plugins: {
                  ...this.hpcUnitsConsumedOptions.plugins,
                  title: {
                    display: true,
                    position: "top",
                    text: `HPC Units Consumed - ${this.dateFilterValue
                      .replace("to", " to ")
                      .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                      }`,
                  },
                  datalabels: {
                    display: true,
                    anchor: "end",
                    align: "top",
                  }
                },
              };
              this.updateGraphs();
            }
            else {
              this.spinner.hide("loadingGraphs");
              this.snackbar.open("No data found to visualize", "Ok", { duration: 3000 });
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            this.snackbar.open("No data found to visualize", "Ok", { duration: 3000 });
          }
        })
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error('error in getHpcUnitsConsumedGraph', error);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }

  }

  cpuUsageByNodes(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getCpuUsage(
          this.depName,
          this.dateFilterValue,
          true
        )
        .subscribe({
          next: (data) => {
            try {
              this.spinner.hide("loadingGraphs");
              this.cpuUsageByNodesChartData.datasets.forEach(d => d.data = []);
              this.cpuUsageByNodesChartData.labels = [];
              this.nodeUtilization = [];

              this.loadTabularData(JSON.parse(JSON.stringify(data)));

              let cpuUsageByNodesData = JSON.parse(JSON.stringify(data));
              var filteredData = this.groupByNodes(cpuUsageByNodesData, "nodeName");

              let totalCpuUsagePer: any = 0;
              let denomenator = 1;

              if (this.dateFilterValue == '1') {
                denomenator = 24
              }
              else if (this.dateFilterValue?.toString()?.indexOf('to') != -1) {
                //denomenator = 7
                denomenator = this.calculateDaysDifference(this.dateFilterValue);
                if (denomenator == null) {
                  denomenator = 7;
                }
                else if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }
              else {
                if (this.dateFilterValue?.toLowerCase().indexOf('days') != -1) {
                  denomenator = +this.dateFilterValue?.replace('days', '');
                }
                else if (this.dateFilterValue?.toLowerCase().indexOf('hr') != -1) {
                  denomenator = +this.dateFilterValue?.replace('hr', '');
                }

                if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }

              Object.keys(filteredData).forEach((key, idx) => {
                let totalJobsPerApp = filteredData[key].reduce(
                  (accumulator, currentValue) => accumulator + currentValue.cpuPercent,
                  0
                )

                if (filteredData[key]?.length) {
                  denomenator = filteredData[key]?.length;
                }

                this.cpuUsageByNodesChartData.datasets[0].data[idx] = 0;

                let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
                totalCpuUsagePer += averageCpuPer;

                this.cpuUsageByNodesChartData.datasets[0].data[idx] = averageCpuPer;

                this.cpuUsageByNodesChartData.labels.push(key + " : " + averageCpuPer + " %");
              });

              totalCpuUsagePer = totalCpuUsagePer / Object.keys(filteredData).length;
              totalCpuUsagePer = Number.isInteger(totalCpuUsagePer) ? totalCpuUsagePer : (totalCpuUsagePer).toFixed(2);

              if (toDownload) {
                let headers = ['Node', 'CPUPercent', 'Total'];
                let downloadData = this.createObjectArray(Object.keys(filteredData), this.cpuUsageByNodesChartData.datasets[0].data, totalCpuUsagePer);
                this.downloadCsv(downloadData, headers, `${Graphs.CpuUsageByNodes}-${this.depName}.csv`);
                this.spinner.hide("loadingGraphs");
              }

              this.cpuUsageByNodesChartData.datasets[0].data.push(totalCpuUsagePer);
              this.cpuUsageByNodesChartData.labels.push("Total " + totalCpuUsagePer + " %");

              this.cpuUsageByNodesChartOptions = {
                ...this.cpuUsageByNodesChartOptions,
                plugins: {
                  title: {
                    display: true,
                    position: "top",
                    text: `CPU Usage By Nodes - ${this.dateFilterValue.replace("to", " to ")}`,
                  },
                }
              };
              this.spinner.hide("loadingGraphs");
              this.chart?.update();
            }
            catch (error) {
              this.spinner.hide("loadingGraphs");
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error('error in cpuUsageByNodes', error);
    }
    finally {
      //this.spinner.hide("loadingGraphs");
    }
  }


  createObjectArray(keys: any[], values: any[], total): { name: string, percent: any, total: any }[] {
    if (keys.length !== values.length) {
      console.error('Arrays must have the same length');
      return [];
    }

    return keys.map((key, index) => ({ name: key, percent: values[index], total: total }));
  }

  cpuUsageByNodeGroups(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getCpuUsage(
          this.depName,
          this.dateFilterValue,
          false
        )
        .subscribe({
          next: (data) => {
            try {
              this.spinner.hide("loadingGraphs");
              this.cpuUsageByNodeGroupsChartData.datasets.forEach(d => d.data = []);
              this.cpuUsageByNodeGroupsChartData.labels = [];
              this.nodeUtilization = [];

              this.loadTabularData(JSON.parse(JSON.stringify(data)));
              let cpuUsageByNodesData = JSON.parse(JSON.stringify(data));

              var filteredData = this.groupByNodes(cpuUsageByNodesData, "nodeGroup");

              let totalCpuUsagePer: any = 0;

              let denomenator = 1;

              if (this.dateFilterValue == '1') {
                denomenator = 24
              }
              else if (this.dateFilterValue?.toString()?.indexOf('to') != -1) {
                //denomenator = 7
                denomenator = this.calculateDaysDifference(this.dateFilterValue);
                if (denomenator == null) {
                  denomenator = 7;
                }
                else if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }
              else {
                if (this.dateFilterValue?.toLowerCase().indexOf('days') != -1) {
                  denomenator = +this.dateFilterValue?.replace('days', '');
                }
                else if (this.dateFilterValue?.toLowerCase().indexOf('hr') != -1) {
                  denomenator = +this.dateFilterValue?.replace('hr', '');
                }

                if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }

              Object.keys(filteredData).forEach((key, idx) => {
                let totalJobsPerApp = filteredData[key].reduce(
                  (accumulator, currentValue) => accumulator + currentValue.cpuPercent,
                  0
                )

                if (filteredData[key]?.length) {
                  denomenator = filteredData[key]?.length;
                }

                let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
                totalCpuUsagePer += averageCpuPer;

                this.cpuUsageByNodeGroupsChartData.datasets[0].data[idx] = averageCpuPer;

                this.cpuUsageByNodeGroupsChartData.labels.push(key + " : " + averageCpuPer + " %");
              });

              totalCpuUsagePer = totalCpuUsagePer / Object.keys(filteredData).length;
              totalCpuUsagePer = Number.isInteger(totalCpuUsagePer) ? totalCpuUsagePer : (totalCpuUsagePer).toFixed(2);

              if (toDownload) {
                let headers = ['Node Group', 'Cpu Percent', 'Total'];
                let downloadData = this.createObjectArray(Object.keys(filteredData), this.cpuUsageByNodeGroupsChartData.datasets[0].data, totalCpuUsagePer);
                this.downloadCsv(downloadData, headers, `${Graphs.CpuUsageByNodeGroups}-${this.depName}.csv`);
                this.spinner.hide("loadingGraphs");
              }

              this.cpuUsageByNodeGroupsChartData.datasets[0].data.push(totalCpuUsagePer);
              this.cpuUsageByNodeGroupsChartData.labels.push("Total " + totalCpuUsagePer + " %");

              this.cpuUsageByNodeGroupsChartOptions = {
                ...this.cpuUsageByNodeGroupsChartOptions,
                plugins: {
                  title: {
                    display: true,
                    position: "top",
                    text: `CPU Usage By Node Groups - ${this.dateFilterValue.replace("to", " to ")}`,
                  },
                }
              };

              this.chart?.update();
            }
            catch (error) {
              this.spinner.hide("loadingGraphs");
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error('error in cpuUsageByNodeGroups', error);
    }
    finally {
      //this.spinner.hide("loadingGraphs");
    }
  }

  parseDate(dateStr: string): Date | null {
    const [day, month, year] = dateStr.split('-').map(Number);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return null;
    }
    return new Date(Date.UTC(2000 + year, month - 1, day)); // Months are zero-based
  }

  calculateDaysDifference(dateRange: string): number | null {
    const dateRegex = /^(\d{2}-\d{2}-\d{2})to(\d{2}-\d{2}-\d{2})$/;

    // Check if the input string matches the expected format
    const match = dateRange?.trim().match(dateRegex);
    if (!match) {
      console.error('Invalid date range format');
      return null;
    }

    const startDate = this.parseDate(match[1]);
    const endDate = this.parseDate(match[2]);

    if (!startDate || !endDate) {
      console.error('Invalid date format in date range');
      return null;
    }

    // Calculate the difference in milliseconds
    const timeDifference = endDate.getTime() - startDate.getTime();

    // Convert the difference to days
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    return Math.abs(daysDifference); // Taking absolute value to handle negative differences
  }

  coreUsageByNodes(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getCoreUsage(
          this.depName,
          this.dateFilterValue,
          true
        )
        .subscribe({
          next: (data) => {
            try {
              this.spinner.hide("loadingGraphs");
              this.coreUsageByNodesChartData.datasets.forEach(d => d.data = []);
              this.coreUsageByNodesChartData.labels = [];
              this.nodeUtilization = [];
              this.loadTabularData(JSON.parse(JSON.stringify(data)));
              let coreUsageByNodesData = JSON.parse(JSON.stringify(data));

              var filteredData = this.groupByNodes(coreUsageByNodesData, "nodeName");

              let totalCoreUsagePer: any = 0;
              let denomenator = 1;

              if (this.dateFilterValue == '1') {
                denomenator = 24
              }
              else if (this.dateFilterValue?.toString()?.indexOf('to') != -1) {
                //denomenator = 7
                denomenator = this.calculateDaysDifference(this.dateFilterValue);
                if (denomenator == null) {
                  denomenator = 7;
                }
                else if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }
              else {
                if (this.dateFilterValue?.toLowerCase().indexOf('days') != -1) {
                  denomenator = +this.dateFilterValue?.replace('days', '');
                }
                else if (this.dateFilterValue?.toLowerCase().indexOf('hr') != -1) {
                  denomenator = +this.dateFilterValue?.replace('hr', '');
                }

                if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }

              Object.keys(filteredData).forEach((key, idx) => {
                let totalJobsPerApp = filteredData[key].reduce(
                  (accumulator, currentValue) => accumulator + currentValue.coreUsagePercentage,
                  0
                )

                if (filteredData[key]?.length) {
                  denomenator = filteredData[key]?.length;
                }

                this.coreUsageByNodesChartData.datasets[0].data[idx] = 0;

                let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
                totalCoreUsagePer += averageCpuPer;

                this.coreUsageByNodesChartData.datasets[0].data[idx] = averageCpuPer;

                this.coreUsageByNodesChartData.labels.push(key + " : " + averageCpuPer + " %");
              });

              totalCoreUsagePer = totalCoreUsagePer / Object.keys(filteredData).length;
              totalCoreUsagePer = Number.isInteger(totalCoreUsagePer) ? totalCoreUsagePer : (totalCoreUsagePer).toFixed(2);

              if (toDownload) {
                let headers = ['Node', 'Core Usage', 'Total'];
                let downloadData = this.createObjectArray(Object.keys(filteredData), this.coreUsageByNodesChartData.datasets[0].data, totalCoreUsagePer);
                this.downloadCsv(downloadData, headers, `${Graphs.CoreUsageByNodes}-${this.depName}.csv`);
                this.spinner.hide("loadingGraphs");
              }

              this.coreUsageByNodesChartData.datasets[0].data.push(totalCoreUsagePer);
              this.coreUsageByNodesChartData.labels.push("Total " + totalCoreUsagePer + " %");

              this.coreUsageByNodesChartOptions = {
                ...this.coreUsageByNodesChartOptions,
                plugins: {
                  title: {
                    display: true,
                    position: "top",
                    text: `Core Usage By Nodes - ${this.dateFilterValue.replace("to", " to ")}`,
                  },
                }
              };
              this.chart?.update();
            }
            catch (error) {
              this.spinner.hide("loadingGraphs");
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error('error in coreUsageByNodes', error);
    }
    finally {
      //this.spinner.hide("loadingGraphs");
    }
  }

  coreUsageByNodeGroups(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getCoreUsage(
          this.depName,
          this.dateFilterValue,
          false
        )
        .subscribe({
          next: (data) => {
            try {
              this.spinner.hide("loadingGraphs");
              this.coreUsageByNodeGroupsChartData.datasets.forEach(d => d.data = []);
              this.coreUsageByNodeGroupsChartData.labels = [];
              this.nodeUtilization = [];

              this.loadTabularData(JSON.parse(JSON.stringify(data)));

              let coreUsageByNodesData = JSON.parse(JSON.stringify(data));

              var filteredData = this.groupByNodes(coreUsageByNodesData, "nodeGroup");

              let totalCoreUsagePer: any = 0;

              let denomenator = 1;

              if (this.dateFilterValue == '1') {
                denomenator = 24
              }
              else if (this.dateFilterValue?.toString()?.indexOf('to') != -1) {
                //denomenator = 7
                denomenator = this.calculateDaysDifference(this.dateFilterValue);
                if (denomenator == null) {
                  denomenator = 7;
                }
                else if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }
              else {
                if (this.dateFilterValue?.toLowerCase().indexOf('days') != -1) {
                  denomenator = +this.dateFilterValue?.replace('days', '');
                }
                else if (this.dateFilterValue?.toLowerCase().indexOf('hr') != -1) {
                  denomenator = +this.dateFilterValue?.replace('hr', '');
                }

                if (denomenator == 1 || denomenator == 0) {
                  denomenator = 24;
                }
              }

              Object.keys(filteredData).forEach((key, idx) => {
                let totalJobsPerApp = filteredData[key].reduce(
                  (accumulator, currentValue) => accumulator + currentValue.coreUsagePercentage,
                  0
                )

                if (filteredData[key]?.length) {
                  denomenator = filteredData[key]?.length;
                }

                let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
                totalCoreUsagePer += averageCpuPer;

                this.coreUsageByNodeGroupsChartData.datasets[0].data[idx] = averageCpuPer;

                this.coreUsageByNodeGroupsChartData.labels.push(key + " : " + averageCpuPer + " %");
              });

              totalCoreUsagePer = totalCoreUsagePer / Object.keys(filteredData).length;
              totalCoreUsagePer = Number.isInteger(totalCoreUsagePer) ? totalCoreUsagePer : (totalCoreUsagePer).toFixed(2);

              if (toDownload) {
                let headers = ['Node Group', 'Cpu Percent', 'Total'];
                let downloadData = this.createObjectArray(Object.keys(filteredData), this.coreUsageByNodeGroupsChartData.datasets[0].data, totalCoreUsagePer);
                this.downloadCsv(downloadData, headers, `${Graphs.CoreUsageByNodeGroups}-${this.depName}.csv`);
                this.spinner.hide("loadingGraphs");
              }

              this.coreUsageByNodeGroupsChartData.datasets[0].data.push(totalCoreUsagePer);
              this.coreUsageByNodeGroupsChartData.labels.push("Total " + totalCoreUsagePer + " %");

              this.coreUsageByNodeGroupsChartOptions = {
                ...this.coreUsageByNodeGroupsChartOptions,
                plugins: {
                  title: {
                    display: true,
                    position: "top",
                    text: `Core Usage By Node Groups - ${this.dateFilterValue.replace("to", " to ")}`,
                  },
                }
              };
              this.chart?.update();
            }
            catch (error) {
              this.spinner.hide("loadingGraphs");
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          }
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error('error in coreUsageByNodeGroups', error);
    }
    finally {
      //this.spinner.hide("loadingGraphs");
    }
  }

  loadAvgJobDurationsByDayData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getAvgJobDurationsByDayService(
          this.depName,
          this.dateFilterValue,
          this.granularityValue
        )
        .subscribe({
          next: (data) => {
            try {
              this.jobDurationsByDayData["datasets"].forEach((d) => (d.data = []));
              this.jobDurationsByDayData["labels"] = [];
              this.jobDurationsByDayData["datasets"].length = 4;
              let jobData = JSON.parse(JSON.stringify(data));
              if (toDownload) {
                let headers = Object.keys(data[0]);
                this.downloadCsv(
                  data,
                  headers,
                  `${Graphs.JobDurationsByDay}-${this.depName}.csv`
                );
                this.spinner.hide("loadingGraphs");
                return;
              }

              this.jobDurationsByDayData["labels"] = [];

              if (jobData) {
                jobData.forEach((x) => {
                  this.jobDurationsByDayData["datasets"][0].data.push(x?.totalRunTime);
                  this.jobDurationsByDayData["datasets"][1].data.push(x?.totalWaitTime);
                  this.jobDurationsByDayData["datasets"][2].data.push(x?.avgRunTime);
                  this.jobDurationsByDayData["datasets"][3].data.push(x?.avgWaitTime);

                  let date;
                  date = formatDate(new Date(x.timeStamp), "mediumDate", "en-US").split(
                    ","
                  )[0];
                  this.jobDurationsByDayData["labels"].push(date);
                })
                this.jobDurationsByDayData["datasets"][2].hidden = true;
                this.jobDurationsByDayData["datasets"][3].hidden = true;
              }

              if (this.jobDurationsByDayData["datasets"]) {
                this.jobDurationsByDayData["datasets"].forEach((dataset, index) => {
                  const avgData = new Array(this.jobDurationsByDayData["labels"]?.length).fill(
                    dataset.data?.map((d) => d)?.reduce((sum: any, current: any) => sum + current,
                      0) / dataset.data.length
                  );

                  this.jobDurationsByDayData["datasets"].push({
                    data: avgData,
                    type: 'line',
                    label: `${dataset.label} Mean`,
                    borderColor: this.jobDurationsByDayBarColors![index],
                    borderDash: [8, 10],
                    fill: false,
                    hidden: dataset.hidden,
                  });
                });
              }

              if (this.jobDurationsByDayOptions) {
                // Add plugin to update averages on visibility change
                this.jobDurationsByDayOptions!.plugins!.legend = {
                  ...this.jobDurationsByDayOptions!.plugins!.legend,
                  onClick: (event: ChartEvent, legendItem: any, legend: any) => {
                    const index = legendItem.datasetIndex;
                    const ci = legend.chart;
                    const meta = ci.getDatasetMeta(index);

                    // Toggle the visibility
                    meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

                    // If this is a main dataset, also toggle its average
                    const avgIndex = this.jobDurationsByDayData["datasets"]?.findIndex(
                      ds => ds.label == `${legendItem.text} Mean`
                    );
                    if (avgIndex !== -1) {
                      const avgMeta = ci.getDatasetMeta(avgIndex);
                      avgMeta.hidden = meta.hidden;
                    }

                    // Update the chart
                    ci.update();
                  }
                };
              }

              let showLabels = false;
              try {
                showLabels = this.dateFilterValue ? (parseInt(this.dateFilterValue.split(' ')[0].trim()) <= 15) : false;
              }
              catch (ex) {
                showLabels = false;
              }

              this.jobDurationsByDayOptions = {
                ...this.jobDurationsByDayOptions,
                plugins: {
                  ...this.jobDurationsByDayOptions.plugins,
                  title: {
                    display: true,
                    position: "top",
                    text: `Job Duration by day - ${this.dateFilterValue
                      .replace("to", " to ")
                      .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                      }`,
                  },
                  datalabels: {
                    formatter: Math.round,
                    display: (context) => {
                      if (showLabels) {
                        return (
                          +context.dataset.data[context.dataIndex] >
                          this.getDataLabelUsableValue(this.jobDurationsByDayData.datasets[0].data) &&
                          +context.dataset.data[context.dataIndex] >
                          this.getDataLabelUsableValue(this.jobDurationsByDayData.datasets[1].data)
                        );
                      }
                      else {
                        return false
                      }
                    },
                  }
                },
              };
              this.updateGraphs();
              this.spinner.hide("loadingGraphs");
            }
            catch (ex) {
              this.spinner.hide("loadingGraphs");
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          },
        });
    }
    catch (error) {
      this.spinner.hide("loadingGraphs");
      console.error('error in loadAvgJobDurationsByDayData', error);
    }
    finally {
      //this.spinner.hide("loadingGraphs");
    }

  }

  get tagsArray() {
    return this.graphDataLabelsForm.controls['jobByTagsPerDayForm'] as FormArray;
  }

  get appsArray() {
    return this.graphDataLabelsForm.controls['jobByApplicationPerDayForm'] as FormArray;
  }

  get getNodeGroupsArray() {
    return this.graphDataLabelsForm.controls['allNodeGroupsForm'] as FormArray;
  }

  tagChanged(value: boolean, index: number) {
    if (value) {
      // this will disable all values except checked one
      this.tagsArray.controls.forEach((control, i) => {
        if (i !== index) {
          control.disable();
        }
      });
      this.selectedJobTag = this.selectedJobTags[index].item_text;
      this.jobByTagsPerDayChartData["datasets"] = this.jobByTagsPerDayChartDataTemp["datasets"].filter((x) => x.label == this.selectedJobTag);
      this.jobByTagsPerDayChartOptions = {
        ...this.jobByTagsPerDayChartOptions,
        plugins: {
          ...this.jobByTagsPerDayChartOptions.plugins,
          datalabels: {
            display: true,
            anchor: "end",
            align: "end",
          }
        },
      };
      this.updateGraphs()
    } else {
      // This will enable all values
      this.tagsArray.controls.forEach((control) => {
        control.enable();
      });
      this.jobByTagsPerDayChartData["datasets"] = this.jobByTagsPerDayChartDataTemp["datasets"];
      let showLabels = true;
      if (this.jobByTagsPerDayChartData["datasets"].length > 3) {
        showLabels = false;
      }

      this.jobByTagsPerDayChartOptions = {
        ...this.jobByTagsPerDayChartOptions,
        plugins: {
          ...this.jobByTagsPerDayChartOptions.plugins,
          datalabels: {
            display: showLabels,
            anchor: "end",
            align: "end",
          }
        },
      };
      this.updateGraphs()
    }
  }


  loadJobByTagsPerDayData(toDownload?: boolean, index: number = -1) {
    this.spinner.show("loadingGraphs");
    this.resetAllData()

    try {
      let allTagNames = this.graphFilterForm.value?.jobTags?.map((gn) => gn.item_text);
      if (allTagNames?.length == 0) {
        this.snackbar.open("Please select minimum 1 tag to proceed.", "Ok", {
          duration: 4000,
        });
        this.spinner.hide("loadingGraphs");
        return;
      }
      this.selectedJobTags = this.graphFilterForm.value?.jobTags?.filter((gn) => gn.item_text);

      this.chartService
        .getJobByTagsPerDayData(
          this.depName,
          this.dateFilterValue,
          this.granularityValue,
          allTagNames?.toString()
        )
        .subscribe({
          next: (data) => {
            try {
              this.spinner.hide("loadingGraphs");
              this.jobByTagsPerDayChartData["datasets"] = [];
              this.jobByTagsPerDayChartData["labels"] = [];

              this.loadTabularData(JSON.parse(JSON.stringify(data)));

              let jobByTagsData: JobByTagsPerDayI[] = JSON.parse(JSON.stringify(data));
              if (toDownload) {
                let headers = Object.keys(data[0]);
                this.downloadCsv(
                  data,
                  headers,
                  `JobByNodeGroupByInterval-${this.depName}.csv`
                );
                this.spinner.hide("loadingGraphs");
              }
              var filteredData = this.groupByNodes(jobByTagsData, "timeStamp");

              allTagNames.forEach((name, index) => {
                if (index != allTagNames.length) {
                  this.jobByTagsPerDayChartData["datasets"].push({
                    data: [],
                    label: name,
                    order: 1,
                    fill: false,
                    radius: 3,
                    hoverBackgroundColor: "#0072c6",
                  })
                }
              })
              Object.keys(filteredData).forEach((key, idx) => {
                if (filteredData[key]) {
                  allTagNames.forEach((name, index) => {
                    const count = filteredData[key].filter(tag => tag.tag.toLowerCase() == name.toLowerCase()).map(x => x.totalCount)[0]
                    if (count) {
                      this.jobByTagsPerDayChartData["datasets"][index].data[idx] = count;
                    }
                    else {
                      this.jobByTagsPerDayChartData["datasets"][index].data[idx] = 0;
                    }
                  })
                }

                if (key) {
                  let date;
                  let dateFilter = this.dateFilterValue;
                  if (
                    dateFilter != "1" &&
                    (this.dateFilterValue.indexOf("days") != -1 ||
                      this.dateFilterValue.indexOf("to") != -1)
                  ) {
                    date = formatDate(new Date(key), "mediumDate", "en-US").split(
                      ","
                    )[0];
                  } else {
                    date = formatDate(new Date(key), "h:mm aa", "en-US").split(
                      ")"
                    )[0];
                  }
                  if (date) {
                    this.jobByTagsPerDayChartData["labels"].push(date);
                  }
                  else {
                    this.jobByTagsPerDayChartData["labels"].push(key);
                  }
                }
              });

              let showLabels = true;
              if (allTagNames.length > 3) {
                showLabels = false;
              }

              this.jobByTagsPerDayChartOptions = {
                ...this.jobByTagsPerDayChartOptions,
                plugins: {
                  ...this.jobByTagsPerDayChartOptions.plugins,
                  title: {
                    display: true,
                    position: "top",
                    text: `Job By Tags By Interval - ${this.dateFilterValue
                      .replace("to", " to ")
                      .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                      }`,
                  },
                  datalabels: {
                    display: showLabels,
                    anchor: "end",
                    align: "end",
                  }
                },
              };
              this.jobByTagsPerDayChartDataTemp = JSON.parse(JSON.stringify(this.jobByTagsPerDayChartData));
              this.updateGraphs();
            }
            catch (ex) {
              this.spinner.hide("loadingGraphs");
            }
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
          },
        });
    }
    catch (ex) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loadJobByTagsPerDayData: ", ex);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  onOptionClick(event: any) {
    this.snackbar.open('Please click on "Apply Filter" after selecting the option.');
    if (event !== 'custom') {
      this.dateFilterValue = event;
      this.showDateRangePicker = false;
    }
  }

  granularityChanged() {
    this.snackbar.open('Please click on "Apply Filter" after selecting the option.');
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  appsChanged(value: boolean, index: number) {
    if (value) {
      // this will disable all values except checked one
      this.appsArray.controls.forEach((control, i) => {
        if (i != index) {
          control.disable();
        }
      });
      let appNameSelected = this.applicationNames[index];
      this.jobByApplicationData["datasets"] = this.jobByApplicationsPerDayChartData["datasets"].filter((x) => x.label == appNameSelected);
      this.jobByApplicationData["labels"] = this.jobByApplicationsPerDayChartData["labels"];
      this.jobByApplicationOptions = {
        ...this.jobByApplicationOptions,
        scales: {
          ...this.jobByApplicationOptions.scales,
          x: {
            title: {
              display: true,
              text: "Date"
            }
          },
        },
        plugins: {
          ...this.jobByApplicationOptions.plugins,
          datalabels: {
            display: (context) => {
              return +context.dataset.data[context.dataIndex] > 10;
            },
          }
        },
      };
      this.updateGraphs()
    } else {
      // This will enable all values
      this.appsArray.controls.forEach((control) => {
        control.enable();
      });
      this.jobByApplicationData["datasets"] = this.jobByApplicationDataTemp["datasets"];
      this.jobByApplicationData["labels"] = this.jobByApplicationDataTemp["labels"];

      this.jobByApplicationOptions = {
        ...this.jobByApplicationOptions,
        scales: {
          ...this.jobByApplicationOptions.scales,
          x: {
            title: {
              display: true,
              text: "Applications"
            }
          },
        },
        plugins: {
          ...this.jobByApplicationOptions.plugins,
          datalabels: {
            display: (context) => {
              return +context.dataset.data[context.dataIndex] > 10;
            },
          }
        },
      };
      this.updateGraphs()
    }
  }

  loadRunningQueuedJobsPerNodeGroupsData(toDownload?: boolean, index: number = -1) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getRunningAndQueuedJobs(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          try {
            if (Object.keys(data).length === 0) {
              this.snackbar.open("No data available for the selected criteria", "Ok", { duration: 3000 });
              this.spinner.hide("loadingGraphs");
              return;
            }
            this.runningQueuedJobsPerNodeGroupChartData["datasets"] = [];
            this.runningQueuedJobsPerNodeGroupChartData["labels"] = [];

            this.loadTabularData(JSON.parse(JSON.stringify(data)));

            let jobData: RunningQueuedJobsPerNodeGroup[] = JSON.parse(JSON.stringify(data));

            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `JobByNodeGroupByInterval-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
            }

            let allTags = [];
            if (jobData) {
              const uniqueNamesSet = new Set(jobData.map(job => job.partitionName));
              allTags = Array.from(uniqueNamesSet);
            }

            var filteredData = this.groupByNodes(jobData, "entryTime");

            let dateFilter = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            if (allTags) {
              allTags.forEach((name, index) => {
                if (index != allTags.length) {

                  const customColor = this.getColorForPartition(name);
                  const lightenColor = this.lightenRGBString(customColor, 50);

                  this.runningQueuedJobsPerNodeGroupChartData["datasets"].push({
                    data: [],
                    label: name + " - Running",
                    order: 1,
                    fill: false,
                    radius: 3,
                    borderColor: customColor,
                    pointBackgroundColor: customColor
                  })
                  this.runningQueuedJobsPerNodeGroupChartData["datasets"].push({
                    data: [],
                    label: name + " - Queued",
                    order: 1,
                    fill: false,
                    radius: 3,
                    borderColor: lightenColor,
                    borderDash: [10, 5],
                    pointBackgroundColor: lightenColor,
                  })
                }
              })

              this.selectedNodeGroups = allTags;
              this.selectedNodeGroups?.forEach(() => this.getNodeGroupsArray.push(this.fb.control(false)));

              Object.keys(filteredData).forEach((key, idx) => {
                if (filteredData[key]) {
                  allTags.forEach((name, index) => {
                    const runCount = filteredData[key].filter(job => job.partitionName.toLowerCase() == name.toLowerCase()).map(x => x?.runningJobs)[0]
                    if (runCount) {
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][2 * index].data[idx] = runCount;
                    }
                    else {
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][2 * index].data[idx] = 0;
                    }

                    const queueCount = filteredData[key].filter(job => job.partitionName.toLowerCase() == name.toLowerCase()).map(x => x?.queuedJobs)[0]
                    if (queueCount) {
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][(2 * index) + 1]!.data[idx] = queueCount;
                    }
                    else {
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][(2 * index) + 1]!.data[idx] = 0;
                    }
                  })
                }

                if (key) {
                  let date;

                  if (
                    dateFilter != "1" &&
                    this.dateFilterValue.indexOf("days") != -1
                  ) {
                    date = formatDate(new Date(key), "mediumDate", "en-US").split(
                      ","
                    )[0];
                  }
                  else if (this.dateFilterValue.indexOf("to") != -1) {
                    date = formatDate(new Date(key), "mediumDate", "en-US").split(
                      ","
                    )[0];
                  }
                  else {
                    date = formatDate(new Date(key), "h:mm aa", "en-US").split(
                      ")"
                    )[0];
                  }

                  if (date) {
                    this.runningQueuedJobsPerNodeGroupChartData["labels"].push(date);
                  }
                  else {
                    this.runningQueuedJobsPerNodeGroupChartData["labels"].push(key);
                  }
                }
              });

              this.runningQueuedJobsPerNodeGroupChartOptions = {
                ...this.runningQueuedJobsPerNodeGroupChartOptions,
                plugins: {
                  ...this.runningQueuedJobsPerNodeGroupChartOptions.plugins,
                  title: {
                    display: true,
                    position: "top",
                    text: `Job By Node Group By Interval - ${this.dateFilterValue
                      .replace("to", " to ")
                      .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                      }`,
                  },
                  datalabels: {
                    display: false
                  }
                },
              };
              this.runningQueuedJobsPerNodeGroupDataTemp = JSON.parse(JSON.stringify(this.runningQueuedJobsPerNodeGroupChartData));
              this.updateGraphs();
              this.spinner.hide("loadingGraphs");
            }

          }
          catch (ex) {
            this.snackbar.open("Some error occurred !", "Ok", { duration: 3000 })
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.snackbar.open("Some error occurred !", "Ok", { duration: 3000 })
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  getColorForPartition(partitionName) {
    const hash = partitionName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const r = (hash * 97) % 255;
    const g = (hash * 43) % 255;
    const b = (hash * 67) % 255;
    return `rgb(${r}, ${g}, ${b})`;
  }

  lightenRGBString(rgbString: string, percent: number): string {
    // Extract the RGB values from the string using a regular expression
    const regex = /rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)/;
    const result = regex.exec(rgbString);

    if (!result) {
      return rgbString;
    }

    // Convert extracted strings to numbers
    const r = parseInt(result[1], 10);
    const g = parseInt(result[2], 10);
    const b = parseInt(result[3], 10);

    // Ensure percent is within valid range
    const p = Math.min(100, Math.max(0, percent)) / 100;

    // Calculate the lighter RGB values
    const newR = Math.round(r + (255 - r) * p);
    const newG = Math.round(g + (255 - g) * p);
    const newB = Math.round(b + (255 - b) * p);

    // Return the lighter RGB color as a string
    return `rgb(${newR}, ${newG}, ${newB})`;
  }

  getPrimeNonPrimeHoursJobSubmissions(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService
        .getPrimeNonPrimeJobCount(
          this.depName,
          this.dateFilterValue,
          this.granularityValue
        )
        .subscribe({
          next: (data) => {
            try {
              this.spinner.hide("loadingGraphs");
              let jobsData = <PrimeNonPrimeHoursJobs[]>JSON.parse(JSON.stringify(data));

              if (toDownload) {
                let headers = Object.keys(data[0]);
                this.downloadCsv(
                  data,
                  headers,
                  `JobByWorkingHours-${this.depName}.csv`
                );

              }

              let dateFilter = this.dateFilterValue;
              if (
                this.dateFilterValue.indexOf("hr") != -1 ||
                this.dateFilterValue.indexOf("days") != -1
              ) {
                dateFilter =
                  this.dateFilterValue.indexOf("hr") != -1
                    ? this.dateFilterValue.trim().slice(0, -2).trim()
                    : this.dateFilterValue.trim().slice(0, -4).trim();
              }

              let uniqueDates;
              if (
                dateFilter != "1" &&
                (this.dateFilterValue.indexOf("days") != -1 ||
                  this.dateFilterValue.indexOf("to") != -1)
              ) {
                uniqueDates = [
                  ...new Set(
                    jobsData?.map(
                      (item) =>
                        formatDate(
                          new Date(item.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0]
                    )
                  ),
                ];
              }
              else {
                uniqueDates = [
                  ...new Set(jobsData.map((item) => item.timeStamp)),
                ];
              }

              uniqueDates.forEach((unq) => {
                let date;
                if (
                  dateFilter != "1" &&
                  this.dateFilterValue.indexOf("days") != -1
                ) {
                  date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                    ","
                  )[0];
                }
                else if (this.dateFilterValue.indexOf("to") != -1) {
                  date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                    ","
                  )[0];
                }
                else {
                  date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                    ")"
                  )[0];
                }
                this.primeNonPrimeHoursJobsSubmissionData.labels.push(date);
              });

              jobsData.forEach((x) => {
                this.primeNonPrimeHoursJobsSubmissionData.datasets[0].data.push(x.officeHoursJobSubmits);
                this.primeNonPrimeHoursJobsSubmissionData.datasets[1].data.push(x.nonOfficeHoursJobSubmits);
              });

              this.primeNonPrimeHoursJobsSubmissionOptions = {
                ...this.primeNonPrimeHoursJobsSubmissionOptions,
                plugins: {
                  ...this.primeNonPrimeHoursJobsSubmissionOptions.plugins,
                  title: {
                    display: true,
                    position: "top",
                    text: `Job Submit Count By Working Hours - ${this.dateFilterValue
                      .replace("to", " to ")
                      .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                      }`,
                  },
                  datalabels: {
                    display: true,
                    anchor: "end",
                    align: "top",
                  }
                },
              };

              this.updateGraphs();
            }
            catch (ex) {
              this.snackbar.open("Some error occurred !", "Ok", { duration: 3000 })
              this.spinner.hide("loadingGraphs");
            }
          },
          error: (err) => {
            this.snackbar.open("Some error occurred !", "Ok", { duration: 3000 })
            this.spinner.hide("loadingGraphs");
          },
        });
    }
    catch (ex) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loading graphs", ex);
    }
    finally {
      // this.spinner.hide("loadingGraphs");
    }
  }

  getJobsByUserByDay(toDownload: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    try {
      this.chartService.getJobsByUserByDay(
        this.depName,
        this.dateFilterValue,
        this.granularityValue,
        this.userFilterValue
      ).subscribe(
        {
          next: (data) => {
            this.jobsByUserByDayData.datasets[0].data = [];
            this.jobsByUserByDayData.datasets[1].data = [];
            this.jobsByUserByDayData.datasets[2].data = [];
            this.jobsByUserByDayData.labels = [];
            this.spinner.hide("loadingGraphs");
            data = <JobsByUserByDay>JSON.parse(JSON.stringify(data));
            this.spinner.hide("loadingGraphs");

            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `JobByUserByDay-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
            }

            const jobsByUserByDay: JobsByUserByDay[] = Array.isArray(data) ? data : [data];

            jobsByUserByDay.forEach(job => {
              this.jobsByUserByDayData.datasets[0].data.push(job.countPerDay);
              this.jobsByUserByDayData.datasets[1].data.push(job.countPerNight);
              this.jobsByUserByDayData.datasets[2].data.push(job.totalCount);
              this.jobsByUserByDayData.labels.push(new Date(job.creationDate.split('T')[0]).toLocaleDateString('en-US', this.granularityValue == 'One Month' ? { month: 'short' } : { month: 'short', day: 'numeric' }));
            });

            this.jobsByUserByDayOptions = {
              ...this.jobsByUserByDayOptions,
              plugins: {
                ...this.jobsByUserByDayOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job By User ( ${this.userFilterValue == 'none' ? this.loggedInUser : this.userFilterValue} ) By Day - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                },
                datalabels: {
                  display: (context) => {
                    return +context.dataset.data[context.dataIndex] > 0;
                  },
                  anchor: "end",
                  align: "top",
                }
              },
            };
            this.updateGraphs();
          },
          error: (err) => {
            this.spinner.hide("loadingGraphs");
            console.error(err);
          }
        }
      );
    }
    catch (ex) {
      this.spinner.hide("loadingGraphs");
      console.error("Error in loading graphs", ex);
    }
    finally {
      this.spinner.hide("loadingGraphs");
    }

  }

  nodeGroupChanged(value: boolean, index: number, nodeGroup: string) {
    if (value) {
      // this will disable all values except checked one
      this.getNodeGroupsArray.controls.forEach((control, i) => {
        if (i !== index) {
          control.disable();
        }
      });
      this.runningQueuedJobsPerNodeGroupChartData["datasets"] = this.runningQueuedJobsPerNodeGroupDataTemp["datasets"].filter((x) => x.label == nodeGroup + " - Running" || x.label == nodeGroup + " - Queued");
      this.runningQueuedJobsPerNodeGroupChartOptions = {
        ...this.runningQueuedJobsPerNodeGroupChartOptions,
        plugins: {
          ...this.runningQueuedJobsPerNodeGroupChartOptions.plugins,
          datalabels: {
            display: true,
            anchor: "end",
            align: "end",
          }
        },
      };
      this.updateGraphs()
    } else {
      // This will enable all values
      this.getNodeGroupsArray.controls.forEach((control) => {
        control.enable();
      });
      this.runningQueuedJobsPerNodeGroupChartData["datasets"] = this.runningQueuedJobsPerNodeGroupDataTemp["datasets"];
      let showLabels = true;

      this.runningQueuedJobsPerNodeGroupChartOptions = {
        ...this.runningQueuedJobsPerNodeGroupChartOptions,
        plugins: {
          ...this.runningQueuedJobsPerNodeGroupChartOptions.plugins,
          datalabels: {
            display: false,
          }
        },
      };
      this.updateGraphs()
    }
  }

  async handleControlClick(control: DynamicControl) {
    try {
      this.spinner.show("downloadingFile");
      await this.chartService.getJobRunQueueDurationAsCSV(
        this.depName,
        this.dateFilterValue,
        control['text']?.replace(/\s+/g, ''),
        control['key']
      ).toPromise();
    } catch (error) {
      this.spinner.hide("downloadingFile");
    } finally {
      this.spinner.hide("downloadingFile");
    }
  }

  loadDynamicControls() {
    this.chartService.getAvailableDynamicControlsData(this.loggedInUser, this.depName)
      .subscribe({
        next: (controls: DynamicControl[]) => {
          this.dynamicControls = controls;
        },
        error: (err) => {
          console.error('Failed to load controls:', err);
          this.dynamicControls = []; // Fallback empty array
        }
      });
  }

  calculateDynamicMax(datasets: any[]): number {
    let maxValue = 0;

    if (datasets && datasets.length > 0 && datasets != null) {
      datasets.forEach(dataset => {
        if (dataset.data && dataset.data.length > 0) {
          const datasetMax = Math.max(...dataset.data);
          if (datasetMax > maxValue) {
            maxValue = datasetMax;
          }
        }
      });
    }
    else {
      maxValue = 100;
    }

    maxValue = maxValue == 0 ? 10 : maxValue;

    // Round up to nearest 10
    return Math.ceil(maxValue / 10) * 10;
  }

}
